import React, { useState, useEffect, useRef, useCallback } from 'react';
import LiveKitMeeting from '../components/LiveKitMeeting';
import { ConsoleShell, useConsoleTheme } from '../components/Console';
import { SCREEN_LABELS, usePresenceContext } from '../hooks/usePresence';
import { supabase } from '../supabaseClient';

const F = 'system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif';
const LIVEKIT_URL = process.env.REACT_APP_LIVEKIT_URL || '';
const GIPHY_KEY = process.env.REACT_APP_GIPHY_KEY || '9kVwIl8Un0NHc8y7azEmgvcXLpz4h1hk';

// Twemoji helper — converts emoji char to CDN SVG URL
function twUrl(emoji) {
  const cp = [...emoji]
    .map(c => c.codePointAt(0).toString(16))
    .filter(c => c !== 'fe0f' && c !== '20e3');
  return 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/' + cp.join('-') + '.svg';
}
// Twemoji img component
function Tw({ e, size = 20, style = {} }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return (
    <img
      src={twUrl(e)}
      alt={e}
      draggable={false}
      style={{ width: size, height: size, display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }}
    />
  );
}
// Sanoire custom reaction — seafoam fingerprint-S icon
const SANOIRE_RX = '__sanoire__';
const SANOIRE_ICON_B64 = 'data:image/svg+xml;base64,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';
function SanoireIcon({ size = 20 }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return (
    <img src={SANOIRE_ICON_B64} alt='sanoire' draggable={false}
      style={{ width: size, height: size, display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, opacity: 0.85 }}
    />
  );
}

const TEAM_COLORS = [
  { color: '#314F5C', text: '#AFE1F6' }, { color: '#819D84', text: '#fff' },
  { color: '#B99C6D', text: '#fff' },    { color: '#6F8FA7', text: '#fff' },
  { color: '#204C2C', text: '#fff' },    { color: '#9F7E4F', text: '#fff' },
];
function makeTeamMember(user, idx) {
  const parts = (user.email || '').split('@')[0].split(/[._-]/);
  const name = parts.map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(' ');
  const initials = parts.map(p => p[0]?.toUpperCase()).join('').slice(0, 2) || '??';
  return { id: user.id, initials, name, email: user.email, ...TEAM_COLORS[idx % TEAM_COLORS.length], online: false };
}
let TEAM = []; // populated from team_members table on mount

let CHANNELS = []; // populated from dispatch_channels table on mount

const SEED = {}; // no hardcoded seed — messages load from Supabase

const STATUS_CFG = {
  open:        { bg: '#fef3c7', color: '#92400e', label: 'Open' },
  in_progress: { bg: '#dbeafe', color: '#1e40af', label: 'In progress' },
  resolved:    { bg: '#d1fae5', color: '#065f46', label: 'Resolved' },
};

const QUICK_REPLIES = [
  { label: 'Acknowledge', text: 'Hi! Thanks for reaching out to Sanoire support. I can see your request and will look into this right away.' },
  { label: 'Looking into it', text: "I'm investigating this now and will get back to you shortly. Thanks for your patience." },
  { label: 'Resolved', text: "Great news — I've resolved the issue on our end. Please let me know if you experience anything further. Travel with confidence! 🌍" },
  { label: 'More info', text: 'Could you provide a bit more detail? Specifically — which device and app version are you using, and which location were you searching for?' },
];

const EMOJI_GROUPS = [
  { label: 'Reactions', emojis: ['👍','👎','❤️','🔥','✅','👀','😂','🎉','🙌','💯','🚀','⭐','😍','🤩','💪','🫡','🥹','😮','🤯','💀','🫶','🏆'] },
  { label: 'Faces',     emojis: ['😀','😃','😄','😁','😆','😅','🤣','😂','🙂','😉','😊','😇','🥰','😍','🤩','😘','😗','😚','😋','😛','🤪','😝','🤑','🤗','🫡','🤔','🫠','🤐','😐','😶','😏','😒','🙄','😬','🤥','😌','😔','😪','🤤','😴','😷','🤒','🤕','🥴','🥳','🥺','😭','😢','😤','😠','😡','🤬','😈'] },
  { label: 'Objects',   emojis: ['📊','📈','📉','💻','📱','🖥','⌨️','🖱','🖨','📷','📸','📹','🎥','📞','☎️','📟','📠','📺','📻','🧭','⏱','⏰','🕰','⌛','📡','🔋','💡','🔦','🕯','🪔','💰','💳','💎','🔑','🗝','🔐','🔒','🔓','🔨','🪛','🔧','🪚','⚙️','🗜','🔩','🧲','🪜','🧯','🛒'] },
  { label: 'Nature',    emojis: ['🌍','🌎','🌏','🌐','🗺','🌋','🏔','⛰','🌁','🏝','🏖','🌊','🌈','⚡','❄️','🔥','💧','🌊','🌀','🌤','⛅','🌥','☁️','🌦','🌧','⛈','🌩','🌨','❄️','☃️','⛄','🌬','🍀','🌿','🌱','🌲','🌳','🌴','🌵','🍁','🍂','🌾','🌺','🌸','🌼','🌻','🌹','🌷','💐'] },
  { label: 'Activity',  emojis: ['⚽','🏀','🏈','⚾','🥎','🎾','🏐','🏉','🎱','🏓','🏸','🥊','🥋','🎯','⛳','🏹','🎣','🤿','🎽','🛹','🛼','🛷','⛸','🥌','🎿','⛷','🏂','🏋️','🤼','🤸','⛹️','🤺','🏇','🧘','🏄','🚣','🧗','🚵','🚴','🏆','🥇','🥈','🥉','🎖','🏅','🎗','🎫','🎟','🎪'] },
  { label: 'Travel',    emojis: ['🚗','🚕','🚙','🚌','🚎','🏎','🚓','🚑','🚒','🚐','🛻','🚚','🚛','🚜','🛵','🏍','🛺','🚲','🛴','🛹','🛼','🚏','🛣','🛤','✈️','🛫','🛬','🛩','💺','🚁','🛸','🚀','⛵','🚤','🛥','🛳','⛴','🚢','⚓','🗺','🗼','🏰','🏯','🗽','⛪','🕌','🛕','🕍','🏟','🏗'] },
  { label: 'Food',      emojis: ['🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🫐','🍈','🍒','🍑','🥭','🍍','🥥','🥝','🍅','🫒','🥑','🍆','🥦','🥬','🥒','🌶','🫑','🧄','🧅','🥔','🍠','🫘','🌽','🥕','🍞','🥐','🧀','🥚','🍳','🥞','🧇','🥓','🌭','🍔','🍟','🍕','🌮','🌯','🫔','🧆','🥙'] },
  { label: 'Symbols',   emojis: ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖','💘','💝','✨','⭐','🌟','💫','⚡','🔥','💥','❄️','🌊','🎵','🎶','🎼','🎤','🎧','🎷','🎸','🎹','🥁','🎺','🎻','🪕','🎮','🕹','🎲','♟','🎭','🎨','🖼','🎰','🚩','🏁','🎌','🏴','🏳️'] },
];


// ── VideoPanel ────────────────────────────────────────────────────────────

function ShareRow({ icon, bg, label, action, last }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return (
    <div style={{ padding: '9px 14px', borderBottom: last ? 'none' : '1px solid #f4f6f8', display: 'flex', alignItems: 'center', gap: 10 }}>
      <div style={{ width: 30, height: 30, borderRadius: 8, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{icon}</div>
      <div style={{ flex: 1, fontSize: '.72rem', color: '#314F5C', overflow: 'hidden' }}>{label}</div>
      {action}
    </div>
  );
}

function VideoPanel({ isMobile, me, videoActive, videoRoomUrl, videoRoomName,
  videoRecording, videoLoading, videoError, videoTab, setVideoTab,
  setVideoRoomUrl, setVideoActive,
  videoTranscript, setVideoTranscript, videoMsgInput, setVideoMsgInput,
  videoSessions, videoMsgsRef, startCall, endCall, startRecording, newRoom,
  sendShareToChannel, onlineUsers, teamMembers, chMsgs, setChMsgs,
  supabase, loadSessions, inviteToCall, meetingToken, videoSessionId }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const [sessFilter,     setSessFilter]     = React.useState('all');
  const [editingSession, setEditingSession] = React.useState(null);
  const [deleteConfirm,  setDeleteConfirm]  = React.useState(null);
  const [shareOpen,   setShareOpen]   = React.useState(false);
  const [shareCopied, setShareCopied] = React.useState(false);
  const [shareChannel, setShareChannel] = React.useState('general');
  const [joinUrl, setJoinUrl] = React.useState('');
  const [joinCopied, setJoinCopied] = React.useState(false);
  const [schedulePosted, setSchedulePosted] = React.useState(false);
  const [inviteOpen, setInviteOpen] = React.useState(false);
  const [inviteQuery, setInviteQuery] = React.useState('');
  const [inviteSent, setInviteSent] = React.useState({});
  const meetingLink = 'https://admin.sanoire.com?room=' + encodeURIComponent(videoRoomName);

  function fmtDur(secs) {
    if (!secs) return '—';
    const m = Math.floor(secs / 60), s = secs % 60;
    return m + ':' + String(s).padStart(2, '0');
  }
  function fmtDate(ts) {
    if (!ts) return '—';
    return new Date(ts).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  }

  // ── Tab bar ──────────────────────────────────────────────────────────────
  const tabBar = (
    <div style={{ display: 'flex', borderBottom: `1px solid ${t.bd}`, background: t.panel, flexShrink: 0 }}>
      {['call', 'sessions'].map(t => (
        <button key={t} onClick={() => setVideoTab(t)} style={{
          flex: 1, padding: '9px 0', background: 'none', border: 'none',
          borderBottom: videoTab === t ? '2px solid #314F5C' : '2px solid transparent',
          fontSize: '.72rem', fontWeight: videoTab === t ? 600 : 400,
          color: videoTab === t ? '#314F5C' : '#9eb8c8',
          cursor: 'pointer', fontFamily: F, transition: 'color .15s',
        }}>
          {t === 'call' ? (
            <span style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: 'center' }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 10l4.553-2.069A1 1 0 0121 8.82v6.36a1 1 0 01-1.447.89L15 14"/><rect x="1" y="6" width="14" height="12" rx="3"/></svg>
              Call
            </span>
          ) : (
            <span style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: 'center' }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Sessions
            </span>
          )}
        </button>
      ))}
    </div>
  );

  // ── Sessions tab ─────────────────────────────────────────────────────────
  if (videoTab === 'sessions') {
    function ctxLabel(s) {
      if (!s.room_name) return '';
      if (s.room_name.startsWith('sanoire-ch-')) return '# ' + s.room_name.replace('sanoire-ch-', '');
      if (s.room_name.startsWith('sanoire-dm-')) return 'DM · ' + s.room_name.replace('sanoire-dm-', '').toUpperCase();
      if (s.room_name.startsWith('sanoire-team-')) return 'Team Room';
      return s.room_name;
    }

    const filtered = videoSessions.filter(s => {
      if (sessFilter === 'audio') return s.session_type === 'audio';
      if (sessFilter === 'video') return s.session_type === 'video';
      if (sessFilter === 'active') return s.status === 'active';
      return true;
    });

    async function endSession(s) {
      if (!supabase) return;
      await supabase.from('call_video_sessions')
        .update({ status: 'ended', ended_at: new Date().toISOString() })
        .eq('id', s.id);
      if (loadSessions) loadSessions();
    }

    async function deleteSession(id) {
      if (!supabase) return;
      await supabase.from('call_video_sessions').delete().eq('id', id);
      setDeleteConfirm(null);
      if (loadSessions) loadSessions();
    }

    async function saveEdit() {
      if (!supabase || !editingSession) return;
      await supabase.from('call_video_sessions')
        .update({ status: editingSession.status, notes: editingSession.note })
        .eq('id', editingSession.id);
      setEditingSession(null);
      if (loadSessions) loadSessions();
    }

    const activeCt = videoSessions.filter(s => s.status === 'active').length;

    return (
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        {tabBar}
        {/* Filter bar */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '10px 16px 0', background: '#f0f7fb', flexShrink: 0 }}>
          {[['all','All'],['active','Active'],['audio','Audio'],['video','Video']].map(([k,lbl]) => {
            const isActive = sessFilter === k;
            const showBadge = k === 'active' && activeCt > 0;
            return (
              <button key={k} onClick={() => setSessFilter(k)} style={{
                padding: '4px 11px', borderRadius: 99, border: 'none', cursor: 'pointer', fontFamily: F,
                fontSize: '.68rem', fontWeight: isActive ? 600 : 400,
                background: isActive ? '#314F5C' : 'rgba(49,79,92,0.07)',
                color: isActive ? '#E0F5FC' : '#5a7a8a',
                display: 'flex', alignItems: 'center', gap: 5, transition: 'all .12s',
              }}>
                {lbl}
                {showBadge && <span style={{ width: 6, height: 6, borderRadius: '50%', background: isActive ? '#AFE1F6' : '#c62828', display: 'inline-block' }} />}
              </button>
            );
          })}
          <div style={{ flex: 1 }} />
          <button onClick={() => loadSessions && loadSessions()} title="Refresh" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9eb8c8', display: 'flex', alignItems: 'center', padding: 4, borderRadius: 6 }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.1"/></svg>
          </button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '12px 16px 20px', background: '#f0f7fb' }}>
          {filtered.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '52px 24px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
              <div style={{ width: 48, height: 48, borderRadius: 14, background: '#e8f0f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='#9eb8c8' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'><path d='M15 10l4.553-2.069A1 1 0 0121 8.82v6.36a1 1 0 01-1.447.89L15 14'/><rect x='1' y='6' width='14' height='12' rx='3'/></svg>
              </div>
              <div style={{ fontSize: '.82rem', fontWeight: 600, color: '#314F5C' }}>{sessFilter === 'all' ? 'No sessions yet' : 'No ' + sessFilter + ' sessions'}</div>
              <div style={{ fontSize: '.72rem', color: '#9eb8c8', lineHeight: 1.6, maxWidth: 220 }}>Start a call to begin logging sessions. All call details will appear here.</div>
              {sessFilter === 'all' && (
                <button onClick={startCall} disabled={videoLoading} style={{ marginTop: 4, padding: '8px 20px', background: t.accent, color: '#E0F5FC', border: 'none', borderRadius: 9, fontSize: '.76rem', fontWeight: 600, cursor: 'pointer', fontFamily: F, display: 'flex', alignItems: 'center', gap: 6 }}>
                  <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.2' strokeLinecap='round'><path d='M15 10l4.553-2.069A1 1 0 0121 8.82v6.36a1 1 0 01-1.447.89L15 14'/><rect x='1' y='6' width='14' height='12' rx='3'/></svg>
                  Start a call
                </button>
              )}
            </div>
          ) : filtered.map(s => {
            const isActive = s.status === 'active';
            const isEditing = editingSession?.id === s.id;
            const isDeleteConfirm = deleteConfirm === s.id;
            const ctx = ctxLabel(s);
            const startD = s.started_at ? new Date(s.started_at) : null;
            const endD = s.ended_at ? new Date(s.ended_at) : null;
            const fmtTs = d => d ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) + ' · ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '—';
            const durStr = s.duration_secs ? Math.floor(s.duration_secs / 60) + 'm ' + (s.duration_secs % 60) + 's' : (isActive ? 'In progress' : '—');
            const participants = Array.isArray(s.participants) ? s.participants : [];

            return (
              <div key={s.id} style={{ background: t.panel, border: '1px solid ' + (isActive ? 'rgba(45,160,106,0.3)' : '#e8eef2'), borderRadius: 12, marginBottom: 10, overflow: 'hidden', boxShadow: isActive ? '0 0 0 2px rgba(45,160,106,0.08)' : '0 1px 3px rgba(0,0,0,0.04)' }}>
                {/* Card header */}
                <div style={{ padding: '12px 14px 10px', borderBottom: `1px solid ${t.bd}`, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 10 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 7, flexWrap: 'wrap', flex: 1, minWidth: 0 }}>
                    {/* Type badge */}
                    <span style={{ fontSize: '.58rem', fontWeight: 700, padding: '2px 7px', borderRadius: 99, flexShrink: 0,
                      background: s.session_type === 'video' ? '#e8f5f0' : '#e8f0fb',
                      color: s.session_type === 'video' ? '#1a7a5a' : '#314F5C' }}>
                      {s.session_type === 'video' ? 'VIDEO' : 'AUDIO'}
                    </span>
                    {/* Context */}
                    {ctx && <span style={{ fontSize: '.72rem', fontWeight: 600, color: '#314F5C', background: 'rgba(49,79,92,0.06)', padding: '2px 8px', borderRadius: 6, flexShrink: 0 }}>{ctx}</span>}
                    {/* Status */}
                    <span style={{ fontSize: '.58rem', fontWeight: 700, padding: '2px 8px', borderRadius: 99, flexShrink: 0,
                      background: isActive ? 'rgba(45,160,106,0.12)' : s.status === 'recorded' ? '#e8f5e9' : '#f0f4f6',
                      color: isActive ? '#1a7a5a' : s.status === 'recorded' ? '#1b5e20' : '#5a7a8a',
                      display: 'flex', alignItems: 'center', gap: 4 }}>
                      {isActive && <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#2da06a', display: 'inline-block', animation: 'sanoirePulse 2s ease-in-out infinite' }} />}
                      {isActive ? 'Live' : s.status === 'recorded' ? 'Recorded' : 'Ended'}
                    </span>
                  </div>
                  {/* Actions */}
                  <div style={{ display: 'flex', gap: 5, flexShrink: 0 }}>
                    {isActive && (
                      <button onClick={() => endSession(s)} title="End session" style={{ fontSize: '.65rem', fontWeight: 600, padding: '4px 10px', background: '#c62828', color: '#fff', border: 'none', borderRadius: 7, cursor: 'pointer', fontFamily: F }}>End</button>
                    )}
                    <button onClick={() => setEditingSession(isEditing ? null : { id: s.id, status: s.status, note: s.notes || '' })} title="Edit" style={{ width: 26, height: 26, borderRadius: 7, border: '1px solid #e4edf3', background: isEditing ? '#314F5C' : '#fff', color: isEditing ? '#E0F5FC' : '#7a9aaa', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                    </button>
                    <button onClick={() => setDeleteConfirm(isDeleteConfirm ? null : s.id)} title="Delete" style={{ width: 26, height: 26, borderRadius: 7, border: '1px solid ' + (isDeleteConfirm ? '#f5c2c2' : '#e4edf3'), background: isDeleteConfirm ? '#fff0f0' : '#fff', color: isDeleteConfirm ? '#c62828' : '#9eb8c8', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>
                    </button>
                  </div>
                </div>

                {/* Delete confirm */}
                {isDeleteConfirm && (
                  <div style={{ padding: '8px 14px', background: '#fff8f8', borderBottom: '1px solid #f5c2c2', display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontSize: '.72rem', color: '#c62828', flex: 1 }}>Delete this session permanently?</span>
                    <button onClick={() => deleteSession(s.id)} style={{ padding: '4px 12px', background: '#c62828', color: '#fff', border: 'none', borderRadius: 6, fontSize: '.68rem', fontWeight: 600, cursor: 'pointer', fontFamily: F }}>Delete</button>
                    <button onClick={() => setDeleteConfirm(null)} style={{ padding: '4px 10px', background: 'transparent', color: '#9eb8c8', border: '1px solid #e4edf3', borderRadius: 6, fontSize: '.68rem', cursor: 'pointer', fontFamily: F }}>Cancel</button>
                  </div>
                )}

                {/* Edit panel */}
                {isEditing && (
                  <div style={{ padding: '10px 14px', background: '#f8fafc', borderBottom: `1px solid ${t.bd}` }}>
                    <div style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'center' }}>
                      <span style={{ fontSize: '.68rem', fontWeight: 600, color: '#5a7a8a', minWidth: 48 }}>Status</span>
                      {['active','ended','recorded'].map(st => (
                        <button key={st} onClick={() => setEditingSession(e => ({ ...e, status: st }))} style={{ padding: '3px 10px', borderRadius: 99, border: '1px solid ' + (editingSession.status === st ? '#314F5C' : '#d4e0ea'), background: editingSession.status === st ? '#314F5C' : '#fff', color: editingSession.status === st ? '#E0F5FC' : '#5a7a8a', fontSize: '.65rem', fontWeight: 600, cursor: 'pointer', fontFamily: F }}>{st}</button>
                      ))}
                    </div>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                      <span style={{ fontSize: '.68rem', fontWeight: 600, color: '#5a7a8a', minWidth: 48, paddingTop: 6 }}>Notes</span>
                      <textarea value={editingSession.note} onChange={e => setEditingSession(ev => ({ ...ev, note: e.target.value }))} rows={2} placeholder="Add notes about this session…" style={{ flex: 1, border: '1px solid #d4e0ea', borderRadius: 7, padding: '5px 9px', fontSize: '.72rem', fontFamily: F, resize: 'none', outline: 'none', color: '#0f1e28' }} />
                    </div>
                    <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end', marginTop: 8 }}>
                      <button onClick={saveEdit} style={{ padding: '5px 14px', background: t.accent, color: '#E0F5FC', border: 'none', borderRadius: 7, fontSize: '.7rem', fontWeight: 600, cursor: 'pointer', fontFamily: F }}>Save</button>
                      <button onClick={() => setEditingSession(null)} style={{ padding: '5px 10px', background: 'transparent', color: '#9eb8c8', border: '1px solid #e4edf3', borderRadius: 7, fontSize: '.7rem', cursor: 'pointer', fontFamily: F }}>Cancel</button>
                    </div>
                  </div>
                )}

                {/* Details grid */}
                <div style={{ padding: '10px 14px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 16px' }}>
                  {[
                    ['Started by', s.started_by || '—'],
                    ['With', s.with_name || (participants.filter(p => p !== s.started_by)[0]) || '—'],
                    ['Started', fmtTs(startD)],
                    ['Ended', fmtTs(endD)],
                    ['Duration', durStr],
                    ['Type', s.session_type === 'video' ? 'Video call' : 'Audio call'],
                  ].map(([label, val]) => (
                    <div key={label}>
                      <div style={{ fontSize: '.58rem', fontWeight: 600, color: '#9eb8c8', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 2 }}>{label}</div>
                      <div style={{ fontSize: '.74rem', color: '#1a2e38', fontWeight: 500 }}>{val}</div>
                    </div>
                  ))}
                </div>

                {/* Participants row */}
                {participants.length > 0 && (
                  <div style={{ padding: '0 14px 10px' }}>
                    <div style={{ fontSize: '.58rem', fontWeight: 600, color: '#9eb8c8', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 5 }}>Participants</div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                      {participants.map((p, pi) => (
                        <span key={pi} style={{ fontSize: '.68rem', padding: '2px 9px', borderRadius: 99, background: 'rgba(49,79,92,0.06)', color: '#314F5C', fontWeight: 500, border: '1px solid rgba(49,79,92,0.1)' }}>{p}</span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Notes (if set) */}
                {s.notes && !isEditing && (
                  <div style={{ padding: '0 14px 10px' }}>
                    <div style={{ fontSize: '.58rem', fontWeight: 600, color: '#9eb8c8', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 3 }}>Notes</div>
                    <div style={{ fontSize: '.72rem', color: '#5a7a8a', fontStyle: 'italic', lineHeight: 1.5 }}>{s.notes}</div>
                  </div>
                )}

                {/* Footer actions */}
                {(s.recording_url || (s.transcript && s.transcript.length > 0)) && (
                  <div style={{ padding: '8px 14px 12px', display: 'flex', gap: 7, borderTop: `1px solid ${t.bd}` }}>
                    {s.recording_url && (
                      <a href={s.recording_url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '.68rem', color: '#314F5C', background: '#edf6fb', border: '1px solid #c8dce8', borderRadius: 6, padding: '4px 10px', textDecoration: 'none', fontWeight: 500 }}>▶ Watch recording</a>
                    )}
                    {s.transcript && s.transcript.length > 0 && (
                      <button onClick={() => {
                        const lines = s.transcript.map(m => '[' + new Date(m.ts).toLocaleTimeString() + '] ' + m.name + ': ' + m.text).join('\n');
                        const blob = new Blob([lines], { type: 'text/plain' });
                        const a = document.createElement('a'); a.href = URL.createObjectURL(blob);
                        a.download = (s.room_name || 'session') + '-transcript.txt'; a.click();
                      }} style={{ fontSize: '.68rem', color: '#314F5C', background: '#f5f0e8', border: '1px solid #d4c4a8', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontFamily: F, fontWeight: 500 }}>↓ Transcript</button>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
  // ── Call tab — idle ───────────────────────────────────────────────────────
  const SANOIRE_ICON_URI = 'data:image/svg+xml;base64,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';
  const liveTeam = teamMembers.map(t => ({ ...t, online: !!(onlineUsers && onlineUsers[t.initials]) }));
  const onlineTeam = liveTeam.filter(t => t.online);

  if (!videoActive) {
    const recentCalls = (videoSessions || []).filter(s => s.status === 'ended').slice(0, 3);
    function sessLabel(s) {
      if (!s.room_name) return 'Call';
      if (s.room_name.startsWith('sanoire-ch-')) return '# ' + s.room_name.replace('sanoire-ch-', '');
      if (s.room_name.startsWith('sanoire-dm-')) return 'DM';
      if (s.room_name.startsWith('sanoire-team-')) return 'Team Room';
      return s.room_name;
    }
    function timeAgo(dt) {
      if (!dt) return '';
      const ms = Date.now() - new Date(dt).getTime();
      const m = Math.floor(ms / 60000);
      if (m < 60) return m + 'm ago';
      const h = Math.floor(m / 60);
      if (h < 24) return h + 'h ago';
      const d = Math.floor(h / 24);
      if (d === 1) return 'Yesterday';
      return new Date(dt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
    function durStr(s) {
      if (!s.started_at) return '';
      const start = new Date(s.started_at).getTime();
      const end = s.ended_at ? new Date(s.ended_at).getTime() : Date.now();
      const sec = Math.floor((end - start) / 1000);
      if (sec < 60) return sec + 's';
      const min = Math.floor(sec / 60);
      if (min < 60) return min + 'm';
      return Math.floor(min / 60) + 'h ' + (min % 60) + 'm';
    }
    return (
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        {tabBar}
        <div style={{ flex: 1, overflowY: 'auto', background: 'linear-gradient(180deg,#eef6fb 0%,#f0f7fb 100%)' }}>
          <div style={{ maxWidth: isMobile ? 560 : 1120, margin: '0 auto', padding: isMobile ? '16px 14px 92px' : '34px 36px 56px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'minmax(0,1.45fr) minmax(0,1fr)', gap: isMobile ? 14 : 22, alignItems: 'start' }}>

              {/* ── LEFT: hero ── */}
              <div style={{
                position: 'relative', overflow: 'hidden',
                background: 'linear-gradient(145deg, #e8f4f0 0%, #dff0ec 40%, #eaf3ee 100%)',
                borderRadius: 20,
                padding: isMobile ? '24px 20px 22px' : '38px 38px 34px',
                border: '1px solid rgba(129,157,132,0.18)',
                boxShadow: '0 4px 22px rgba(49,79,92,0.06)',
                minHeight: isMobile ? 0 : 380,
                display: 'flex', flexDirection: 'column',
              }}>
                <svg width='250' height='250' viewBox='0 0 24 24' fill='none' stroke='#314F5C' strokeWidth='1' strokeLinecap='round' strokeLinejoin='round' style={{ position: 'absolute', right: -48, top: -36, opacity: 0.05, pointerEvents: 'none' }}><path d='M15 10l4.553-2.069A1 1 0 0121 8.82v6.36a1 1 0 01-1.447.89L15 14'/><rect x='1' y='6' width='14' height='12' rx='3'/></svg>

              {/* Room status row */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 22, position: 'relative' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                  <div style={{ width: 8, height: 8, borderRadius: '50%', background: videoLoading ? '#B99C6D' : '#2da06a', flexShrink: 0, boxShadow: videoLoading ? 'none' : '0 0 8px rgba(45,160,106,0.5)' }} />
                  <span style={{ fontSize: '.7rem', color: '#6F8FA7', fontWeight: 500, fontFamily: 'monospace', letterSpacing: '.03em' }}>{videoLoading ? 'Creating room…' : videoRoomName}</span>
                </div>
                <button onClick={() => { navigator.clipboard && navigator.clipboard.writeText(meetingLink); setJoinCopied(true); setTimeout(() => setJoinCopied(false), 2000); }} style={{
                  background: joinCopied ? '#e6f5ec' : '#fff',
                  border: '1px solid ' + (joinCopied ? '#a8dfc0' : '#d4e4ee'),
                  borderRadius: 9, padding: '5px 13px', cursor: 'pointer',
                  fontSize: '.66rem', fontWeight: 600,
                  color: joinCopied ? '#1a7a45' : '#6F8FA7',
                  fontFamily: F, transition: 'all .2s',
                }}>
                  {joinCopied ? '✓ Copied' : 'Copy link'}
                </button>
              </div>

              {/* Title + presence row */}
              <div style={{ position: 'relative', marginBottom: 'auto' }}>
                <div style={{ fontSize: isMobile ? '1.5rem' : '1.95rem', fontWeight: 800, color: '#0f1e28', letterSpacing: '-.03em', lineHeight: 1.08 }}>Team Room</div>
                <div style={{ fontSize: '.82rem', color: '#6F8FA7', fontWeight: 400, marginTop: 6 }}>Video &amp; audio calls for the whole team</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 24 }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {liveTeam.map((t, i) => (
                      <div key={t.initials} style={{ marginLeft: i === 0 ? 0 : -9, position: 'relative', zIndex: liveTeam.length - i }}>
                        <div style={{ width: 40, height: 40, borderRadius: 12, background: t.color, color: t.text, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.62rem', fontWeight: 700, border: '2.5px solid #e8f4f0', opacity: t.online ? 1 : 0.35, transition: 'opacity .3s' }} title={t.name + (t.online ? ' · Online' : ' · Away')}>{t.initials}</div>
                        {t.online && <div style={{ position: 'absolute', bottom: -1, right: -1, width: 10, height: 10, borderRadius: '50%', background: '#2da06a', border: '2px solid #e8f4f0', boxShadow: '0 0 4px rgba(45,160,106,0.4)' }} />}
                      </div>
                    ))}
                  </div>
                  <div>
                    <div style={{ fontSize: '.74rem', fontWeight: 700, color: '#314F5C' }}>{onlineTeam.length} online</div>
                    <div style={{ fontSize: '.62rem', color: '#9eb8c8' }}>{liveTeam.length} members</div>
                  </div>
                </div>
              </div>

              {/* Start Meeting CTA */}
              <button onClick={startCall} disabled={videoLoading} style={{
                width: '100%', padding: '17px 0', marginTop: 30,
                background: videoLoading ? 'rgba(49,79,92,0.3)' : '#314F5C',
                color: '#E0F5FC', border: 'none', borderRadius: 14,
                fontSize: '1rem', fontWeight: 700,
                cursor: videoLoading ? 'not-allowed' : 'pointer', fontFamily: F,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
                boxShadow: videoLoading ? 'none' : '0 4px 18px rgba(49,79,92,0.28)',
                letterSpacing: '-.01em', transition: 'all .15s', position: 'relative',
              }}>
                {videoLoading ? (
                  <span style={{ display: 'flex', alignItems: 'center', gap: 8, opacity: .7 }}>
                    <svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.2' strokeLinecap='round' style={{ animation: 'sanoireSpin 0.9s linear infinite' }}><path d='M21 12a9 9 0 11-6.219-8.56'/></svg>
                    Setting up…
                  </span>
                ) : (
                  <><svg width='17' height='17' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round'><path d='M15 10l4.553-2.069A1 1 0 0121 8.82v6.36a1 1 0 01-1.447.89L15 14'/><rect x='1' y='6' width='14' height='12' rx='3'/></svg>Start Meeting</>
                )}
              </button>
              </div>

              {/* ── RIGHT: action rail ── */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>

              {/* Join with link */}
              <div style={{ background: t.panel, borderRadius: 14, padding: '18px', boxShadow: '0 1px 3px rgba(15,30,40,0.06), 0 0 0 1px rgba(15,30,40,0.03)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 12 }}>
                  <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='#6F8FA7' strokeWidth='2' strokeLinecap='round'><path d='M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71'/><path d='M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71'/></svg>
                  <span style={{ fontSize: '.72rem', fontWeight: 600, color: '#314F5C' }}>Join with link</span>
                </div>
                <div style={{ display: 'flex', gap: 0, borderRadius: 9, overflow: 'hidden', border: '1px solid #e2eaf0' }}>
                  <input value={joinUrl} onChange={e => setJoinUrl(e.target.value)} onKeyDown={e => e.stopPropagation()} placeholder='Paste link…' style={{ flex: 1, border: 'none', outline: 'none', padding: '9px 12px', fontSize: '.72rem', color: '#0f1e28', fontFamily: F, background: '#fafcfd', minWidth: 0 }} />
                  <button onClick={() => { if (joinUrl.trim()) { setVideoRoomUrl(joinUrl.trim()); setVideoActive(true); setJoinUrl(''); } }} disabled={!joinUrl.trim()} style={{ padding: '9px 14px', background: joinUrl.trim() ? '#314F5C' : '#e8eef2', color: joinUrl.trim() ? '#E0F5FC' : '#9eb8c8', border: 'none', cursor: joinUrl.trim() ? 'pointer' : 'default', fontSize: '.7rem', fontWeight: 600, fontFamily: F, flexShrink: 0, transition: 'all .15s' }}>Join</button>
                </div>
              </div>

              {/* Schedule a call */}
              <div style={{ background: t.panel, borderRadius: 14, padding: '18px', boxShadow: '0 1px 3px rgba(15,30,40,0.06), 0 0 0 1px rgba(15,30,40,0.03)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 12 }}>
                  <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='#6F8FA7' strokeWidth='2' strokeLinecap='round'><rect x='3' y='4' width='18' height='18' rx='2'/><line x1='16' y1='2' x2='16' y2='6'/><line x1='8' y1='2' x2='8' y2='6'/><line x1='3' y1='10' x2='21' y2='10'/></svg>
                  <span style={{ fontSize: '.72rem', fontWeight: 600, color: '#314F5C' }}>Schedule a call</span>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <input id='scheduleTimeInput' type='datetime-local' onKeyDown={e => e.stopPropagation()} style={{ flex: 1, border: '1px solid #e2eaf0', borderRadius: 9, padding: '8px 10px', fontSize: '.68rem', color: '#0f1e28', fontFamily: F, outline: 'none', background: '#fafcfd', minWidth: 0 }} />
                  <button onClick={() => {
                    if (schedulePosted) return;
                    const inp = document.getElementById('scheduleTimeInput');
                    if (!inp || !inp.value || !me) return;
                    const dt = new Date(inp.value);
                    const formatted = dt.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) + ' at ' + dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                    const msg = { id: Date.now(), user: me.initials, name: me.name, time: 'just now', text: '\u{1F4C5} Team call scheduled for ' + formatted + ' — ' + meetingLink, reactions: [] };
                    if (setChMsgs) setChMsgs(prev => ({ ...prev, general: [...(prev.general || []), msg] }));
                    if (sendShareToChannel) sendShareToChannel('general', meetingLink);
                    // Also create a real Planner calendar entry with the room link
                    try {
                      fetch('/api/calendar-events', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ title: 'Team Room call', type: 'meeting', start_at: dt.toISOString(), end_at: new Date(dt.getTime() + 30 * 60000).toISOString(), video: true, room_url: meetingLink, created_by: me.name }) }).catch(() => {});
                    } catch (_e) {}
                    inp.value = '';
                    setSchedulePosted(true);
                    setTimeout(() => setSchedulePosted(false), 3000);
                  }} style={{ padding: '8px 13px', background: schedulePosted ? '#819D84' : '#314F5C', color: '#E0F5FC', border: 'none', borderRadius: 9, fontSize: '.66rem', fontWeight: 600, cursor: schedulePosted ? 'default' : 'pointer', fontFamily: F, flexShrink: 0, whiteSpace: 'nowrap', transition: 'background .2s' }}>
                    {schedulePosted ? '✓ Posted' : 'Post'}
                  </button>
                </div>
              </div>

              {/* Secondary action buttons */}
              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={() => setShareOpen(v => !v)} style={{ flex: 1, padding: '11px 0', background: t.panel, color: '#6F8FA7', border: '1px solid #dde8ef', borderRadius: 12, fontSize: '.72rem', fontWeight: 500, cursor: 'pointer', fontFamily: F, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, boxShadow: '0 1px 2px rgba(15,30,40,0.04)' }}>
                  <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><circle cx='18' cy='5' r='3'/><circle cx='6' cy='12' r='3'/><circle cx='18' cy='19' r='3'/><line x1='8.59' y1='13.51' x2='15.42' y2='17.49'/><line x1='15.41' y1='6.51' x2='8.59' y2='10.49'/></svg>
                  Share link
                </button>
                <button onClick={() => { if (window.confirm('Generate a new room? Anyone with the current link won\'t be able to join.')) newRoom(); }} style={{ flex: 1, padding: '11px 0', background: t.panel, color: '#6F8FA7', border: '1px solid #dde8ef', borderRadius: 12, fontSize: '.72rem', fontWeight: 500, cursor: 'pointer', fontFamily: F, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, boxShadow: '0 1px 2px rgba(15,30,40,0.04)' }}>
                  <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'><polyline points='1 4 1 10 7 10'/><path d='M3.51 15a9 9 0 1 0 .49-3.1'/></svg>
                  New room
                </button>
              </div>

              {/* Recent calls card */}
              {recentCalls.length > 0 && (
                <div style={{ background: t.panel, borderRadius: 14, padding: '18px 20px', boxShadow: '0 1px 3px rgba(15,30,40,0.06), 0 0 0 1px rgba(15,30,40,0.03)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                      <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='#314F5C' strokeWidth='2' strokeLinecap='round'><circle cx='12' cy='12' r='10'/><polyline points='12 6 12 12 16 14'/></svg>
                      <span style={{ fontSize: '.74rem', fontWeight: 700, color: '#0f1e28' }}>Recent calls</span>
                    </div>
                    <button onClick={() => setVideoTab('sessions')} style={{ background: 'none', border: 'none', color: '#6F8FA7', fontSize: '.64rem', fontWeight: 600, cursor: 'pointer', fontFamily: F, padding: '2px 0' }}>View all →</button>
                  </div>
                  {recentCalls.map((s, i) => {
                    const av = teamMembers.find(t => t.initials === (s.started_by || '').toUpperCase()) || { color: '#6F8FA7', text: '#fff', initials: (s.started_by || '?').slice(0,2).toUpperCase() };
                    return (
                      <div key={s.id || i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderTop: i > 0 ? '1px solid #f4f6f8' : 'none' }}>
                        <div style={{ width: 30, height: 30, borderRadius: 9, background: av.color, color: av.text || '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.5rem', fontWeight: 700, flexShrink: 0 }}>{av.initials}</div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: '.72rem', fontWeight: 600, color: '#0f1e28' }}>{sessLabel(s)}</div>
                          <div style={{ fontSize: '.6rem', color: '#9eb8c8' }}>{durStr(s)} · {timeAgo(s.started_at)}</div>
                        </div>
                        <div style={{ fontSize: '.58rem', fontWeight: 500, color: '#9eb8c8', background: '#f5f8fa', padding: '3px 9px', borderRadius: 6 }}>ended</div>
                      </div>
                    );
                  })}
                </div>
              )}

              </div>
            </div>

            {videoError && (
              <div style={{ fontSize: '.72rem', color: '#c62828', background: '#fff0f0', border: '1px solid #f5c2c2', borderRadius: 8, padding: '9px 14px', textAlign: 'center', lineHeight: 1.5, width: '100%', marginTop: 14 }}>{videoError}</div>
            )}

          </div>
        </div>
      </div>
    );
  }

  // ── Call tab — active (responsive split) ─────────────────────────────────
  const chatPanel = (
    <div style={{ display: 'flex', flexDirection: 'column', background: t.panel, flexShrink: 0, ...(isMobile ? { height: 260, borderTop: `1px solid ${t.bd}` } : { width: 252, borderLeft: `1px solid ${t.bd}` }) }}>
      {/* Participants strip + Add people */}
      <div style={{ padding: '10px 14px 9px', borderBottom: `1px solid ${t.bd}`, flexShrink: 0, background: '#fafbfc', position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 7 }}>
          <div style={{ fontSize: '.62rem', fontWeight: 600, color: '#9eb8c8', textTransform: 'uppercase', letterSpacing: '.07em' }}>In this call</div>
          {videoActive && inviteToCall && (
            <button onClick={() => { setInviteOpen(p => !p); setInviteQuery(''); }}
              style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '3px 9px 3px 6px', background: inviteOpen ? 'rgba(49,79,92,0.10)' : 'rgba(49,79,92,0.05)', border: '1px solid rgba(49,79,92,0.12)', borderRadius: 99, cursor: 'pointer', fontSize: '.6rem', fontWeight: 600, color: '#314F5C', fontFamily: F, transition: 'background .15s' }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Add
            </button>
          )}
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {/* Always show "You" first during active call */}
          {me && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '3px 8px 3px 4px', background: 'rgba(49,79,92,0.10)', borderRadius: 99, border: '1px solid rgba(49,79,92,0.18)' }}>
              <div style={{ width: 18, height: 18, borderRadius: '50%', background: me.color || '#314F5C', color: me.text || '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.42rem', fontWeight: 700, flexShrink: 0 }}>{me.initials}</div>
              <span style={{ fontSize: '.65rem', color: '#314F5C', fontWeight: 600 }}>You</span>
            </div>
          )}
          {/* Other online team members (exclude self to avoid duplicate) */}
          {teamMembers.filter(t => onlineUsers && onlineUsers[t.initials] && (!me || t.initials !== me.initials)).map(t => (
            <div key={t.initials} style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '3px 8px 3px 4px', background: 'rgba(49,79,92,0.05)', borderRadius: 99, border: '1px solid rgba(49,79,92,0.1)' }}>
              <div style={{ width: 18, height: 18, borderRadius: '50%', background: t.color, color: t.text, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.42rem', fontWeight: 700, flexShrink: 0 }}>{t.initials}</div>
              <span style={{ fontSize: '.65rem', color: '#314F5C', fontWeight: 500 }}>{t.name.split(' ')[0]}</span>
            </div>
          ))}
        </div>
        {/* Add people dropdown */}
        {inviteOpen && videoActive && (() => {
          const inCall = new Set(teamMembers.filter(t => onlineUsers && onlineUsers[t.initials]).map(t => t.initials));
          if (me) inCall.add(me.initials);
          const available = teamMembers.filter(m => !inCall.has(m.initials));
          const filtered = inviteQuery.trim()
            ? available.filter(m => m.name.toLowerCase().includes(inviteQuery.toLowerCase()) || (m.email || '').toLowerCase().includes(inviteQuery.toLowerCase()))
            : available;
          return (
            <div style={{ position: 'absolute', top: '100%', left: 8, right: 8, zIndex: 9999, background: t.panel, border: '1px solid #d8e4ea', borderRadius: 10, boxShadow: '0 8px 28px rgba(15,30,40,0.16)', marginTop: 2, overflow: 'hidden' }}>
              <div style={{ padding: '8px 10px 6px', borderBottom: `1px solid ${t.bd}` }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#f7fafc', border: '1px solid #e4ecf0', borderRadius: 7, padding: '5px 8px' }}>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#9eb8c8" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                  <input autoFocus value={inviteQuery} onChange={e => setInviteQuery(e.target.value)}
                    onKeyDown={e => e.stopPropagation()}
                    onBlur={() => setTimeout(() => setInviteOpen(false), 180)}
                    placeholder="Search team members..."
                    style={{ flex: 1, border: 'none', background: 'transparent', fontSize: '.7rem', color: '#0f1e28', outline: 'none', fontFamily: F }} />
                </div>
              </div>
              <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                {filtered.length === 0 && (
                  <div style={{ padding: '14px 12px', fontSize: '.68rem', color: '#9eb8c8', textAlign: 'center' }}>
                    {available.length === 0 ? 'All team members are in the call' : 'No matches'}
                  </div>
                )}
                {filtered.map(m => {
                  const sent = inviteSent[m.initials];
                  return (
                    <div key={m.initials}
                      onMouseDown={() => {
                        if (sent) return;
                        inviteToCall(m);
                        setInviteSent(prev => ({ ...prev, [m.initials]: true }));
                        setTimeout(() => setInviteSent(prev => { const n = { ...prev }; delete n[m.initials]; return n; }), 8000);
                      }}
                      style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '8px 12px', cursor: sent ? 'default' : 'pointer', background: sent ? '#f0faf5' : 'transparent', transition: 'background .12s' }}
                      onMouseEnter={e => { if (!sent) e.currentTarget.style.background = '#f5f9fc'; }}
                      onMouseLeave={e => { if (!sent) e.currentTarget.style.background = 'transparent'; }}>
                      <div style={{ width: 26, height: 26, borderRadius: '50%', background: m.color, color: m.text || '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.46rem', fontWeight: 700, flexShrink: 0 }}>{m.initials}</div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: '.7rem', fontWeight: 600, color: '#0f1e28', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.name}</div>
                        <div style={{ fontSize: '.58rem', color: '#9eb8c8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.email || ''}{onlineUsers && onlineUsers[m.initials] ? ' · Online' : ''}</div>
                      </div>
                      {sent ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '.58rem', fontWeight: 600, color: '#2da06a', flexShrink: 0 }}>
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                          Invited
                        </div>
                      ) : (
                        <div style={{ fontSize: '.58rem', fontWeight: 600, color: '#6F8FA7', flexShrink: 0 }}>Invite</div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })()}
      </div>
      <div style={{ padding: '6px 14px 5px', borderBottom: `1px solid ${t.bd}`, fontSize: '.65rem', fontWeight: 600, color: '#314F5C', flexShrink: 0, background: t.panel }}>
        Meeting chat
      </div>
      <div ref={videoMsgsRef} style={{ flex: 1, overflowY: 'auto', padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 8 }}>
        {videoTranscript.length === 0 && (
          <div style={{ fontSize: '.68rem', color: '#c0d0d8', textAlign: 'center', marginTop: 20 }}>No messages yet</div>
        )}
        {videoTranscript.map((m, i) => {
          const av = TEAM.find(t => t.initials === m.user) || { color: '#6F8FA7', text: '#fff' };
          return (
            <div key={i} style={{ display: 'flex', gap: 7, alignItems: 'flex-start' }}>
              <div style={{ width: 24, height: 24, borderRadius: 6, background: av.color, color: av.text, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.52rem', fontWeight: 700, flexShrink: 0 }}>{m.user}</div>
              <div>
                <div style={{ fontSize: '.65rem', fontWeight: 600, color: '#0f1e28' }}>{m.name} <span style={{ fontWeight: 400, color: '#9eb8c8', fontSize: '.58rem' }}>{new Date(m.ts).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span></div>
                <div style={{ fontSize: '.72rem', color: '#2a3840', lineHeight: 1.5 }}>{m.text}</div>
              </div>
            </div>
          );
        })}
      </div>
      <div style={{ padding: '7px 10px', borderTop: `1px solid ${t.bd}`, display: 'flex', gap: 6, flexShrink: 0 }}>
        <input value={videoMsgInput} onChange={e => setVideoMsgInput(e.target.value)}
          onKeyDown={e => { e.stopPropagation(); if (e.key === 'Enter') { e.preventDefault(); if (videoMsgInput.trim() && me) { const msg = { user: me.initials, name: me.name, text: videoMsgInput.trim(), ts: new Date().toISOString() }; setVideoTranscript(prev => [...prev, msg]); setVideoMsgInput(''); setTimeout(() => videoMsgsRef.current?.scrollTo({ top: 99999, behavior: 'smooth' }), 50); } } }}
          placeholder="Message…"
          style={{ flex: 1, border: '1px solid #d8eaf4', borderRadius: 7, padding: '6px 9px', fontSize: '.72rem', color: '#0f1e28', outline: 'none', fontFamily: F, minWidth: 0 }}
        />
        <button onClick={() => { if (videoMsgInput.trim() && me) { const msg = { user: me.initials, name: me.name, text: videoMsgInput.trim(), ts: new Date().toISOString() }; setVideoTranscript(prev => [...prev, msg]); setVideoMsgInput(''); setTimeout(() => videoMsgsRef.current?.scrollTo({ top: 99999, behavior: 'smooth' }), 50); } }}
          style={{ width: 28, height: 28, borderRadius: 7, background: videoMsgInput.trim() ? '#314F5C' : '#dde4ea', border: 'none', color: '#fff', cursor: videoMsgInput.trim() ? 'pointer' : 'default', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'background .15s' }}>
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
        </button>
      </div>
    </div>
  );

  // LiveKit fills the whole content area edge-to-edge — its grid, chat,
  // participant list and screen-share are built in, so the side meeting-chat
  // panel is dropped on this path. The Daily fallback keeps the side panel.
  if (LIVEKIT_URL) {
    return (
      <div id="sanoire-callroom" style={{ flex: 1, display: 'flex', minWidth: 0, minHeight: 0, background: '#0b1620' }}>
        <LiveKitMeeting room={videoRoomName} name={(me && (me.name || me.initials)) || 'Member'} isMobile={isMobile} sessionId={videoSessionId} me={me} onLeave={() => setVideoActive(false)} />
      </div>
    );
  }
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: isMobile ? 'column' : 'row', minHeight: 0 }}>
      {/* Video — Daily.co iframe (fallback when LiveKit isn't configured) */}
      <iframe
        title="Sanoire Video"
        src={(videoRoomUrl || '') + (meetingToken ? '?t=' + meetingToken : '')}
        allow="camera; microphone; fullscreen; display-capture; autoplay"
        style={{ flex: 1, border: 'none', display: 'block', minHeight: isMobile ? 260 : 0 }}
      />
      {chatPanel}
    </div>
  );
}

function useIsMobile() {
  const [mob, setMob] = React.useState(() => typeof window !== 'undefined' && window.innerWidth < 768);
  React.useEffect(() => { const h = () => setMob(window.innerWidth < 768); window.addEventListener('resize', h); return () => window.removeEventListener('resize', h); }, []);
  return mob;
}

function timeAgo(ts) {
  if (!ts) return '';
  const m = Math.floor((Date.now() - new Date(ts)) / 60000);
  if (m < 1) return 'just now'; if (m < 60) return m + 'm ago';
  const h = Math.floor(m / 60);
  if (h < 24) return h + 'h ago'; return Math.floor(h / 24) + 'd ago';
}

function Avatar({ initials, color, textColor = '#fff', size = 32 }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return <div style={{ width: size, height: size, borderRadius: size <= 24 ? '50%' : 9, background: color, color: textColor, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: size * 0.38 + 'px', fontWeight: 700, flexShrink: 0, letterSpacing: '-.01em' }}>{initials}</div>;
}

function SectionHeader({ label, open, onToggle, action }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  return (
    <div style={{ display: 'flex', alignItems: 'center', padding: '8px 8px 5px', gap: 6 }}>
      <button onClick={onToggle}
        style={{ display: 'flex', alignItems: 'center', gap: 5, background: 'none', border: 'none',
          cursor: 'pointer', padding: 0, fontFamily: F, flex: 1, minWidth: 0 }}>
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
          stroke="rgba(49,79,92,0.3)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
          style={{ transform: open ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform .15s', flexShrink: 0 }}>
          <polyline points="3,1 7,5 3,9"/>
        </svg>
        <span style={{ fontSize: '.68rem', color: 'rgba(49,79,92,0.5)', fontWeight: 600, letterSpacing: '.01em' }}>{label}</span>
      </button>
      {action}
    </div>
  );
}

function GifPicker({ onSelect, onClose }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const [query, setQuery]   = useState('');
  const [gifs, setGifs]     = useState([]);
  const [loading, setLoading] = useState(true);
  const inputRef = useRef(null);
  const fetchGifs = useCallback(async (q) => {
    setLoading(true);
    try {
      const url = q.trim()
        ? 'https://api.giphy.com/v1/gifs/search?api_key=' + GIPHY_KEY + '&q=' + encodeURIComponent(q) + '&limit=12&rating=g'
        : 'https://api.giphy.com/v1/gifs/trending?api_key=' + GIPHY_KEY + '&limit=12&rating=g';
      const res = await fetch(url);
      const data = await res.json();
      setGifs((data.data || []).map(g => ({ id: g.id, url: g.images.fixed_height.url, preview: g.images.fixed_height_small.url, title: g.title })));
    } catch (_e) { setGifs([]); }
    setLoading(false);
  }, []);
  useEffect(() => { fetchGifs(''); }, [fetchGifs]);
  useEffect(() => {
    if (!query.trim()) { fetchGifs(''); return; }
    const t = setTimeout(() => fetchGifs(query), 400);
    return () => clearTimeout(t);
  }, [query, fetchGifs]);
  useEffect(() => { inputRef.current?.focus(); }, []);
  return (
    <div style={{ position: 'absolute', bottom: '100%', left: 0, right: 0, background: t.panel, border: '1px solid #e0e6ea', borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.15)', zIndex: 200, overflow: 'hidden', marginBottom: 6 }}>
      <div style={{ padding: '10px 12px', borderBottom: `1px solid ${t.bd}` }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
          <span style={{ fontSize: 12, fontWeight: 600, color: '#0f1e28', fontFamily: F }}>GIF</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9eb8c8', fontSize: 16, lineHeight: 1, padding: '0 2px' }}>×</button>
        </div>
        <input ref={inputRef} value={query} onChange={e => setQuery(e.target.value)} onKeyDown={e => e.stopPropagation()} placeholder='Search GIFs…' style={{ width: '100%', border: '1px solid #e0e6ea', borderRadius: 7, padding: '6px 10px', fontSize: 12, fontFamily: F, outline: 'none', color: '#0f1e28' }} />
      </div>
      <div style={{ height: 200, overflowY: 'auto', padding: 8, display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 4 }}>
        {loading && [1,2,3,4,5,6].map(i => <div key={i} style={{ aspectRatio: '1.6', borderRadius: 5, background: '#f0f4f6', animation: 'pulse 1.5s infinite' }} />)}
        {!loading && gifs.length === 0 && <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '32px 0', fontSize: 12, color: '#9eb8c8', fontFamily: F }}>No GIFs found</div>}
        {gifs.map(g => (
          <button key={g.id} onClick={() => onSelect(g.url)} style={{ border: 'none', padding: 0, borderRadius: 5, overflow: 'hidden', cursor: 'pointer', background: '#f0f4f6' }}>
            <img src={g.preview} alt={g.title} style={{ width: '100%', display: 'block', aspectRatio: '1.6', objectFit: 'cover' }} loading='lazy' />
          </button>
        ))}
      </div>
      <div style={{ padding: '5px 10px', borderTop: `1px solid ${t.bd}`, textAlign: 'right' }}>
        <span style={{ fontSize: 10, color: '#c0ccd4', fontFamily: F }}>Powered by GIPHY</span>
      </div>
    </div>
  );
}

function getPickerTabIcon(i, active) {
  const stroke = active ? '#AFE1F6' : '#6F8FA7';
  if (i === 0) return <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke={stroke} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3H14z'/><path d='M7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3'/></svg>;
  if (i === 1) return <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke={stroke} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><circle cx='12' cy='12' r='10'/><path d='M8 14s1.5 2 4 2 4-2 4-2'/><line x1='9' y1='9' x2='9.01' y2='9'/><line x1='15' y1='9' x2='15.01' y2='9'/></svg>;
  if (i === 2) return <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke={stroke} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><rect x='2' y='3' width='20' height='14' rx='2'/><line x1='8' y1='21' x2='16' y2='21'/><line x1='12' y1='17' x2='12' y2='21'/></svg>;
  return <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke={stroke} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><polygon points='12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2'/></svg>;
}
function EmojiPicker({ onSelect, onClose }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const [group, setGroup] = useState(0);
  return (
    <div style={{ position: 'absolute', bottom: '100%', left: 0, background: t.panel, border: `1px solid ${t.bd}`, borderRadius: 14, boxShadow: '0 8px 36px rgba(0,0,0,0.13)', zIndex: 200, width: 'min(320px, calc(100vw - 32px))', overflow: 'hidden', marginBottom: 7 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderBottom: `1px solid ${t.bd}` }}>
        <div style={{ display: 'flex', gap: 3 }}>
          {EMOJI_GROUPS.map((g, i) => (
            <button key={i} onClick={() => setGroup(i)} style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '4px 9px', borderRadius: 8, border: 'none', background: group === i ? '#314F5C' : 'transparent', color: group === i ? '#AFE1F6' : '#6F8FA7', fontSize: 11, cursor: 'pointer', fontFamily: F, fontWeight: group === i ? 600 : 400, transition: 'background .1s' }}>{getPickerTabIcon(i, group === i)}{g.label}</button>
          ))}
        </div>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9eb8c8', fontSize: 18, lineHeight: 1, padding: '0 2px' }}>×</button>
      </div>
      <div style={{ padding: '8px 10px 12px', display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 2 }}>
        {EMOJI_GROUPS[group].emojis.map(e => (
          <button key={e} onClick={() => onSelect(e)} style={{ border: 'none', background: 'transparent', borderRadius: 8, padding: '6px 0', cursor: 'pointer', transition: 'background .1s, transform .12s', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onMouseEnter={el => { el.currentTarget.style.background='#edf2f5'; el.currentTarget.style.transform='scale(1.2)'; }} onMouseLeave={el => { el.currentTarget.style.background='transparent'; el.currentTarget.style.transform=''; }}>{e === SANOIRE_RX ? <SanoireIcon size={26} /> : <Tw e={e} size={24} />}</button>
        ))}
      </div>
    </div>
  );
}

function DispatchBody({ session }) {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const onlineUsers = usePresenceContext();
  const isMobile = useIsMobile();
  const [selected, setSelected]       = useState({ type: 'channel', id: 'general' });
  const [videoActive,     setVideoActive]     = useState(false);
  const [videoRoomName,   setVideoRoomName]   = useState(() => 'sanoire-team-' + Math.random().toString(16).slice(2, 8));
  const [videoRoomUrl,    setVideoRoomUrl]     = useState(null);
  const [videoSessionId,  setVideoSessionId]   = useState(null);
  const [videoRecording,  setVideoRecording]   = useState(false);
  const [videoStartTime,  setVideoStartTime]   = useState(null);
  const [videoTranscript, setVideoTranscript]  = useState([]);
  const [videoMsgInput,   setVideoMsgInput]    = useState('');
  const [videoSessions,   setVideoSessions]    = useState([]);
  const [videoTab,        setVideoTab]         = useState('call'); // 'call' | 'sessions'
  const [videoLoading,    setVideoLoading]     = useState(false);
  const [videoError,      setVideoError]       = useState(null);
  const videoMsgsRef = useRef(null);
  const callChannelRef = useRef(null);
  const videoActiveRef = useRef(false);

  // Keep ref in sync with state for postMessage handler
  useEffect(() => { videoActiveRef.current = videoActive; }, [videoActive]);

  // MEETING-PERSIST (June 2026) — tell App when a Team Room meeting is live so
  // it keeps this screen MOUNTED across tab changes (instead of unmounting and
  // disconnecting LiveKit). The meeting now keeps running in the background; a
  // "Return to meeting" pill brings you back. Ending is explicit (Leave button).
  useEffect(() => {
    try { window.dispatchEvent(new CustomEvent('sanoire:meetinglive', { detail: { active: videoActive } })); } catch (_e) {}
  }, [videoActive]);
  const DAILY_DOMAIN  = process.env.REACT_APP_DAILY_DOMAIN  || '';
  const DAILY_API_KEY = process.env.REACT_APP_DAILY_API_KEY || '';
  const [meetingToken, setMeetingToken] = useState(null);

  // Listen for Daily.co postMessage — catch 'left-meeting' so Leave button triggers our endCall
  useEffect(() => {
    function handleDailyMessage(event) {
      if (!event.data || typeof event.data !== 'object') return;
      const action = event.data.action || event.data.type || '';
      if (action === 'left-meeting' || action === 'meeting-ended') {
        // User left via Daily.co controls — trigger our proper endCall flow
        if (videoActiveRef.current) {
          window.dispatchEvent(new CustomEvent('sanoire:dailyleave'));
        }
      }
    }
    window.addEventListener('message', handleDailyMessage);
    return () => window.removeEventListener('message', handleDailyMessage);
  }, []);
  const [hoveredDm, setHoveredDm]   = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [channels, setChannels]       = useState([]);
  const [typingUsers, setTypingUsers] = useState([]);
  const typingTimers = React.useRef({});
  const [threadReplies, setThreadReplies] = useState({});
  const [threadInput, setThreadInput]     = useState('');
  const [threadSending, setThreadSending] = useState(false);
  // Calls are handled by App-level FloatingCallOverlay via sanoire:startcall event
  const [translations, setTranslations]   = useState({});
  const [translateLang, setTranslateLang] = useState(
    () => localStorage.getItem('sanoire_dispatch_lang') || (navigator.language || 'en').split('-')[0]);
  const [msgReactions, setMsgReactions] = useState({});
  const [hoveredMsg, setHoveredMsg] = useState(null);
  const [dmCallLoading, setDmCallLoading] = useState(false);
  const [activeDmCall, setActiveDmCall] = useState(null);
  const [callElapsed, setCallElapsed] = useState(0);
  const callTimerRef = useRef(null);
  const chCallTimerRef = useRef(null);
  const [chCallMuted,    setChCallMuted]    = useState(false);
  const [chCallDuration, setChCallDuration] = useState(0);
  const [pendingIncomingCall, setPendingIncomingCall] = useState(null);
  const [activeChannelCalls, setActiveChannelCalls]   = useState({});   // { [channelId]: { roomUrl, startedBy, startedAt, sessionId } }
  const [myActiveChannelId,  setMyActiveChannelId]    = useState(null); // channelId I personally started
  const dmCallSessionRef = useRef(null);  // call_video_sessions id for current DM call
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showPinned, setShowPinned] = useState(false);
  const [pinnedMsgs, setPinnedMsgs] = useState([]);
  const [activeThread, setActiveThread] = useState(null);
  // PINNED_MSGS: loaded from dispatch_pins table via setPinnedMsgs (see pin button)
  const [chOpen, setChOpen] = useState(true);
  const [dmOpen, setDmOpen] = useState(true);
  const [callOpen, setCallOpen] = useState(true);
  const [sidebarSearch, setSidebarSearch] = useState('');
  const [sidebarSearchFocused, setSidebarSearchFocused] = useState(false);
  const [hoveredCh,      setHoveredCh]      = useState(null);
  const [hiddenDms,      setHiddenDms]      = useState(() => new Set(JSON.parse(localStorage.getItem('dispatch_hidden_dms')      || '[]')));
  const [hiddenChannels, setHiddenChannels] = useState(() => new Set(JSON.parse(localStorage.getItem('dispatch_hidden_channels') || '[]')));
  const [unreadChs, setUnreadChs] = useState(new Set()); // populated from real read state
  const [showSidebar, setShowSidebar] = useState(() => isMobile); // mobile opens on the channel list, not inside a channel
  const [callCollapsed, setCallCollapsed] = useState(false);
  React.useEffect(() => { setCallCollapsed(!!videoActive && !isMobile); }, [videoActive, isMobile]);
  const [tickets, setTickets]         = useState([]);
  const [ticketMsgs, setTicketMsgs]   = useState([]);
  const [loadingTix, setLoadingTix]   = useState(true);
  const [replyText, setReplyText]     = useState('');
  const [sending, setSending]         = useState(false);
  const [me, setMe]                   = useState(null);
  // Listen for incoming video chat messages from other participants
  useEffect(() => {
    if (!callChannelRef.current) return;
    const channel = callChannelRef.current;
    const handleVideoMsg = ({ payload }) => {
      if (!payload || payload.user === (me?.initials)) return; // skip own messages
      setVideoTranscript(prev => [...prev, payload]);
      setTimeout(() => videoMsgsRef.current?.scrollTo({ top: 99999, behavior: 'smooth' }), 50);
    };
    channel.on('broadcast', { event: 'video_chat_msg' }, handleVideoMsg);
    return () => { channel.unsubscribe && channel.unsubscribe(); };
  }, [me]); // eslint-disable-line
  const [chMsgs, setChMsgs]           = useState(SEED);
  const [chInput, setChInput]         = useState('');
  const [dmMsgs, setDmMsgs]           = useState({});
  const [dmInput, setDmInput]         = useState('');
  const [reactions, setReactions]     = useState({});
  const [readReceipts, setReadReceipts] = useState({}); // { msgId: [initials...] }
  const [editingMsg, setEditingMsg]    = useState(null); // { id, text }
  const [mentionQuery, setMentionQuery] = useState(''); // @ mention search
  const [showMentions, setShowMentions] = useState(false);
  const [linkPreviews, setLinkPreviews] = useState({}); // { msgId: { title, desc, url, favicon } }
  const [dispatchUnread, setDispatchUnread] = useState(0);
  const [mobileTab, setMobileTab] = useState('chat');
  const [mobileHelpFilter, setMobileHelpFilter] = useState('new');
  const [mobileThreadTab, setMobileThreadTab] = useState('customer');
  const [lastChatSelected, setLastChatSelected] = useState({ type: 'channel', id: 'general' });
  const [notes, setNotes] = useState([]);
  const [showEmoji, setShowEmoji]     = useState(false);
  const [showGif, setShowGif]         = useState(false);
  const [showQuickReplies, setShowQuickReplies] = useState(false);
  const [msgReactionPicker, setMsgReactionPicker] = useState(null);
  const bottomRef = useRef(null);

  useEffect(() => {
    supabase.from('team_members')
      .select('name, email, color, text_color, initials')
      .eq('active', true)
      .order('created_at')
      .then(({ data: tm }) => {
        if (!tm || tm.length === 0) return;
        const loaded = tm.map(m => ({
          initials: m.initials || (m.name || '').split(/\s+/).map(w => w[0]?.toUpperCase() || '').join('').slice(0, 2) || '??',
          name:     m.name  || '',
          email:    m.email || '',
          color:    m.color || '#314F5C',
          text:     m.text_color || '#fff',
          online:   false,
        }));
        TEAM = loaded;
        setTeamMembers(loaded);
      });
  }, []);

  useEffect(() => {
    supabase.from('dispatch_channels').select('*').order('sort_order', { ascending: true })
      .then(({ data }) => {
        if (data && data.length > 0) {
          const loaded = data.map(c => ({ id: c.id, label: c.id, desc: c.description || '' }));
          CHANNELS = loaded; setChannels(loaded);
        }
      });
  }, []);

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => {
      if (!data?.user) return;
      const email = data.user.email || '';
      const found = TEAM.find(t => t.email === email);
      if (found) { setMe(found); window.__myInitials = found.initials; return; }
      const parts = email.split('@')[0].split(/[._-]/);
      const myInit = parts.map(p => p[0]?.toUpperCase()).join('').slice(0, 2) || 'ME';
      window.__myInitials = myInit;
      setMe({ initials: myInit, name: parts[0] || 'Me', email, color: '#314F5C', text: '#AFE1F6', online: true });
    });
  }, []);

  useEffect(() => {
    supabase.rpc('admin_get_tickets').then(({ data }) => { setTickets(data || []); setLoadingTix(false); });
    const ch = supabase.channel('comms-tix').on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'support_tickets' }, p => setTickets(prev => [p.new, ...prev])).subscribe();
    return () => supabase.removeChannel(ch);
  }, []);

  useEffect(() => {
    if (selected.type !== 'ticket' || !selected.id) return;
    supabase.rpc('admin_get_replies', { p_ticket_id: selected.id }).then(({ data }) => setTicketMsgs(data || []));
    const ch = supabase.channel('comms-rep-' + selected.id)
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'support_replies', filter: 'ticket_id=eq.' + selected.id }, () => {
        supabase.rpc('admin_get_replies', { p_ticket_id: selected.id }).then(({ data }) => setTicketMsgs(data || []));
      }).subscribe();
    return () => supabase.removeChannel(ch);
  }, [selected]);

  // ── Load real channel messages from Supabase on channel select ──────────
  useEffect(() => {
    if (selected.type !== 'channel') return;
    const chanId = selected.id;
    supabase
      .from('dispatch_messages')
      .select('*')
      .eq('channel_id', chanId)
      .order('created_at', { ascending: true })
      .limit(200)
      .then(({ data }) => {
        if (data && data.length > 0) {
          const msgs = data.map(m => ({
            id: m.id,
            user: m.user_initials,
            name: m.user_name,
            ts:   m.created_at,
            time: new Date(m.created_at).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }),
            text: m.text || '',
            gif:  m.gif_url || null,
            reactions: [],
            edited: m.edited || false,
          }));
          setChMsgs(prev => ({ ...prev, [chanId]: msgs }));
          // Load reactions for these messages from dispatch_reactions
          const msgIds = data.map(m => m.id);
          if (msgIds.length > 0) {
            supabase.from('dispatch_reactions').select('message_id,emoji,user_initials').in('message_id', msgIds)
              .then(({ data: rxData }) => {
                if (!rxData || rxData.length === 0) return;
                const rxMap = {};
                rxData.forEach(r => {
                  if (!rxMap[r.message_id]) rxMap[r.message_id] = {};
                  rxMap[r.message_id][r.emoji] = (rxMap[r.message_id][r.emoji] || 0) + 1;
                });
                setChMsgs(prev => ({ ...prev, [chanId]: (prev[chanId] || []).map(m => {
                  const rx = rxMap[m.id]; if (!rx) return m;
                  return { ...m, reactions: Object.entries(rx).map(([e, n]) => ({ e, n })) };
                }) }));
              });
          }
        } else {
          // Channel has no messages yet — show empty (no fake seed)
          setChMsgs(prev => ({ ...prev, [chanId]: prev[chanId]?.length ? prev[chanId] : [] }));
        }
      });
    // Realtime: append new messages from other users
    const rtCh = supabase
      .channel('ch-msgs:' + chanId)
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'dispatch_messages',
        filter: 'channel_id=eq.' + chanId },
        payload => {
          const m = payload.new;
          const msg = {
            id: m.id, user: m.user_initials, name: m.user_name,
            ts: m.created_at,
            time: new Date(m.created_at).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }),
            text: m.text || '', gif: m.gif_url || null, reactions: [], edited: false,
          };
          setChMsgs(prev => {
            const cur = prev[chanId] || [];
            // Deduplicate: skip if we already have this id (from optimistic insert)
            if (cur.some(x => x.id === m.id)) return prev;
            return { ...prev, [chanId]: [...cur, msg] };
          });
          // Mark channel unread if we didn't send it
          if (m.user_initials !== window.__myInitials) {
            setUnreadChs(s => new Set([...s, chanId]));
          }
        }
      )
      .subscribe();
    return () => supabase.removeChannel(rtCh);
  }, [selected.id, selected.type]); // eslint-disable-line

  // ── Load pinned messages when channel selected ────────────────────────────
  useEffect(() => {
    if (selected.type !== 'channel') { setPinnedMsgs([]); return; }
    supabase.from('dispatch_pins').select('*').eq('channel_id', selected.id)
      .order('created_at', { ascending: false })
      .then(({ data }) => setPinnedMsgs(data || []));
  }, [selected.id, selected.type]); // eslint-disable-line

  useEffect(() => {
    if (!activeThread) return;
    supabase.from('dispatch_thread_replies').select('*').eq('message_id', activeThread).order('created_at', { ascending: true })
      .then(({ data }) => { if (data) setThreadReplies(prev => ({ ...prev, [activeThread]: data })); });
    const ch = supabase.channel('thread:' + activeThread)
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'dispatch_thread_replies', filter: 'message_id=eq.' + activeThread },
        payload => { setThreadReplies(prev => ({ ...prev, [activeThread]: [...(prev[activeThread] || []), payload.new] })); })
      .subscribe();
    return () => supabase.removeChannel(ch);
  }, [activeThread]); // eslint-disable-line

  // Load internal notes when ticket selected on mobile
  React.useEffect(() => {
    if (!selected.id || selected.type !== 'ticket') { setNotes([]); return; }
    supabase.rpc('admin_get_notes', { p_ticket_id: selected.id })
      .then(({ data: nd }) => setNotes(nd || []))
      .catch(() => setNotes([]));
  }, [selected.id, selected.type]); // eslint-disable-line

  // ── Load DM history from Supabase on DM select ───────────────────────────
  useEffect(() => {
    if (selected.type !== 'dm' || !me) return;
    const dmPair = [me.initials, selected.id].sort().join('-');
    const chanId  = 'dm:' + dmPair;
    supabase.from('dispatch_messages').select('*').eq('channel_id', chanId)
      .order('created_at', { ascending: true }).limit(200)
      .then(({ data }) => {
        if (data && data.length > 0) {
          const msgs = data.map(m => ({
            id: m.id, user: m.user_initials, from: m.user_initials, name: m.user_name,
            ts: m.created_at,
            time: new Date(m.created_at).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }),
            text: m.text || '', gif: m.gif_url || null, reactions: [], edited: m.edited || false,
          }));
          setDmMsgs(prev => ({ ...prev, [selected.id]: msgs }));
        }
      });
    const rtCh2 = supabase.channel('dm-msgs:' + chanId)
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'dispatch_messages',
        filter: 'channel_id=eq.' + chanId },
        payload => {
          const m = payload.new;
          const msg = { id: m.id, user: m.user_initials, from: m.user_initials, name: m.user_name,
            ts: m.created_at, time: new Date(m.created_at).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }),
            text: m.text || '', gif: m.gif_url || null, reactions: [], edited: false };
          setDmMsgs(prev => {
            const cur = prev[selected.id] || [];
            if (cur.some(x => x.id === m.id)) return prev;
            return { ...prev, [selected.id]: [...cur, msg] };
          });
        }).subscribe();
    return () => supabase.removeChannel(rtCh2);
  }, [selected.id, selected.type, me]); // eslint-disable-line

  async function sendThreadReply() {
    if (!threadInput.trim() || !me || !activeThread || threadSending) return;
    if (!activeThread) return;
    setThreadSending(true);
    const optimisticId = Date.now();
    const txt = threadInput.trim();
    const reply = { id: optimisticId, message_id: activeThread, user_initials: me.initials, user_name: me.name, text: txt, created_at: new Date().toISOString() };
    setThreadReplies(prev => ({ ...prev, [activeThread]: [...(prev[activeThread] || []), reply] }));
    setThreadInput('');
    const { data: saved } = await supabase.from('dispatch_thread_replies').insert({ message_id: activeThread, user_initials: me.initials, user_name: me.name, text: txt }).select().single();
    if (saved) setThreadReplies(prev => ({ ...prev, [activeThread]: (prev[activeThread] || []).map(r => r.id === optimisticId ? { ...r, id: saved.id } : r) }));
    setThreadSending(false);
  }

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [ticketMsgs, chMsgs, dmMsgs, selected]);

  useEffect(() => {
    const ch = supabase.channel('admin-calls')
      .on('broadcast', { event: 'incoming_call' }, ({ payload }) => {
        if (!payload) return;
        setPendingIncomingCall(payload);
      })
      .on('broadcast', { event: 'channel_call_started' }, ({ payload }) => {
        if (!payload) return;
        setActiveChannelCalls(prev => ({ ...prev, [payload.channelId]: { roomUrl: payload.roomUrl, startedBy: payload.startedBy, startedAt: payload.startedAt, sessionId: null } }));
      })
      .on('broadcast', { event: 'channel_call_ended' }, ({ payload }) => {
        if (!payload) return;
        setActiveChannelCalls(prev => { const n = { ...prev }; delete n[payload.channelId]; return n; });
        setMyActiveChannelId(id => id === payload.channelId ? null : id);
      })
      .subscribe();
    callChannelRef.current = ch;
    return () => { supabase.removeChannel(ch); callChannelRef.current = null; };
  }, []); // eslint-disable-line

  // ── End call on browser close / page unload ──────────────────────────────
  React.useEffect(() => {
    function handleUnload() {
      if (!myActiveChannelId) return;
      // Best-effort: broadcast end to peers (may not arrive, but try)
      if (callChannelRef.current) {
        callChannelRef.current.send({
          type: 'broadcast', event: 'channel_call_ended',
          payload: { channelId: myActiveChannelId },
        }).catch(() => {});
      }
    }
    window.addEventListener('beforeunload', handleUnload);
    return () => window.removeEventListener('beforeunload', handleUnload);
  }, [myActiveChannelId]); // eslint-disable-line

  // ── Handle end-call initiated from the FloatingCallOverlay ─────────────────
  // Use a ref so we always read current activeChannelCalls without stale closure
  const activeChannelCallsRef = React.useRef({});
  useEffect(() => { activeChannelCallsRef.current = activeChannelCalls; }, [activeChannelCalls]);

  useEffect(() => {
    function handleOverlayEnd(e) {
      const { type, id } = e.detail || {};
      if (type === 'channel' && id) {
        const callData = activeChannelCallsRef.current[id];
        const endedAt = new Date().toISOString();
        // DB update — outside setter so it's a real async call
        if (callData?.sessionId) {
          supabase.from('call_video_sessions')
            .update({ ended_at: endedAt, status: 'ended' })
            .eq('id', callData.sessionId)
            .then(() => {}).catch(() => {});
        } else {
          supabase.from('call_video_sessions')
            .update({ ended_at: endedAt, status: 'ended' })
            .eq('room_name', 'sanoire-ch-' + id).eq('status', 'active')
            .then(() => {}).catch(() => {});
        }
        // State update
        setActiveChannelCalls(prev => { const n = { ...prev }; delete n[id]; return n; });
        setMyActiveChannelId(cur => cur === id ? null : cur);
        // Clear channel header timer (Bug 7 fix)
        if (chCallTimerRef.current) { clearInterval(chCallTimerRef.current); chCallTimerRef.current = null; }
        setChCallDuration(0);
        setChCallMuted(false);
        // Broadcast to peers
        if (callChannelRef.current) {
          callChannelRef.current.send({
            type: 'broadcast', event: 'channel_call_ended', payload: { channelId: id },
          }).catch(() => {});
        }
      } else if (type === 'dm') {
        if (dmCallSessionRef.current) {
          supabase.from('call_video_sessions')
            .update({ ended_at: new Date().toISOString(), status: 'ended' })
            .eq('id', dmCallSessionRef.current)
            .then(() => {}).catch(() => {});
          dmCallSessionRef.current = null;
        }
        setActiveDmCall(null);
        setCallElapsed(0);
        if (callTimerRef.current) { clearInterval(callTimerRef.current); callTimerRef.current = null; }
        setDmCallLoading(false);
      }
    }
    window.addEventListener('sanoire:overlayendcall', handleOverlayEnd);
    return () => window.removeEventListener('sanoire:overlayendcall', handleOverlayEnd);
  }, []); // eslint-disable-line

  // Hydrate active channel calls from Supabase — expire stale sessions > 4hrs
  useEffect(() => {
    const FOUR_HOURS = 4 * 60 * 60 * 1000;
    supabase.from('call_video_sessions')
      .select('id, room_name, room_url, started_by, started_at')
      .eq('status', 'active')
      .like('room_name', 'sanoire-ch-%')
      .then(({ data }) => {
        if (!data || data.length === 0) { setActiveChannelCalls({}); return; }
        const map = {};
        const staleIds = [];
        data.forEach(s => {
          const age = Date.now() - new Date(s.started_at).getTime();
          if (age > FOUR_HOURS) {
            // Auto-expire stale sessions in DB
            staleIds.push(s.id);
          } else {
            const chId = s.room_name.replace('sanoire-ch-', '');
            map[chId] = { roomUrl: s.room_url, startedBy: s.started_by, startedAt: s.started_at, sessionId: s.id };
          }
        });
        if (staleIds.length > 0) {
          supabase.from('call_video_sessions')
            .update({ status: 'ended', ended_at: new Date().toISOString() })
            .in('id', staleIds)
            .then(() => {});
        }
        setActiveChannelCalls(map);
      });
  }, []); // eslint-disable-line

  const selTicket = selected.type === 'ticket' ? tickets.find(t => t.id === selected.id) : null;

  async function sendTicketReply() {
    if (!replyText.trim() || !selTicket || sending) return;
    setSending(true);
    await supabase.rpc('admin_reply', { p_ticket_id: selTicket.id, p_message: replyText.trim() });
    setReplyText('');
    const { data } = await supabase.rpc('admin_get_replies', { p_ticket_id: selTicket.id });
    setTicketMsgs(data || []);
    setSending(false);
  }

  async function setStatus(status) {
    if (!selTicket) return;
    await supabase.rpc('admin_update_ticket_status', { p_ticket_id: selTicket.id, p_status: status });
    setTickets(prev => prev.map(t => t.id === selTicket.id ? { ...t, status } : t));
  }

  const typingChannelRef = React.useRef(null);
  useEffect(() => {
    if (!me || (selected.type !== 'channel' && selected.type !== 'dm')) return;
    const rtId = selected.type === 'channel' ? selected.id : 'dm:' + [me.initials, selected.id].sort().join('-');
    const ch = supabase.channel('typing:' + rtId)
      .on('broadcast', { event: 'typing' }, ({ payload }) => {
        if (payload.initials === me.initials) return;
        setTypingUsers(prev => {
          const rest = prev.filter(u => u.initials !== payload.initials);
          return payload.active ? [...rest, { initials: payload.initials, name: payload.name }] : rest;
        });
        if (typingTimers.current[payload.initials]) clearTimeout(typingTimers.current[payload.initials]);
        if (payload.active) typingTimers.current[payload.initials] = setTimeout(() => setTypingUsers(prev => prev.filter(u => u.initials !== payload.initials)), 4000);
      }).subscribe();
    typingChannelRef.current = ch;
    return () => { supabase.removeChannel(ch); setTypingUsers([]); };
  }, [selected, me]); // eslint-disable-line

  function broadcastTyping(active) {
    if (!me || !typingChannelRef.current) return;
    typingChannelRef.current.send({ type: 'broadcast', event: 'typing', payload: { initials: me.initials, name: me.name, active } }).catch(() => {});
  }

  async function sendChannelMsg(text) {
    const txt = text !== undefined ? text : chInput;
    if (!txt.trim() || !me) return;
    if (txt.trim() === '/gif') { setShowGif(true); setChInput(''); return; }
    const optimisticId = Date.now();
    const msg = { id: optimisticId, user: me.initials, name: me.name, time: 'just now', text: txt.trim(), reactions: [], created_at: new Date().toISOString() };
    setChMsgs(prev => ({ ...prev, [selected.id]: [...(prev[selected.id] || []), msg] }));
    setChInput('');
    broadcastTyping(false);
    setReadReceipts(prev => ({ ...prev, [optimisticId]: [me.initials] }));
    const url = extractUrl(txt);
    if (url) fetchLinkPreview(optimisticId, url);
    // Persist to Supabase
    const { data: saved } = await supabase.from('dispatch_messages').insert({ channel_id: selected.id, user_initials: me.initials, user_name: me.name, text: txt.trim() }).select().single();
    if (saved) setChMsgs(prev => ({ ...prev, [selected.id]: (prev[selected.id] || []).map(m => m.id === optimisticId ? { ...m, id: saved.id } : m) }));
  }

  async function sendChannelGif(url) {
    if (!me) return;
    const optimisticId = Date.now();
    const msg = { id: optimisticId, user: me.initials, name: me.name, time: 'just now', gif: url, reactions: [] };
    setChMsgs(prev => ({ ...prev, [selected.id]: [...(prev[selected.id] || []), msg] }));
    setShowGif(false);
    const { data: saved } = await supabase.from('dispatch_messages').insert({ channel_id: selected.id, user_initials: me.initials, user_name: me.name, gif_url: url }).select().single();
    if (saved) setChMsgs(prev => ({ ...prev, [selected.id]: (prev[selected.id] || []).map(m => m.id === optimisticId ? { ...m, id: saved.id } : m) }));
  }

  async function sendDm(text) {
    const txt = text !== undefined ? text : dmInput;
    if (!txt.trim() || !me) return;
    if (txt.trim() === '/gif') { setShowGif(true); setDmInput(''); return; }
    const dmPair = [me.initials, selected.id].sort().join('-');
    const channelId = 'dm:' + dmPair;
    const optimisticId = Date.now();
    const msg = { id: optimisticId, user: me.initials, from: me.initials, name: me.name, time: 'just now', text: txt.trim(), created_at: new Date().toISOString() };
    setDmMsgs(prev => ({ ...prev, [selected.id]: [...(prev[selected.id] || []), msg] }));
    setDmInput('');
    const { data: saved } = await supabase.from('dispatch_messages').insert({ channel_id: channelId, user_initials: me.initials, user_name: me.name, text: txt.trim() }).select().single();
    if (saved) setDmMsgs(prev => ({ ...prev, [selected.id]: (prev[selected.id] || []).map(m => m.id === optimisticId ? { ...m, id: saved.id } : m) }));
  }

  async function sendDmGif(url) {
    if (!me) return;
    const dmPair = [me.initials, selected.id].sort().join('-');
    const channelId = 'dm:' + dmPair;
    const optimisticId = Date.now();
    const msg = { id: optimisticId, user: me.initials, from: me.initials, name: me.name, time: 'just now', gif: url };
    setDmMsgs(prev => ({ ...prev, [selected.id]: [...(prev[selected.id] || []), msg] }));
    setShowGif(false);
    const { data: saved } = await supabase.from('dispatch_messages').insert({ channel_id: channelId, user_initials: me.initials, user_name: me.name, gif_url: url }).select().single();
    if (saved) setDmMsgs(prev => ({ ...prev, [selected.id]: (prev[selected.id] || []).map(m => m.id === optimisticId ? { ...m, id: saved.id } : m) }));
  }

  function appendEmoji(e) {
    if (selected.type === 'ticket') setReplyText(prev => prev + e);
    else if (selected.type === 'dm') setDmInput(prev => prev + e);
    else setChInput(prev => prev + e);
    setShowEmoji(false);
  }

  function handleGifSelect(url) {
    if (selected.type === 'channel') sendChannelGif(url);
    else if (selected.type === 'dm') sendDmGif(url);
    else { setReplyText(prev => prev + ' [GIF: ' + url + ']'); setShowGif(false); }
  }

  const fileInputRef = useRef(null);
  async function uploadAndSendFile(file) {
    if (!file || !me) return;
    if (file.size > 25 * 1024 * 1024) { alert('File too large — max 25 MB.'); return; }
    try {
      const safe = (file.name || 'file').replace(/[^a-zA-Z0-9._-]/g, '_');
      const path = (selected.type || 'misc') + '/' + Date.now() + '-' + Math.random().toString(36).slice(2) + '-' + safe;
      const up = await supabase.storage.from('dispatch-uploads').upload(path, file, { cacheControl: '3600', upsert: false, contentType: file.type || undefined });
      if (up.error) { console.warn('attach upload failed', up.error); alert('Upload failed. Please try again.'); return; }
      const pub = supabase.storage.from('dispatch-uploads').getPublicUrl(path);
      const url = pub && pub.data && pub.data.publicUrl;
      if (!url) return;
      if ((file.type || '').startsWith('image/')) {
        handleGifSelect(url);
      } else {
        const label = '📎 ' + (file.name || 'attachment') + ' ' + url;
        if (selected.type === 'channel') sendChannelMsg(label);
        else if (selected.type === 'dm') sendDm(label);
        else setReplyText(prev => (prev ? prev + ' ' : '') + label);
      }
    } catch (e) { console.warn('attach error', e); alert('Upload failed. Please try again.'); }
  }

  async function addMsgReaction(msgId, emoji, isChannel) {
    if (!me) return;
    const key = msgId + emoji;
    const wasMe = reactions[key];
    setReactions(prev => ({ ...prev, [key]: !wasMe }));
    const updateMsgs = arr => arr.map(m => {
      if (m.id !== msgId) return m;
      const existing = (m.reactions || []).find(r => r.e === emoji);
      if (wasMe) return { ...m, reactions: (m.reactions || []).map(r => r.e === emoji ? { ...r, n: Math.max(0, r.n - 1) } : r).filter(r => r.n > 0) };
      if (existing) return { ...m, reactions: (m.reactions || []).map(r => r.e === emoji ? { ...r, n: r.n + 1, mine: true } : r) };
      return { ...m, reactions: [...(m.reactions || []), { e: emoji, n: 1, mine: true }] };
    });
    if (isChannel) setChMsgs(prev => ({ ...prev, [selected.id]: updateMsgs(prev[selected.id] || []) }));
    else setDmMsgs(prev => ({ ...prev, [selected.id]: updateMsgs(prev[selected.id] || []) }));
    if (typeof msgId === 'string' && msgId.includes('-')) {
      if (wasMe) await supabase.from('dispatch_reactions').delete().eq('message_id', msgId).eq('user_initials', me.initials).eq('emoji', emoji);
      else await supabase.from('dispatch_reactions').upsert({ message_id: msgId, user_initials: me.initials, emoji });
    }
    setMsgReactionPicker(null);
  }

  // ── Read receipts: mark message as read by me ──────────────────────────
  function markRead(msgId) {
    if (!me) return;
    setReadReceipts(prev => {
      const existing = prev[msgId] || [];
      if (existing.includes(me.initials)) return prev;
      return { ...prev, [msgId]: [...existing, me.initials] };
    });
  }

  // ── Link preview: extract from URL in message text ──────────────────────
  function extractUrl(text) {
    if (!text) return null;
    const m = text.match(/https?:\/\/[^\s]+/);
    return m ? m[0] : null;
  }

  async function fetchLinkPreview(msgId, url) {
    if (linkPreviews[msgId]) return;
    // Use allorigins as a CORS proxy to fetch OG tags
    try {
      const res = await fetch('https://api.allorigins.win/get?url=' + encodeURIComponent(url));
      const data = await res.json();
      const html = data.contents || '';
      const title = (html.match(/<meta[^>]+property=["']og:title["'][^>]+content=["']([^"']+)["']/) || html.match(/<title[^>]*>([^<]+)<\/title>/) || [])[1] || '';
      const desc  = (html.match(/<meta[^>]+property=["']og:description["'][^>]+content=["']([^"']+)["']/) || html.match(/<meta[^>]+name=["']description["'][^>]+content=["']([^"']+)["']/) || [])[1] || '';
      const favicon = (html.match(/<link[^>]+rel=["'](?:shortcut )?icon["'][^>]+href=["']([^"']+)["']/) || [])[1] || '';
      const host = url.replace(/https?:\/\//, '').split('/')[0];
      if (title || desc) setLinkPreviews(prev => ({ ...prev, [msgId]: { title: title.slice(0,80), desc: desc.slice(0,140), url: host, favicon } }));
    } catch (_e) {}
  }

  // ── Edit message ─────────────────────────────────────────────────────────
  async function saveEdit(msgId, newText) {
    if (!newText.trim()) return;
    const update = arr => arr.map(m => m.id === msgId ? { ...m, text: newText.trim(), edited: true } : m);
    if (selected.type === 'channel') setChMsgs(prev => ({ ...prev, [selected.id]: update(prev[selected.id] || []) }));
    else if (selected.type === 'dm') setDmMsgs(prev => ({ ...prev, [selected.id]: update(prev[selected.id] || []) }));
    setEditingMsg(null);
    if (typeof msgId === 'string' && msgId.includes('-')) {
      await supabase.from('dispatch_messages').update({ text: newText.trim(), edited: true, edited_at: new Date().toISOString() }).eq('id', msgId);
    }
  }

  async function deleteMsg(msgId) {
    if (selected.type === 'channel') setChMsgs(prev => ({ ...prev, [selected.id]: (prev[selected.id] || []).filter(m => m.id !== msgId) }));
    else if (selected.type === 'dm') setDmMsgs(prev => ({ ...prev, [selected.id]: (prev[selected.id] || []).filter(m => m.id !== msgId) }));
    if (typeof msgId === 'string' && msgId.includes('-')) {
      await supabase.from('dispatch_messages').delete().eq('id', msgId);
    }
  }

  function pick(type, id) {
    setSelected({ type, id });
    if (type === 'ticket' && id && !selected.id) setActiveThread(null);
    if (type === 'channel') setUnreadChs(prev => { const s = new Set(prev); s.delete(id); return s; });
    setReplyText(''); setChInput(''); setDmInput('');
    setShowEmoji(false); setShowGif(false); setShowQuickReplies(false);
    if (isMobile) setShowSidebar(false);
    // read receipts marked via message render
  }

  const openCount = tickets.filter(t => t.status !== 'resolved').length;

  const sidebar = (
    <div style={{ width: isMobile ? '100%' : 252, flexShrink: 0, background: '#edf2f5', display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto' }}>

      {/* ── Header ── */}
      {!isMobile && (
        <div style={{ padding: '12px 12px 10px', flexShrink: 0,
          borderBottom: '0.5px solid rgba(49,79,92,0.08)', background: t.panel }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
            {me && (
              <div style={{ position: 'relative', flexShrink: 0 }}>
                <div style={{ width: 26, height: 26, borderRadius: 8, background: me.color,
                  color: me.text, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '.56rem', fontWeight: 700 }}>{me.initials}</div>
                <div style={{ position: 'absolute', bottom: -1, right: -1, width: 6, height: 6,
                  borderRadius: '50%', background: '#2da06a', border: '1.5px solid #fff' }} />
              </div>
            )}
            {Object.values(onlineUsers).filter(u => u.initials !== me?.initials).slice(0, 3).map((u, ui) => (
              <div key={ui} title={u.name + ' · Online'}
                style={{ width: 20, height: 20, borderRadius: 6, background: (teamMembers.find(t => t.initials === u.initials) || {}).color || '#6F8FA7',
                  color: (teamMembers.find(t => t.initials === u.initials) || {}).text || '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '.44rem', fontWeight: 700, flexShrink: 0, position: 'relative' }}>
                {u.initials}
                <div style={{ position: 'absolute', bottom: -1, right: -1, width: 5, height: 5,
                  borderRadius: '50%', background: '#2da06a', border: '1px solid #fff' }} />
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: sidebarSearchFocused ? '#fff' : 'rgba(49,79,92,0.04)',
            borderRadius: 8, padding: '6px 10px', border: sidebarSearchFocused ? '1px solid rgba(49,79,92,0.2)' : '1px solid rgba(49,79,92,0.1)', transition: 'all .15s' }}>
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="rgba(49,79,92,0.35)" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input value={sidebarSearch} onChange={e => setSidebarSearch(e.target.value)}
              onFocus={() => setSidebarSearchFocused(true)} onBlur={() => setSidebarSearchFocused(false)}
              placeholder="Search channels, people…"
              onKeyDown={e => e.stopPropagation()}
              style={{ background: 'none', border: 'none', outline: 'none', flex: 1,
                fontSize: '.72rem', color: '#0f1e28', fontFamily: F }} />
          </div>
        </div>
      )}
            {/* ── Body ── */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '10px 10px 16px' }}>

        {/* Customer Help — expandable with inline ticket list */}
        <div style={{ marginBottom: 10 }}>
          <button onClick={() => { const first = tickets.find(t => t.status !== 'resolved'); if (first) pick('ticket', first.id); else pick('customerhelp', 'hub'); }} style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 9, padding: '8px 10px', background: selected.type === 'customerhelp' || selected.type === 'ticket' ? 'rgba(49,79,92,0.06)' : 'transparent', border: selected.type === 'customerhelp' || selected.type === 'ticket' ? '1px solid rgba(49,79,92,0.15)' : '1px solid transparent', borderRadius: 9, cursor: 'pointer', fontFamily: F, textAlign: 'left', transition: 'all .1s' }}
            onMouseEnter={e => { if(selected.type !== 'customerhelp' && selected.type !== 'ticket') e.currentTarget.style.background = 'rgba(49,79,92,0.04)'; }}
            onMouseLeave={e => { if(selected.type !== 'customerhelp' && selected.type !== 'ticket') e.currentTarget.style.background = 'transparent'; }}>
            <div style={{ width: 26, height: 26, borderRadius: 7, background: openCount > 0 ? 'rgba(229,57,53,0.09)' : 'rgba(49,79,92,0.07)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={openCount > 0 ? '#e05c5c' : '#6F8FA7'} strokeWidth="2" strokeLinecap="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '.74rem', color: '#0f2a38', fontWeight: 600 }}>Customer Help</div>
              <div style={{ fontSize: '.6rem', color: openCount > 0 ? '#e05c5c' : '#9eb8c8', marginTop: 1 }}>{openCount > 0 ? openCount + ' open' : 'All clear'}</div>
            </div>
            {openCount > 0 && <div style={{ width: 18, height: 18, borderRadius: '50%', background: '#e05c5c', color: '#fff', fontSize: '.6rem', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{openCount}</div>}
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="rgba(49,79,92,0.3)" strokeWidth="2" strokeLinecap="round" style={{ transform: (selected.type === 'customerhelp' || selected.type === 'ticket') ? 'rotate(90deg)' : 'none', transition: 'transform .15s', flexShrink: 0 }}><polyline points="9 18 15 12 9 6"/></svg>
          </button>
          {(selected.type === 'customerhelp' || selected.type === 'ticket') && tickets.filter(t => t.status !== 'resolved').slice(0, 6).map(t => {
            const isActive = selected.type === 'ticket' && selected.id === t.id;
            const cfg = STATUS_CFG[t.status] || STATUS_CFG.open;
            return (
              <button key={t.id} onClick={() => pick('ticket', t.id)} style={{ width: '100%', textAlign: 'left', display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px 6px 14px', borderRadius: 8, border: 'none', cursor: 'pointer', fontFamily: F, marginTop: 2, background: isActive ? '#fff' : 'transparent', boxShadow: isActive ? '0 1px 3px rgba(49,79,92,0.08)' : 'none', transition: 'all .1s' }}
                onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = 'rgba(49,79,92,0.04)'; }}
                onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}>
                <div style={{ width: 3, height: 28, borderRadius: 2, background: cfg.color, flexShrink: 0 }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: '.71rem', fontWeight: 500, color: '#0f1e28', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{(t.email || 'Unknown').split('@')[0]}</div>
                  <div style={{ fontSize: '.61rem', color: '#7a9aaa', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginTop: 1 }}>{t.subject}</div>
                </div>
              </button>
            );
          })}
        </div>

        {/* Channels */}
        <div style={{ marginBottom: 6 }}>
          <SectionHeader label="Channels" open={chOpen} onToggle={() => setChOpen(v => !v)} action={<button style={{ background: 'rgba(49,79,92,0.07)', border: 'none', borderRadius: 5, cursor: 'pointer', color: '#7a9aaa', width: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, lineHeight: 1 }} onClick={async () => {
              const name = window.prompt('New channel name (lowercase):');
              if (!name) return;
              const id = name.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
              if (!id) return;
              const { error } = await supabase.from('dispatch_channels').insert({ id, description: '', sort_order: channels.length + 1 });
              if (error) { alert('Could not create channel: ' + error.message); return; }
              const { data } = await supabase.from('dispatch_channels').select('*').order('sort_order', { ascending: true });
              if (data) { const loaded = data.map(c => ({ id: c.id, label: c.id, desc: c.description || '' })); CHANNELS = loaded; setChannels(loaded); }
            }}>+</button>} />
          {chOpen && channels.length === 0 && (
            [1, 2, 3].map(i => (
              <div key={i} style={{ padding: '5px 14px', display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: 'rgba(175,225,246,0.08)', flexShrink: 0 }}/>
                <div style={{ height: 7, borderRadius: 4, background: 'rgba(175,225,246,0.06)', width: (50 + i * 15) + '%', animation: 'sanoirePulse 1.6s ease-in-out ' + (i * 0.2) + 's infinite' }}/>
              </div>
            ))
          )}
          {chOpen && channels.length > 0 && (() => {
            const sq = sidebarSearch.trim().toLowerCase();
            // In search mode show hidden channels too (so user can reopen them)
            const visible = CHANNELS.filter(ch => {
              const matches = !sq || ch.label.toLowerCase().includes(sq) || (ch.desc || '').toLowerCase().includes(sq);
              return matches && (sq ? true : !hiddenChannels.has(ch.id));
            });
            return visible.map(ch => {
              const active = selected.type === 'channel' && selected.id === ch.id;
              const hasUnread = unreadChs.has(ch.id) && !active;
              const isHidden = hiddenChannels.has(ch.id);
              const isHov = hoveredCh === ch.id;
              return (
                <div key={ch.id} style={{ position: 'relative', marginBottom: 2 }}
                  onMouseEnter={() => setHoveredCh(ch.id)}
                  onMouseLeave={() => setHoveredCh(null)}>
                  <button
                    onClick={() => {
                      if (isHidden) setHiddenChannels(prev => { const n = new Set(prev); n.delete(ch.id); localStorage.setItem('dispatch_hidden_channels', JSON.stringify([...n])); return n; });
                      pick('channel', ch.id);
                    }}
                    style={{ width: '100%', textAlign: 'left', display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px',
                      borderRadius: 9, border: 'none', cursor: 'pointer', fontFamily: F,
                      background: active ? '#fff' : 'transparent',
                      boxShadow: active ? '0 1px 4px rgba(49,79,92,0.1), 0 0 0 1px rgba(49,79,92,0.07)' : 'none',
                      opacity: isHidden ? 0.5 : 1, transition: 'all .12s' }}>
                    <div style={{ width: 24, height: 24, borderRadius: 7, flexShrink: 0, background: active ? 'rgba(49,79,92,0.1)' : 'rgba(49,79,92,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke={active ? '#314F5C' : isHidden ? '#b0c8d4' : '#7a9aaa'} strokeWidth="1.7" strokeLinecap="round"><line x1="2" y1="5.5" x2="14" y2="5.5"/><line x1="2" y1="10.5" x2="14" y2="10.5"/><line x1="5.5" y1="2" x2="4.2" y2="14"/><line x1="11.8" y1="2" x2="10.5" y2="14"/></svg>
                    </div>
                    <span style={{ flex: 1, fontSize: '.76rem', color: active ? '#0f1e28' : hasUnread ? '#0f2a38' : isHidden ? '#9eb8c8' : '#5a7a8a', fontWeight: active ? 600 : hasUnread ? 600 : 400 }}>{ch.label}</span>
                    {isHidden && !isHov && <span style={{ fontSize: '.54rem', color: '#b8cfd8', fontWeight: 600, letterSpacing: '.06em', textTransform: 'uppercase', flexShrink: 0 }}>hidden</span>}
                    {hasUnread && !isHidden && <span style={{ width: 7, height: 7, borderRadius: '50%', background: t.accent, flexShrink: 0 }} />}
                  </button>
                  {/* Hide button — only on hover for non-hidden channels */}
                  {isHov && !isHidden && (
                    <button
                      onClick={ev => {
                        ev.stopPropagation();
                        const next = CHANNELS.find(c => !hiddenChannels.has(c.id) && c.id !== ch.id);
                        setHiddenChannels(prev => { const n = new Set(prev); n.add(ch.id); localStorage.setItem('dispatch_hidden_channels', JSON.stringify([...n])); return n; });
                        if (selected.type === 'channel' && selected.id === ch.id) pick('channel', next?.id || 'general');
                        setHoveredCh(null);
                      }}
                      title="Hide channel"
                      style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
                        width: 18, height: 18, borderRadius: 5, border: 'none',
                        background: 'rgba(49,79,92,0.1)', color: '#8aabba',
                        cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>
                      <svg width="7" height="7" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="1" y1="1" x2="11" y2="11"/><line x1="11" y1="1" x2="1" y2="11"/></svg>
                    </button>
                  )}
                  {/* Reopen button — only on hover for hidden channels (visible in search) */}
                  {isHov && isHidden && (
                    <button
                      onClick={ev => { ev.stopPropagation(); setHiddenChannels(prev => { const n = new Set(prev); n.delete(ch.id); localStorage.setItem('dispatch_hidden_channels', JSON.stringify([...n])); return n; }); pick('channel', ch.id); setHoveredCh(null); }}
                      title="Reopen channel"
                      style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
                        fontSize: '.58rem', padding: '2px 7px', borderRadius: 5,
                        border: '1px solid rgba(49,79,92,0.18)', background: t.panel,
                        color: '#314F5C', cursor: 'pointer', fontWeight: 600, fontFamily: F, whiteSpace: 'nowrap' }}>
                      Show
                    </button>
                  )}
                </div>
              );
            });
          })()}
        </div>

        {/* Calls */}
        <div style={{ marginBottom: 6 }}>
          <SectionHeader label="Calls" open={callOpen} onToggle={() => setCallOpen(v => !v)} />
          {callOpen && (
            <button onClick={() => pick('calls', 'teamroom')}
              onMouseEnter={e => { if (selected.type !== 'calls') e.currentTarget.style.background = 'rgba(49,79,92,0.05)'; }}
              onMouseLeave={e => { if (selected.type !== 'calls') e.currentTarget.style.background = 'transparent'; }}
              style={{ width: '100%', textAlign: 'left', display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px', borderRadius: 9, border: 'none', cursor: 'pointer', fontFamily: F, marginBottom: 2, background: selected.type === 'calls' ? '#fff' : 'transparent', boxShadow: selected.type === 'calls' ? '0 1px 4px rgba(49,79,92,0.1), 0 0 0 1px rgba(49,79,92,0.07)' : 'none', transition: 'all .12s' }}>
              <div style={{ width: 24, height: 24, borderRadius: 7, flexShrink: 0, background: selected.type === 'calls' ? 'rgba(49,79,92,0.1)' : 'rgba(49,79,92,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={selected.type === 'calls' ? '#314F5C' : '#7a9aaa'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 10l4.553-2.069A1 1 0 0121 8.82v6.36a1 1 0 01-1.447.89L15 14"/><rect x="1" y="6" width="14" height="12" rx="3"/></svg>
              </div>
              <span style={{ flex: 1, fontSize: '.76rem', color: selected.type === 'calls' ? '#0f1e28' : '#5a7a8a', fontWeight: selected.type === 'calls' ? 600 : 400 }}>Team Room</span>
              {videoActive && <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#28a745', flexShrink: 0 }} />}
              {selected.type === 'calls' && !videoActive && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="rgba(49,79,92,0.3)" strokeWidth="2" strokeLinecap="round"><polyline points="9 18 15 12 9 6"/></svg>}
            </button>
          )}
        </div>

        {/* Direct Messages */}
        <div style={{ paddingBottom: 8 }}>
          <SectionHeader label="Direct Messages" open={dmOpen} onToggle={() => setDmOpen(v => !v)} />
          {/* Claude presence entry — shown when Claude is actively working */}
          {dmOpen && onlineUsers['AI'] && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px', borderRadius: 9, marginBottom: 2, background: 'rgba(49,79,92,0.04)' }}>
              <div style={{ position: 'relative', flexShrink: 0 }}>
                <div style={{ width: 26, height: 26, borderRadius: 8, background: '#1a3040', color: '#AFE1F6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.6rem', fontWeight: 700 }}>AI</div>
                <div style={{ position: 'absolute', bottom: -1, right: -1, width: 7, height: 7, borderRadius: '50%', background: '#2da06a', border: '1.5px solid #edf2f5', boxShadow: '0 0 4px rgba(45,160,106,0.4)' }} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '.76rem', color: '#0f1e28', fontWeight: 500 }}>Claude</div>
                <div style={{ fontSize: '.6rem', color: '#2da06a', marginTop: 1 }}>
                  {'● '}{onlineUsers['AI']?.screen || 'Working on Sanoire'}
                </div>
              </div>
            </div>
          )}
          {dmOpen && teamMembers.length === 0 && (
            [1, 2, 3, 4].map(i => (
              <div key={i} style={{ padding: '5px 10px', display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
                <div style={{ width: 22, height: 22, borderRadius: 6, background: 'rgba(175,225,246,0.08)', flexShrink: 0 }}/>
                <div style={{ height: 7, borderRadius: 4, background: 'rgba(175,225,246,0.06)', width: (40 + i * 12) + '%', animation: 'sanoirePulse 1.6s ease-in-out ' + (i * 0.15) + 's infinite' }}/>
              </div>
            ))
          )}
          {dmOpen && teamMembers.length > 0 && (() => {
            const sq = sidebarSearch.trim().toLowerCase();
            // Filter: match search + respect hidden (show hidden in search so user can reopen)
            const visible = TEAM.filter(m => {
              const matchesSearch = !sq || m.name.toLowerCase().includes(sq) || m.initials.toLowerCase().includes(sq);
              if (!matchesSearch) return false;
              const isActive = selected.type === 'dm' && selected.id === m.initials;
              return isActive || (sq ? true : !hiddenDms.has(m.initials));
            });
            if (visible.length === 0 && sq) return (
              <div style={{ padding: '8px 10px', fontSize: '.71rem', color: '#9eb8c8', fontStyle: 'italic' }}>No people match "{sq}"</div>
            );
            return visible.map(m => {
              const active = selected.type === 'dm' && selected.id === m.initials;
              const isHidden = hiddenDms.has(m.initials);
              const isHov = hoveredDm === m.initials;
              return (
                <div key={m.initials} style={{ position: 'relative', marginBottom: 2 }}
                  onMouseEnter={() => setHoveredDm(m.initials)}
                  onMouseLeave={() => setHoveredDm(null)}>
                  <button
                    onClick={() => {
                      if (isHidden) setHiddenDms(prev => { const n = new Set(prev); n.delete(m.initials); localStorage.setItem('dispatch_hidden_dms', JSON.stringify([...n])); return n; });
                      pick('dm', m.initials);
                    }}
                    style={{ width: '100%', textAlign: 'left', display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px',
                      borderRadius: 9, border: 'none', cursor: 'pointer', fontFamily: F,
                      background: active ? '#fff' : 'transparent',
                      boxShadow: active ? '0 1px 4px rgba(49,79,92,0.1), 0 0 0 1px rgba(49,79,92,0.07)' : 'none',
                      opacity: isHidden ? 0.5 : 1, transition: 'all .12s' }}>
                    <div style={{ position: 'relative', flexShrink: 0 }}>
                      <Avatar initials={m.initials} color={m.color} textColor={m.text} size={26} />
                      {(() => { const isOnline = !!onlineUsers[m.initials]; return (
                        <div style={{ position: 'absolute', bottom: -1, right: -1, width: 7, height: 7, borderRadius: '50%',
                          background: isOnline ? '#2da06a' : '#c8d8de', border: '1.5px solid #edf2f5',
                          boxShadow: isOnline ? '0 0 4px rgba(45,160,106,0.4)' : 'none' }}
                          title={isOnline ? (onlineUsers[m.initials]?.screen ? 'Online · ' + (SCREEN_LABELS[onlineUsers[m.initials].screen] || onlineUsers[m.initials].screen) : 'Online') : 'Offline'}
                        />
                      ); })()}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: '.76rem', color: active ? '#0f1e28' : isHidden ? '#9eb8c8' : '#4a6a7a', fontWeight: active ? 600 : 400 }}>{m.name}</div>
                      {isHidden && !isHov && <div style={{ fontSize: '.58rem', color: '#b8cfd8', marginTop: 1, textTransform: 'uppercase', letterSpacing: '.06em', fontWeight: 600 }}>hidden</div>}
                    </div>
                  </button>
                  {/* Hover actions: call + close — only for non-hidden */}
                  {isHov && !isHidden && (
                    <div style={{ position: 'absolute', right: 7, top: '50%', transform: 'translateY(-50%)', display: 'flex', gap: 3 }}>
                      <button onClick={ev => { ev.stopPropagation(); startDmCall(m); }} title={'Call ' + m.name}
                        style={{ width: 22, height: 22, borderRadius: 6, border: 'none', background: 'rgba(49,79,92,0.08)', color: '#314F5C', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>
                        <svg width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.2' strokeLinecap='round'><path d='M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .84h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.28a16 16 0 006.29 6.29l1.46-1.46a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 15.31z'/></svg>
                      </button>
                      <button
                        onClick={ev => {
                          ev.stopPropagation();
                          setHiddenDms(prev => { const n = new Set(prev); n.add(m.initials); localStorage.setItem('dispatch_hidden_dms', JSON.stringify([...n])); return n; });
                          setDmMsgs(prev => { const n = { ...prev }; delete n[m.initials]; return n; });
                          if (selected.type === 'dm' && selected.id === m.initials) pick('channel', 'general');
                          setHoveredDm(null);
                        }}
                        title="Close DM"
                        style={{ width: 22, height: 22, borderRadius: 6, border: 'none', background: 'rgba(49,79,92,0.08)', color: '#8aabba', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>
                        <svg width='7' height='7' viewBox='0 0 12 12' fill='none' stroke='currentColor' strokeWidth='2.2' strokeLinecap='round'><line x1='1' y1='1' x2='11' y2='11'/><line x1='11' y1='1' x2='1' y2='11'/></svg>
                      </button>
                    </div>
                  )}
                  {/* Hover actions for hidden DMs (visible via search): reopen */}
                  {isHov && isHidden && (
                    <button
                      onClick={ev => { ev.stopPropagation(); setHiddenDms(prev => { const n = new Set(prev); n.delete(m.initials); localStorage.setItem('dispatch_hidden_dms', JSON.stringify([...n])); return n; }); pick('dm', m.initials); setHoveredDm(null); }}
                      title="Reopen DM"
                      style={{ position: 'absolute', right: 7, top: '50%', transform: 'translateY(-50%)',
                        fontSize: '.58rem', padding: '2px 7px', borderRadius: 5,
                        border: '1px solid rgba(49,79,92,0.18)', background: t.panel,
                        color: '#314F5C', cursor: 'pointer', fontWeight: 600, fontFamily: F, whiteSpace: 'nowrap' }}>
                      Reopen
                    </button>
                  )}
                </div>
              );
            });
          })()}
        </div>

      </div>
    </div>
  );

  let headerName = '', headerSub = '', headerActions = null;
  if (selected.type === 'ticket' && selTicket) {
    const cfg = STATUS_CFG[selTicket.status] || STATUS_CFG.open;
    headerName = (selTicket.email || '').split('@')[0];
    headerSub  = selTicket.subject;
    headerActions = isMobile ? (
      <div style={{ display: 'flex', gap: 5, flexShrink: 0, alignItems: 'center' }}>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: cfg.color, flexShrink: 0 }} />
        {selTicket.status !== 'resolved'
          ? <button onClick={() => setStatus('resolved')} style={{ padding: '5px 10px', background: '#819D84', color: '#fff', border: 'none', borderRadius: 7, fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: F }}>Resolve</button>
          : <button onClick={() => setStatus('open')} style={{ padding: '5px 10px', background: 'transparent', color: '#7a9aaa', border: '1px solid #d2dde4', borderRadius: 7, fontSize: 11, cursor: 'pointer', fontFamily: F }}>Reopen</button>
        }
      </div>
    ) : (
      <div style={{ display: 'flex', gap: 6, flexShrink: 0, alignItems: 'center' }}>
        <span style={{ padding: '3px 9px', borderRadius: 999, fontSize: 11, fontWeight: 500, background: cfg.bg, color: cfg.color }}>{cfg.label}</span>
        {selTicket.status !== 'resolved' ? (
          <>
            {selTicket.status !== 'in_progress' && <button onClick={() => setStatus('in_progress')} style={{ padding: '4px 10px', background: '#6F8FA7', color: '#fff', border: 'none', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: F }}>In Progress</button>}
            <button onClick={() => setStatus('resolved')} style={{ padding: '4px 10px', background: '#819D84', color: '#fff', border: 'none', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: F }}>Resolve</button>
          </>
        ) : (
          <button onClick={() => setStatus('open')} style={{ padding: '4px 10px', background: 'transparent', color: '#7a9aaa', border: '1px solid #d2dde4', borderRadius: 6, fontSize: 11, cursor: 'pointer', fontFamily: F }}>Reopen</button>
        )}
      </div>
    );
  } else if (selected.type === 'channel') {
    const ch = CHANNELS.find(c => c.id === selected.id);
    headerName = ch ? '# ' + ch.label : '# ' + selected.id;
    headerSub = '';
    const _chActiveCall = activeChannelCalls[selected.id];
    const _chIsMyCall   = myActiveChannelId === selected.id;
    // ── Call button: three states ─────────────────────────────────────────
    const _callBtn = _chActiveCall ? (
      _chIsMyCall ? (
        // I started this call — show inline controls
        <div style={{ display: 'flex', alignItems: 'center', gap: 7, flexShrink: 0 }}>
          {/* Live timer pill */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 10px 5px 8px',
            background: 'linear-gradient(135deg,#061a0f 0%,#092017 100%)',
            border: '1.5px solid rgba(45,160,106,0.3)', borderRadius: 99 }}>
            <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#2da06a', flexShrink: 0,
              boxShadow: '0 0 5px rgba(45,160,106,0.6)', display: 'inline-block',
              animation: 'soLivePulse 1.8s ease-in-out infinite' }} />
            <span style={{ fontSize: '.71rem', fontWeight: 700, color: '#4ade98',
              fontVariantNumeric: 'tabular-nums', letterSpacing: '.04em' }}>
              {String(Math.floor(chCallDuration/60)).padStart(2,'0')}:{String(chCallDuration%60).padStart(2,'0')}
            </span>
          </div>
          {/* Mic toggle */}
          <button onClick={() => {
                  setChCallMuted(m => !m);
                  // Send mute command to Daily.co iframe
                  const iframe = document.querySelector('iframe[title="Sanoire Video"]');
                  if (iframe?.contentWindow) {
                    iframe.contentWindow.postMessage(
                      JSON.stringify({ action: chCallMuted ? 'unmute-audio' : 'mute-audio' }), '*'
                    );
                  }
                }} title={chCallMuted ? 'Unmute' : 'Mute'}
            style={{ width: 32, height: 32, borderRadius: 9, border: 'none',
              background: chCallMuted ? 'rgba(239,83,80,0.15)' : 'rgba(49,79,92,0.08)',
              cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
              transition: 'background .15s' }}>
            <svg width='13' height='13' viewBox='0 0 24 24' fill='none'
              stroke={chCallMuted ? '#ef7070' : '#314F5C'} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
              {chCallMuted
                ? <><line x1='1' y1='1' x2='23' y2='23'/><path d='M9 9v3a3 3 0 005.12 2.12M15 9.34V4a3 3 0 00-5.94-.6'/><path d='M17 16.95A7 7 0 015 12v-2m14 0v2a7 7 0 01-.11 1.23'/><line x1='12' y1='19' x2='12' y2='23'/><line x1='8' y1='23' x2='16' y2='23'/></>
                : <><path d='M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z'/><path d='M19 10v2a7 7 0 01-14 0v-2'/><line x1='12' y1='19' x2='12' y2='23'/><line x1='8' y1='23' x2='16' y2='23'/></>
              }
            </svg>
          </button>
          {/* End Call */}
          <button onClick={() => endChannelCall(selected.id)}
            style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 13px', borderRadius: 99,
              background: 'linear-gradient(135deg,#c62828 0%,#a31b1b 100%)', border: 'none', cursor: 'pointer',
              color: '#fff', fontSize: '.72rem', fontWeight: 700, fontFamily: 'inherit',
              boxShadow: '0 1px 0 rgba(0,0,0,0.2) inset, 0 2px 8px rgba(198,40,40,0.4)', letterSpacing: '.01em' }}>
            <svg width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round'><path d='M10.68 13.31a16 16 0 003.41 2.6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.42 19.42 0 01-3.33-2.67m-2.67-3.34a19.79 19.79 0 01-3.07-8.63A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91M23 1L1 23'/></svg>
            End Call
          </button>
        </div>
      ) : (
        // Someone else started — show Join Call with live pulse
        <button onClick={() => startChannelCall(selected.id)}
          style={{ display: 'flex', alignItems: 'center', gap: 7, padding: '6px 13px', borderRadius: 99,
            background: 'linear-gradient(135deg,#1a4a35 0%,#0f2f22 100%)',
            border: '1.5px solid rgba(45,160,106,0.45)', cursor: 'pointer',
            color: '#4ade98', fontSize: '.72rem', fontWeight: 700, fontFamily: 'inherit',
            boxShadow: '0 0 0 3px rgba(45,160,106,0.1), 0 2px 8px rgba(45,160,106,0.25)', letterSpacing: '.01em' }}>
          <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#2da06a', flexShrink: 0,
            boxShadow: '0 0 0 2px rgba(45,160,106,0.25)', display: 'inline-block',
            animation: 'sanoirePulse 2s ease-in-out infinite' }} />
          Join Call
        </button>
      )
    ) : (
      // No active call — teal Call button matching admin design system
      <button onClick={() => startChannelCall(selected.id)}
        style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 13px', borderRadius: 99,
          background: t.accent, border: 'none', cursor: 'pointer',
          color: '#E0F5FC', fontSize: '.72rem', fontWeight: 700, fontFamily: 'inherit',
          boxShadow: '0 1px 0 rgba(0,0,0,0.12) inset, 0 2px 6px rgba(49,79,92,0.3)', letterSpacing: '.01em', transition: 'background .12s' }}>
        <svg width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round'><path d='M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .84h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.28a16 16 0 006.29 6.29l1.46-1.46a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 15.31z'/></svg>
        Call
      </button>
    );
    // Mobile call button: icon-only, same three states
    const _callBtnMobile = _chActiveCall ? (
      _chIsMyCall ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <span style={{ fontSize: '.65rem', fontWeight: 700, color: '#4ade98', fontVariantNumeric: 'tabular-nums',
            background: 'linear-gradient(135deg,#061a0f,#092017)', border: '1px solid rgba(45,160,106,0.3)',
            borderRadius: 99, padding: '4px 8px' }}>
            {String(Math.floor(chCallDuration/60)).padStart(2,'0')}:{String(chCallDuration%60).padStart(2,'0')}
          </span>
          <button onClick={() => {
                  setChCallMuted(m => !m);
                  // Send mute command to Daily.co iframe
                  const iframe = document.querySelector('iframe[title="Sanoire Video"]');
                  if (iframe?.contentWindow) {
                    iframe.contentWindow.postMessage(
                      JSON.stringify({ action: chCallMuted ? 'unmute-audio' : 'mute-audio' }), '*'
                    );
                  }
                }} title={chCallMuted ? 'Unmute' : 'Mute'}
            style={{ width: 32, height: 32, borderRadius: 9, border: 'none',
              background: chCallMuted ? 'rgba(239,83,80,0.15)' : 'rgba(49,79,92,0.08)',
              cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width='13' height='13' viewBox='0 0 24 24' fill='none'
              stroke={chCallMuted ? '#ef7070' : '#314F5C'} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
              {chCallMuted
                ? <><line x1='1' y1='1' x2='23' y2='23'/><path d='M9 9v3a3 3 0 005.12 2.12M15 9.34V4a3 3 0 00-5.94-.6'/><path d='M17 16.95A7 7 0 015 12v-2m14 0v2a7 7 0 01-.11 1.23'/><line x1='12' y1='19' x2='12' y2='23'/><line x1='8' y1='23' x2='16' y2='23'/></>
                : <><path d='M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z'/><path d='M19 10v2a7 7 0 01-14 0v-2'/><line x1='12' y1='19' x2='12' y2='23'/><line x1='8' y1='23' x2='16' y2='23'/></>
              }
            </svg>
          </button>
          <button onClick={() => endChannelCall(selected.id)} title='End call'
            style={{ width: 34, height: 34, borderRadius: 99, background: 'linear-gradient(135deg,#c62828 0%,#a31b1b 100%)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', boxShadow: '0 2px 8px rgba(198,40,40,0.4)' }}>
            <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round'><path d='M10.68 13.31a16 16 0 003.41 2.6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.42 19.42 0 01-3.33-2.67m-2.67-3.34a19.79 19.79 0 01-3.07-8.63A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91M23 1L1 23'/></svg>
          </button>
        </div>
      ) : (
        <button onClick={() => startChannelCall(selected.id)} title='Join call' style={{ width: 34, height: 34, borderRadius: 99, background: 'linear-gradient(135deg,#1a4a35 0%,#0f2f22 100%)', border: '1.5px solid rgba(45,160,106,0.45)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#4ade98', boxShadow: '0 0 0 3px rgba(45,160,106,0.1)' }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#2da06a', animation: 'sanoirePulse 2s ease-in-out infinite', display: 'inline-block' }} />
        </button>
      )
    ) : (
      <button onClick={() => startChannelCall(selected.id)} title='Call' style={{ width: 34, height: 34, borderRadius: 99, background: t.accent, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#E0F5FC', boxShadow: '0 2px 6px rgba(49,79,92,0.3)' }}>
        <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round'><path d='M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .84h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.28a16 16 0 006.29 6.29l1.46-1.46a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 15.31z'/></svg>
      </button>
    );
    headerActions = isMobile ? (
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
        {_callBtnMobile}
        <button onClick={() => { setShowSearch(v => !v); setSearchQuery(''); }} title='Search' style={{ width: 32, height: 32, borderRadius: 8, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', background: showSearch ? 'rgba(49,79,92,0.08)' : 'transparent', color: showSearch ? '#314F5C' : '#9eb8c8' }}>
          <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'><circle cx='11' cy='11' r='8'/><line x1='21' y1='21' x2='16.65' y2='16.65'/></svg>
        </button>
      </div>
    ) : (
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
        {_callBtn}
        <div style={{ display: 'flex', alignItems: 'center', marginRight: 4 }}>
          {teamMembers.filter(t => t.online).map((t, i) => (<div key={t.initials} title={t.name} style={{ marginLeft: i > 0 ? -6 : 0, zIndex: 3-i, position: 'relative' }}><div style={{ width: 24, height: 24, borderRadius: 7, background: t.color, color: t.text, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.5rem', fontWeight: 700, border: '1.5px solid #fff' }}>{t.initials}</div><div style={{ position: 'absolute', bottom: -1, right: -1, width: 6, height: 6, borderRadius: '50%', background: '#2da06a', border: '1.5px solid #fff' }} /></div>))}
        </div>
        <select value={translateLang} onChange={e => setLang(e.target.value)} title='Translate messages to'
          style={{ fontSize: '.62rem', border: '1px solid #e4edf3', borderRadius: 7, padding: '3px 5px',
            background: '#f8fafc', color: '#314F5C', cursor: 'pointer', fontFamily: 'inherit', maxWidth: 80 }}>
          {[['en','EN'],['es','ES'],['fr','FR'],['de','DE'],['ja','JA'],['zh','ZH'],['ar','AR'],['pt','PT'],['ko','KO'],['th','TH'],['vi','VI'],['km','KM'],['id','ID'],['hi','HI']].map(([code, label]) => (
            <option key={code} value={code}>{label}</option>
          ))}
        </select>
        <div style={{ width: 1, height: 18, background: '#e8eef2', margin: '0 2px' }} />
        <button onClick={() => { setShowSearch(v => !v); setSearchQuery(''); }} title='Search' style={{ width: 30, height: 30, borderRadius: 7, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', background: showSearch ? 'rgba(49,79,92,0.08)' : 'transparent', color: showSearch ? '#314F5C' : '#7a9aaa', transition: 'all .12s' }} onMouseEnter={e => { if (!showSearch) e.currentTarget.style.background='#f4f7f9'; }} onMouseLeave={e => { if (!showSearch) e.currentTarget.style.background='transparent'; }}><svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'><circle cx='11' cy='11' r='8'/><line x1='21' y1='21' x2='16.65' y2='16.65'/></svg></button>
        <button onClick={() => setShowPinned(v => !v)} title='Pinned' style={{ width: 30, height: 30, borderRadius: 7, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', background: showPinned ? 'rgba(49,79,92,0.08)' : 'transparent', color: showPinned ? '#314F5C' : '#7a9aaa', position: 'relative', transition: 'all .12s' }} onMouseEnter={e => { if (!showPinned) e.currentTarget.style.background='#f4f7f9'; }} onMouseLeave={e => { if (!showPinned) e.currentTarget.style.background='transparent'; }}><svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'><line x1='12' y1='17' x2='12' y2='22'/><path d='M5 17h14v-1.76a2 2 0 00-1.11-1.79l-1.78-.9A2 2 0 0015 10.76V6h1a2 2 0 000-4H8a2 2 0 000 4h1v4.76a2 2 0 01-1.11 1.79l-1.78.9A2 2 0 005 15.24V17z'/></svg>{pinnedMsgs.length > 0 && <span style={{ position: 'absolute', top: 3, right: 3, width: 12, height: 12, borderRadius: '50%', background: t.accent, color: '#fff', fontSize: '.46rem', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{pinnedMsgs.length}</span>}</button>
      </div>
    );
  } else if (selected.type === 'calls') {
    headerName = 'Team Room';
    headerSub = videoActive ? 'Call in progress' : 'Video & audio calls';
    if (videoActive) {
      headerActions = (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
          {videoRecording && (
            <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '.63rem', color: '#c62828', fontWeight: 500 }}>
              <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#c62828', display: 'inline-block', animation: 'pulse 1.2s ease-in-out infinite' }} />REC
            </span>
          )}
          {!videoRecording && (
            <button onClick={startRecording} title='Record session' style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 12px', background: 'transparent', border: '1.5px solid #c8dce8', borderRadius: 8, cursor: 'pointer', color: '#5a7a8a', fontSize: 11, fontWeight: 500, fontFamily: F, transition: 'all .13s' }} onMouseEnter={e => { e.currentTarget.style.borderColor='#a0bcd0'; }} onMouseLeave={e => { e.currentTarget.style.borderColor='#c8dce8'; }}>
              <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='#c62828' strokeWidth='2' strokeLinecap='round'><circle cx='12' cy='12' r='6' fill='rgba(198,40,40,0.25)'/><circle cx='12' cy='12' r='10'/></svg>
            </button>
          )}
          <button onClick={endCall} style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '6px 14px', background: '#c62828', color: '#fff', border: 'none', borderRadius: 99, fontSize: 11, fontWeight: 700, cursor: 'pointer', fontFamily: F, boxShadow: '0 1px 0 rgba(0,0,0,0.15) inset, 0 2px 6px rgba(198,40,40,0.3)' }}>End call</button>
        </div>
      );
    }
  } else if (selected.type === 'dm') {
    const m = TEAM.find(t => t.initials === selected.id);
    headerName = m?.name || selected.id;
    const dmCallActive = activeDmCall?.memberInitials === selected.id;
    const callMins = String(Math.floor(callElapsed / 60)).padStart(2, '0');
    const callSecs = String(callElapsed % 60).padStart(2, '0');
    headerSub = dmCallActive ? null : (!!onlineUsers[selected.id] ? 'Active now' : 'Away');
    headerActions = dmCallActive ? (
      // Active DM call — timer pill + End Call, matching channel style
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 7, padding: '5px 11px 5px 9px',
          background: 'linear-gradient(135deg,#061a0f 0%,#092017 100%)',
          border: '1.5px solid rgba(45,160,106,0.3)', borderRadius: 99 }}>
          <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#2da06a', flexShrink: 0,
            boxShadow: '0 0 6px rgba(45,160,106,0.7)', display: 'inline-block',
            animation: 'sanoirePulse 2s ease-in-out infinite' }} />
          <span style={{ fontSize: '.71rem', fontWeight: 700, color: '#4ade98',
            fontVariantNumeric: 'tabular-nums', letterSpacing: '.04em' }}>{callMins}:{callSecs}</span>
        </div>
        <button onClick={endDmCall}
          style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 13px',
            background: 'linear-gradient(135deg,#c62828 0%,#a31b1b 100%)',
            border: 'none', borderRadius: 99, cursor: 'pointer', color: '#fff',
            fontSize: '.72rem', fontWeight: 700, fontFamily: F,
            boxShadow: '0 1px 0 rgba(0,0,0,0.2) inset, 0 2px 8px rgba(198,40,40,0.4)',
            letterSpacing: '.01em' }}>
          <svg width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round'><path d='M10.68 13.31a16 16 0 003.41 2.6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.42 19.42 0 01-3.33-2.67m-2.67-3.34a19.79 19.79 0 01-3.07-8.63A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91M23 1L1 23'/></svg>
          End Call
        </button>
      </div>
    ) : (
      // Idle — phone icon + 'Call', matching channel button style exactly
      <button onClick={() => m && startDmCall(m)} disabled={!!dmCallLoading}
        style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 13px',
          background: dmCallLoading ? 'rgba(45,160,106,0.45)' : 'linear-gradient(135deg,#2da06a 0%,#1e8a57 100%)',
          border: 'none', borderRadius: 99, cursor: dmCallLoading ? 'not-allowed' : 'pointer',
          color: '#fff', fontSize: '.72rem', fontWeight: 700, fontFamily: F,
          boxShadow: dmCallLoading ? 'none' : '0 1px 0 rgba(0,0,0,0.15) inset, 0 2px 8px rgba(45,160,106,0.35)',
          letterSpacing: '.01em', transition: 'all .15s' }}>
        {dmCallLoading === (m && m.initials) ? (
          <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' style={{ animation: 'sanoireSpin 0.9s linear infinite' }}><path d='M21 12a9 9 0 11-6.219-8.56'/></svg>
        ) : (
          <svg width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round'><path d='M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .84h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.28a16 16 0 006.29 6.29l1.46-1.46a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 15.31z'/></svg>
        )}
        {dmCallLoading === (m && m.initials) ? 'Starting…' : 'Call'}
      </button>
    );
  }

  let msgs = [];
  if (selected.type === 'ticket' && selTicket) {
    msgs = [
      { id: 'orig', isAdmin: false, avatar: (selTicket.email||'?')[0].toUpperCase(), name: selTicket.email, time: selTicket.created_at, text: selTicket.message },
      ...ticketMsgs.map(r => ({ id: r.id, isAdmin: r.author === 'admin', avatar: r.author === 'admin' ? 'S' : (selTicket.email||'?')[0].toUpperCase(), name: r.author === 'admin' ? 'Sanoire' : selTicket.email, time: r.created_at, text: r.message })),
    ];
  } else if (selected.type === 'channel') {
    msgs = (chMsgs[selected.id] || []);
  } else if (selected.type === 'dm') {
    msgs = (dmMsgs[selected.id] || []);
  }

  // ── @mention detection ────────────────────────────────────────────────
  const typingBroadcastTimer = React.useRef(null);

  async function translateMsg(msgId, text) {
    // Toggle off if already visible
    if (translations[msgId]?.visible) {
      setTranslations(prev => ({ ...prev, [msgId]: { ...prev[msgId], visible: false } }));
      return;
    }
    // Already translated — just show it
    if (translations[msgId]?.text) {
      setTranslations(prev => ({ ...prev, [msgId]: { ...prev[msgId], visible: true } }));
      return;
    }
    setTranslations(prev => ({ ...prev, [msgId]: { loading: true, visible: true } }));
    try {
      const targetLang = translateLang === 'en' ? 'English' : new Intl.DisplayNames(['en'], { type: 'language' }).of(translateLang) || translateLang;
      const res = await fetch('https://api.anthropic.com/v1/messages', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'anthropic-dangerous-direct-browser-access': 'true' },
        body: JSON.stringify({
          model: 'claude-haiku-4-5-20251001',
          max_tokens: 512,
          messages: [{ role: 'user', content: 'Translate the following message to ' + targetLang + '. Reply with ONLY the translation, no explanation, no quotes:\n\n' + text }],
        })
      });
      const data = await res.json();
      const translated = data.content?.[0]?.text?.trim() || 'Translation failed';
      setTranslations(prev => ({ ...prev, [msgId]: { text: translated, loading: false, visible: true } }));
    } catch (_e) {
      setTranslations(prev => ({ ...prev, [msgId]: { text: 'Translation failed.', loading: false, visible: true } }));
    }
  }

  function setLang(lang) {
    setTranslateLang(lang);
    localStorage.setItem('sanoire_dispatch_lang', lang);
    setTranslations({}); // clear cached translations when language changes
  }

  function handleInputChange(val, setter) {
    setter(val);
    const atMatch = val.match(/@(\w*)$/);
    if (atMatch) { setMentionQuery(atMatch[1]); setShowMentions(true); }
    else { setShowMentions(false); setMentionQuery(''); }
    if (val.trim()) {
      broadcastTyping(true);
      if (typingBroadcastTimer.current) clearTimeout(typingBroadcastTimer.current);
      typingBroadcastTimer.current = setTimeout(() => broadcastTyping(false), 3000);
    } else { broadcastTyping(false); }
  }

  const mentionResults = showMentions
    ? TEAM.filter(t => t.name.toLowerCase().startsWith(mentionQuery.toLowerCase()))
    : [];

  function insertMention(name) {
    const setter = selected.type === 'dm' ? setDmInput : setChInput;
    const val    = selected.type === 'dm' ? dmInput : chInput;
    setter(val.replace(/@\w*$/, '@' + name + ' '));
    setShowMentions(false);
  }

  const inputValue = selected.type === 'ticket' ? replyText : selected.type === 'dm' ? dmInput : chInput;
  const inputSet   = selected.type === 'ticket' ? setReplyText : selected.type === 'dm' ? setDmInput : setChInput;
  const inputSend  = selected.type === 'ticket' ? sendTicketReply : selected.type === 'dm' ? sendDm : sendChannelMsg;
  const inputPH    = selected.type === 'ticket' ? 'Reply to customer…' : selected.type === 'dm' ? ('Message ' + headerName + '…') : ('Message ' + headerName + '…');
  const isResolved = selected.type === 'ticket' && selTicket?.status === 'resolved';

  const QUICK_REACT = ['__sanoire__','👍','❤️','🔥','✅','👀','😂'];
  const REACTION_COLORS = {
    '__sanoire__': { bg: 'rgba(175,225,246,0.18)', border: 'rgba(111,190,224,0.45)', cnt: '#1a4a5c' },
    '👍': { bg: 'rgba(49,79,92,0.07)',    border: 'rgba(49,79,92,0.22)',    cnt: '#314F5C' },
    '👎': { bg: 'rgba(159,126,79,0.07)',  border: 'rgba(159,126,79,0.22)',  cnt: '#7a5f35' },
    '❤️': { bg: 'rgba(201,64,64,0.07)',   border: 'rgba(201,64,64,0.22)',   cnt: '#c94040' },
    '🔥': { bg: 'rgba(185,156,109,0.09)', border: 'rgba(185,156,109,0.26)', cnt: '#9a7632' },
    '✅': { bg: 'rgba(129,157,132,0.09)', border: 'rgba(129,157,132,0.26)', cnt: '#4d7550' },
    '👀': { bg: 'rgba(111,143,167,0.09)', border: 'rgba(111,143,167,0.24)', cnt: '#4a7a9a' },
    '😂': { bg: 'rgba(175,225,246,0.16)', border: 'rgba(111,143,167,0.22)', cnt: '#3a7a9a' },
    '🎉': { bg: 'rgba(185,156,109,0.09)', border: 'rgba(185,156,109,0.26)', cnt: '#9a7632' },
    '🙌': { bg: 'rgba(49,79,92,0.07)',    border: 'rgba(49,79,92,0.22)',    cnt: '#314F5C' },
    '🚀': { bg: 'rgba(111,143,167,0.09)', border: 'rgba(111,143,167,0.24)', cnt: '#4a7a9a' },
  };
  const REACTION_DEFAULT = { bg: 'rgba(49,79,92,0.07)', border: 'rgba(49,79,92,0.22)', cnt: '#314F5C' };
  const getReactionColor = (e) => REACTION_COLORS[e] || REACTION_DEFAULT;

  // ── Video helpers ────────────────────────────────────────────────────────

  async function startCall() {
    // LiveKit path — no Daily room needed; the room IS the channel/team name.
    if (LIVEKIT_URL) {
      setVideoError(null);
      setVideoStartTime(new Date().toISOString());
      try {
        const { data: sessionData } = await supabase.from('call_video_sessions').insert({
          room_name: videoRoomName, room_url: 'livekit:' + videoRoomName,
          started_by: me?.name || 'Admin', participants: [me?.name || 'Admin'],
          session_type: 'video', status: 'active',
        }).select().single();
        if (sessionData) setVideoSessionId(sessionData.id);
      } catch (_e) {}
      setVideoActive(true);
      window.dispatchEvent(new CustomEvent('sanoire:hideoverlay'));
      return;
    }
    if (!DAILY_DOMAIN || !DAILY_API_KEY) {
      setVideoError('Daily.co credentials not configured. Add REACT_APP_DAILY_DOMAIN and REACT_APP_DAILY_API_KEY to environment variables.');
      return;
    }
    setVideoLoading(true);
    setVideoError(null);
    try {
      // Room may already exist (created by newRoom on mount) — reuse it if so
      let roomUrl = videoRoomUrl || ('https://' + DAILY_DOMAIN + '/' + videoRoomName);
      if (!videoRoomUrl) {
        const res = await fetch('/api/create-room', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ room_name: videoRoomName, expiry_hours: 24 }),
        });
        const room = await res.json();
        if (!res.ok) throw new Error(room.error || 'Failed to create room');
        roomUrl = room.room_url || roomUrl;
      }
      setVideoRoomUrl(roomUrl);
      setVideoStartTime(new Date().toISOString());
      const { data: sessionData } = await supabase.from('call_video_sessions').insert({
        room_name: videoRoomName, room_url: roomUrl,
        started_by: me?.name || 'Admin', participants: [me?.name || 'Admin'],
        session_type: 'video',
        status: 'active',
      }).select().single();
      if (sessionData) setVideoSessionId(sessionData.id);
      // Fetch a meeting token so we don't expose the API key in the iframe
      try {
        const tokenRes = await fetch('/api/meeting-token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ room_name: videoRoomName, user_name: me?.name || 'Admin' }),
        });
        const tokenData = await tokenRes.json();
        if (tokenData.token) setMeetingToken(tokenData.token);
      } catch (_e) { /* token fetch failed — will fall back to no-token join */ }
      setVideoActive(true);
      // Notify FloatingCallOverlay + Layout header pill
      window.dispatchEvent(new CustomEvent('sanoire:startcall', {
        detail: { type: 'video', id: videoRoomName, name: 'Team Room', roomUrl }
      }));
      // Hide the floating overlay — Team Room has inline video controls
      window.dispatchEvent(new CustomEvent('sanoire:hideoverlay'));
    } catch (err) {
      setVideoError(err.message || 'Could not start call.');
    } finally {
      setVideoLoading(false);
    }
  }

  async function startRecording() {
    if (!videoSessionId || !DAILY_API_KEY) return;
    try {
      await fetch('/api/create-room', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'start_recording', room_name: videoRoomName }),
      });
      setVideoRecording(true);
    } catch (_e) {}
  }

  async function startDmCall(member) {
    if (!DAILY_DOMAIN || !DAILY_API_KEY) return;
    setDmCallLoading(member.initials);
    // Create a deterministic room name for this DM pair
    const pair = [me?.initials || 'ME', member.initials].sort().join('-').toLowerCase();
    const dmRoomName = 'sanoire-dm-' + pair;
    try {
      const res = await fetch('/api/create-room', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ room_name: dmRoomName, expiry_hours: 168 }),
      });
      const room = await res.json();
      if (!res.ok && !room.room_url) throw new Error(room.error || 'Failed to create room');
      const roomUrl = room.room_url || ('https://' + DAILY_DOMAIN + '/' + dmRoomName);
      const callStartedAt = new Date().toISOString();
      // Log to call_video_sessions
      const { data: sessionData } = await supabase.from('call_video_sessions').insert({
        room_name: dmRoomName, room_url: roomUrl,
        started_by: me?.name || 'Admin',
        caller_name: me?.name || 'Admin',
        with_name: member.name,
        session_type: 'audio', status: 'active',
        participants: [me?.name || 'Admin', member.name],
      }).select().single();
      if (sessionData) dmCallSessionRef.current = sessionData.id;
      // Show inline call bar and broadcast
      setActiveDmCall({ roomUrl, memberInitials: member.initials, memberName: member.name, _startedAt: callStartedAt });
      setCallElapsed(0);
      if (callTimerRef.current) clearInterval(callTimerRef.current);
      callTimerRef.current = setInterval(() => setCallElapsed(s => s + 1), 1000);
      if (selected.type !== 'dm' || selected.id !== member.initials) pick('dm', member.initials);
      broadcastAndNotifyCall({ roomUrl, roomName: dmRoomName, withName: member.name, withInitials: member.initials, type: 'dm', recipientEmails: [member.email] });
    } catch (_e) {}
    setDmCallLoading(false);
  }

  async function startChannelCall(channelId) {
    if (!DAILY_DOMAIN || !DAILY_API_KEY) {
      // No Daily.co config — nothing to do
      return;
    }
    const chLabel = CHANNELS.find(ch => ch.id === channelId)?.label || ('#' + channelId);
    // If a call is already active in this channel, join it — don't start a second one
    if (activeChannelCalls[channelId]) {
      const { roomUrl } = activeChannelCalls[channelId];
      const chLabel = CHANNELS.find(ch => ch.id === channelId)?.label || ('#' + channelId);
      // Open FloatingCallOverlay for the joiner
      window.dispatchEvent(new CustomEvent('sanoire:startcall', {
        detail: { type: 'channel', id: channelId, name: chLabel, roomUrl }
      }));
      // Start inline header timer
      setChCallDuration(0);
      if (chCallTimerRef.current) clearInterval(chCallTimerRef.current);
      chCallTimerRef.current = setInterval(() => setChCallDuration(s => s + 1), 1000);
      return;
    }
    const roomName = 'sanoire-ch-' + channelId;
    const startedAt = new Date().toISOString();
    try {
      const res = await fetch('/api/create-room', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ room_name: roomName, expiry_hours: 2 }),
      });
      const room = await res.json();
      if (!res.ok) throw new Error(room.error || 'Failed to create room');
      const roomUrl = room.room_url || ('https://' + DAILY_DOMAIN + '/' + roomName);
      // Log to call_video_sessions
      const { data: sessionData } = await supabase.from('call_video_sessions').insert({
        room_name: roomName, room_url: roomUrl,
        started_by: me?.name || 'Admin',
        with_name: '#' + chLabel,
        session_type: 'audio', status: 'active',
        participants: [me?.name || 'Admin'],
      }).select().single();
      const sessionId = sessionData?.id || null;
      // Update local + peer state
      setActiveChannelCalls(prev => ({ ...prev, [channelId]: { roomUrl, startedBy: me?.name || 'Admin', startedAt, sessionId } }));
      setMyActiveChannelId(channelId);
      // Start inline header timer
      setChCallDuration(0); setChCallMuted(false);
      if (chCallTimerRef.current) clearInterval(chCallTimerRef.current);
      chCallTimerRef.current = setInterval(() => setChCallDuration(s => s + 1), 1000);
      // Broadcast to all online teammates
      if (callChannelRef.current) {
        callChannelRef.current.send({ type: 'broadcast', event: 'channel_call_started', payload: { channelId, roomUrl, startedBy: me?.name || 'Admin', startedAt } }).catch(() => {});
      }
      broadcastAndNotifyCall({ roomUrl, roomName, withName: chLabel, withInitials: '#', type: 'channel', recipientEmails: null });
    } catch (_e) {}
  }

  async function endChannelCall(channelId) {
    const callInfo = activeChannelCalls[channelId];
    const roomName = 'sanoire-ch-' + channelId;
    if (callInfo?.sessionId) {
      // Initiator: update by session id
      try {
        await supabase.from('call_video_sessions')
          .update({ ended_at: new Date().toISOString(), status: 'ended' })
          .eq('id', callInfo.sessionId);
      } catch (_e) {}
    } else {
      // Joiner or stale: update by room_name as fallback
      try {
        await supabase.from('call_video_sessions')
          .update({ ended_at: new Date().toISOString(), status: 'ended' })
          .eq('room_name', roomName)
          .eq('status', 'active');
      } catch (_e) {}
    }
    setActiveChannelCalls(prev => { const n = { ...prev }; delete n[channelId]; return n; });
    setMyActiveChannelId(null);
    if (chCallTimerRef.current) { clearInterval(chCallTimerRef.current); chCallTimerRef.current = null; }
    setChCallDuration(0); setChCallMuted(false);
    if (callChannelRef.current) {
      callChannelRef.current.send({ type: 'broadcast', event: 'channel_call_ended', payload: { channelId } }).catch(() => {});
    }
  }

  async function broadcastAndNotifyCall({ roomUrl, roomName, withName, withInitials, type, recipientEmails }) {
    // 1. Broadcast to online users via the persistent admin-calls channel
    try {
      if (callChannelRef.current) {
        callChannelRef.current.send({
          type: 'broadcast', event: 'incoming_call',
          payload: {
            callerName:     me?.name || 'Someone',
            callerInitials: me?.initials || '?',
            callType:       type,
            roomUrl, roomName,
            recipients:     recipientEmails || 'all',
          }
        }).catch(() => {});
      }
    } catch (_e) {}
    // 2. Notify offline team members via all channels
    try {
      const callerName     = me?.name || 'A team member';
      const callerInitials = me?.initials || '?';
      const offlineEmails  = teamMembers
        .filter(m => m.email && m.email !== me?.email && !onlineUsers[m.initials])
        .map(m => m.email);
      if (offlineEmails.length > 0) {
        // Email via Resend
        fetch('/api/call-notify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ callerName, callerInitials, roomUrl, roomName, recipients: offlineEmails })
        }).catch(() => {});
        // Web Push + SMS + deep-link email via the notification dispatcher
        fetch('/api/notify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ emails: offlineEmails, event: 'call', title: callerName + ' is calling', body: 'Tap to join the Team Room', url: '/?room=' + encodeURIComponent(roomName), requireInteraction: true })
        }).catch(() => {});
        // Telegram
        fetch('/api/send-telegram', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ message: callerName + ' is calling. Join: ' + roomUrl })
        }).catch(() => {});
        // Push notification
        fetch('/api/send-push', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            title: callerName + ' is calling',
            body: 'Tap to join the call on Sanoire Admin',
            data: { url: roomUrl, type: 'incoming_call' },
            segment: 'all',
          })
        }).catch(() => {});
      }
    } catch (_e) {}
  }

  async function endCall() {
    const endedAt = new Date().toISOString();
    const durSecs = videoStartTime ? Math.floor((new Date(endedAt) - new Date(videoStartTime)) / 1000) : null;
    if (videoSessionId) {
      await supabase.from('call_video_sessions').update({
        ended_at: endedAt, duration_secs: durSecs,
        transcript: videoTranscript, status: videoRecording ? 'recorded' : 'ended',
      }).eq('id', videoSessionId);
    }
    setVideoActive(false);
    setVideoRecording(false);
    setVideoSessionId(null);
    setVideoStartTime(null);
    setVideoTranscript([]);
    setMeetingToken(null);
    // Notify FloatingCallOverlay to dismiss + Layout pill
    window.dispatchEvent(new CustomEvent('sanoire:endcall'));
    window.dispatchEvent(new CustomEvent('sanoire:showoverlay'));
    window.dispatchEvent(new CustomEvent('sanoire:callstate', { detail: { active: false } }));
    newRoom();
    // Wait a tick before reloading sessions so DB write has propagated (Bug 4)
    setTimeout(() => { loadSessions(); }, 600);
  }

  // Handle Daily.co Leave button clicks (caught by postMessage listener above)
  useEffect(() => {
    function handleDailyLeave() { endCall(); }
    window.addEventListener('sanoire:dailyleave', handleDailyLeave);
    return () => window.removeEventListener('sanoire:dailyleave', handleDailyLeave);
  }, [videoActive, videoSessionId, videoTranscript, videoStartTime, videoRecording]); // eslint-disable-line

  function endDmCall() {
    if (dmCallSessionRef.current) {
      const endedAt = new Date().toISOString();
      const durSecs = activeDmCall?._startedAt ? Math.floor((new Date(endedAt) - new Date(activeDmCall._startedAt)) / 1000) : null;
      supabase.from('call_video_sessions').update({ ended_at: endedAt, duration_secs: durSecs, status: 'ended' }).eq('id', dmCallSessionRef.current).then(null, () => {});
      dmCallSessionRef.current = null;
    }
    setActiveDmCall(null);
    setCallElapsed(0);
    if (callTimerRef.current) { clearInterval(callTimerRef.current); callTimerRef.current = null; }
    setDmCallLoading(false);
  }

  function sendShareToChannel(channelId, link) {
    if (!me) return;
    const optimisticId = Date.now();
    const msg = { id: optimisticId, user: me.initials, name: me.name, time: 'just now', text: 'Meeting link: ' + link, reactions: [] };
    setChMsgs(prev => ({ ...prev, [channelId]: [...(prev[channelId] || []), msg] }));
    // Persist to Supabase
    supabase.from('dispatch_messages')
      .insert({ channel_id: channelId, user_initials: me.initials, user_name: me.name, text: 'Meeting link: ' + link })
      .select().single()
      .then(({ data: saved }) => {
        if (saved) setChMsgs(prev => ({
          ...prev,
          [channelId]: (prev[channelId] || []).map(m => m.id === optimisticId ? { ...m, id: saved.id } : m)
        }));
      }).catch(() => {});
  }

  function newRoom() {
    if (!DAILY_DOMAIN) return;
    const freshName = 'sanoire-team-' + Math.random().toString(16).slice(2, 8);
    setVideoRoomName(freshName);
    setVideoRoomUrl(null);
    setVideoError(null);
    setVideoLoading(true);
    fetch('/api/create-room', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ room_name: freshName, expiry_hours: 168 }),
    })
      .then(r => r.json())
      .then(room => { if (room.room_url) setVideoRoomUrl(room.room_url); })
      .catch(_e => {})
      .finally(() => setVideoLoading(false));
  }

  async function loadSessions() {
    const { data } = await supabase.from('call_video_sessions').select('*').order('started_at', { ascending: false }).limit(100);
    if (data) setVideoSessions(data);
  }

  function sendVideoMsg() {
    if (!videoMsgInput.trim() || !me) return;
    const msg = { user: me.initials, name: me.name, text: videoMsgInput.trim(), ts: new Date().toISOString() };
    setVideoTranscript(prev => [...prev, msg]);
    setVideoMsgInput('');
    setTimeout(() => videoMsgsRef.current?.scrollTo({ top: 99999, behavior: 'smooth' }), 50);
    // Broadcast to other participants via Realtime
    if (callChannelRef.current) {
      callChannelRef.current.send({ type: 'broadcast', event: 'video_chat_msg', payload: msg }).catch(() => {});
    }
    // Persist transcript to session row.
    // Supabase v2 query builder isn't a native Promise — wrap in async IIFE
    // and try/await/catch so a runtime error doesn't crash the handler.
    if (videoSessionId) {
      (async () => {
        try {
          await supabase.from('call_video_sessions')
            .update({ transcript: [...videoTranscript, msg] })
            .eq('id', videoSessionId);
        } catch (_e) { /* swallow */ }
      })();
    }
  }

  useEffect(() => {
    if (selected.type !== 'calls') return;
    loadSessions();
    // Only create a fresh room if none exists yet and no active call
    if (!videoActive && !videoRoomUrl) newRoom();
  }, [selected]); // eslint-disable-line

  // ── Auto-join from ?room= URL param (shared meeting links) ──────────────────
  const roomParamHandled = useRef(false);
  useEffect(() => {
    if (roomParamHandled.current) return;
    try {
      const roomParam = new URLSearchParams(window.location.search).get('room');
      if (!roomParam) return;
      roomParamHandled.current = true;
      // Clean up the URL so refreshing doesn't re-join
      window.history.replaceState({}, '', window.location.pathname);
      // Navigate to Team Room and set up the room
      const dailyDomain = process.env.REACT_APP_DAILY_DOMAIN || '';
      const roomUrl = 'https://' + dailyDomain + '/' + roomParam;
      setVideoRoomName(roomParam);
      setVideoRoomUrl(roomUrl);
      setSelected({ type: 'calls', id: 'team-room' });
      // Auto-start the meeting after a short delay for state to settle
      setTimeout(() => {
        setVideoActive(true);
        setVideoStartTime(new Date().toISOString());
        // Log the session
        supabase.from('call_video_sessions').insert({
          room_name: roomParam, room_url: roomUrl,
          started_by: me?.name || 'Guest', session_type: 'video', status: 'active',
          participants: [me?.name || 'Guest'].filter(Boolean),
        }).select().single().then(({ data }) => { if (data) setVideoSessionId(data.id); });
        // Fetch meeting token
        fetch('/api/meeting-token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ room_name: roomParam, user_name: me?.name || 'Guest' }),
        }).then(r => r.json()).then(d => { if (d.token) setMeetingToken(d.token); }).catch(() => {});
        // Notify overlays
        window.dispatchEvent(new CustomEvent('sanoire:startcall', {
          detail: { type: 'video', id: roomParam, name: 'Team Room', roomUrl }
        }));
        window.dispatchEvent(new CustomEvent('sanoire:hideoverlay'));
      }, 300);
    } catch (_e) {}
  }, []); // eslint-disable-line

  // CALL-FIX-03 (May 15, 2026) — load a Team Room from an external trigger.
  // Fires when FloatingCallOverlay's "Switch to video" or Layout's header pill
  // dispatches sanoire:loadteamroom with the active roomUrl. Mirrors the
  // ?room= URL param handler — sets state, switches to the calls panel,
  // auto-starts the meeting, logs the session, fetches the meeting token.
  // Without this listener, the Switch-to-video button used to land users on
  // Communications with no room loaded.
  useEffect(() => {
    function onLoadRoom(e) {
      const fullUrl = e.detail?.roomUrl;
      if (!fullUrl) return;
      let roomName = '';
      try { roomName = new URL(fullUrl).pathname.replace(/^\//, ''); }
      catch (_e) { roomName = String(fullUrl).split('/').pop() || ''; }
      if (!roomName) return;
      setVideoRoomName(roomName);
      setVideoRoomUrl(fullUrl);
      setSelected({ type: 'calls', id: 'team-room' });
      setTimeout(() => {
        setVideoActive(true);
        setVideoStartTime(new Date().toISOString());
        supabase.from('call_video_sessions').insert({
          room_name: roomName, room_url: fullUrl,
          started_by: me?.name || 'Guest', session_type: 'video', status: 'active',
          participants: [me?.name || 'Guest'].filter(Boolean),
        }).select().single().then(({ data }) => { if (data) setVideoSessionId(data.id); });
        fetch('/api/meeting-token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ room_name: roomName, user_name: me?.name || 'Guest' }),
        }).then(r => r.json()).then(d => { if (d.token) setMeetingToken(d.token); }).catch(() => {});
        window.dispatchEvent(new CustomEvent('sanoire:hideoverlay'));
      }, 80);
    }
    window.addEventListener('sanoire:loadteamroom', onLoadRoom);
    return () => window.removeEventListener('sanoire:loadteamroom', onLoadRoom);
  }, [me]); // eslint-disable-line

  const callDark = selected.type === 'calls' && videoActive;
  const mainPanel = (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: callDark ? '#0b1620' : t.panel, minWidth: 0, minHeight: 0 }}>

      {/* Customer Help — no overview panel; sidebar auto-picks first ticket */}
      {selected.type === 'customerhelp' && (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8, color: '#9eb8c8', background: '#fafbfc' }}>
          <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round'><path d='M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z'/></svg>
          <div style={{ fontSize: '.78rem' }}>Select a ticket from the sidebar</div>
        </div>
      )}
      {selected.type !== 'customerhelp' && <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      {/* Header */}
      <div style={{ padding: '11px 18px', borderBottom: callDark ? '1px solid rgba(255,255,255,0.07)' : `1px solid ${t.bd}`, background: callDark ? '#0f1f2b' : t.panel, flexShrink: 0, display: 'flex', alignItems: 'center', gap: 10, minHeight: 52 }}>
        {isMobile && (<button onClick={() => setShowSidebar(true)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8, margin: -4, color: '#314F5C', flexShrink: 0, display: 'flex', minWidth: 36, minHeight: 36, alignItems: 'center', justifyContent: 'center' }}><svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'><line x1='3' y1='6' x2='21' y2='6'/><line x1='3' y1='12' x2='21' y2='12'/><line x1='3' y1='18' x2='21' y2='18'/></svg></button>)}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: '.88rem', fontWeight: 600, color: callDark ? '#eef5f9' : '#0f1e28', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{headerName || 'Select a conversation'}</span>

          </div>
          {headerSub && <div style={{ fontSize: '.65rem', color: callDark ? '#8fa9b8' : '#7a9aaa', marginTop: 1 }}>{headerSub}</div>}
        </div>
        {headerActions}
      </div>

      {showSearch && selected.type === 'channel' && (<div style={{ borderBottom: `1px solid ${t.bd}`, padding: '8px 18px', background: '#fafbfc', display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}><svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='#9eb8c8' strokeWidth='2' strokeLinecap='round'><circle cx='11' cy='11' r='8'/><line x1='21' y1='21' x2='16.65' y2='16.65'/></svg><input autoFocus value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder={'Search in #' + (CHANNELS.find(ch2 => ch2.id === selected.id)?.label || selected.id) + '…'} style={{ flex: 1, border: 'none', background: 'transparent', fontSize: '.8rem', color: '#0f1e28', outline: 'none', fontFamily: F }} />{searchQuery && <button onClick={() => setSearchQuery('')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9eb8c8', fontSize: 16, lineHeight: 1 }}>×</button>}</div>)}
      {showPinned && selected.type === 'channel' && (<div style={{ borderBottom: '1px solid #edf0f3', background: '#fffbf4', padding: '12px 18px', flexShrink: 0 }}><div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}><svg width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='#9F7E4F' strokeWidth='2' strokeLinecap='round'><line x1='12' y1='17' x2='12' y2='22'/><path d='M5 17h14v-1.76a2 2 0 00-1.11-1.79l-1.78-.9A2 2 0 0015 10.76V6h1a2 2 0 000-4H8a2 2 0 000 4h1v4.76a2 2 0 01-1.11 1.79l-1.78.9A2 2 0 005 15.24V17z'/></svg><span style={{ fontSize: '.65rem', fontWeight: 600, color: '#9F7E4F', textTransform: 'uppercase', letterSpacing: '.08em' }}>Pinned Messages</span></div>{pinnedMsgs.map(p => (<div key={p.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '7px 10px', background: '#fff', borderRadius: 8, marginBottom: 5, border: '1px solid rgba(159,126,79,0.15)' }}><div style={{ width: 3, alignSelf: 'stretch', background: '#B99C6D', borderRadius: 2, flexShrink: 0 }} /><div><div style={{ fontSize: '.76rem', color: '#1a2e38', lineHeight: 1.5 }}>{p.message_text || p.text}</div><div style={{ fontSize: '.62rem', color: '#9eb8c8', marginTop: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}><span>{p.pinned_by || p.author} · {p.created_at ? new Date(p.created_at).toLocaleDateString([], { month: 'short', day: 'numeric' }) : p.time}</span><button onClick={async () => { await supabase.from('dispatch_pins').delete().eq('id', p.id); setPinnedMsgs(prev => prev.filter(x => x.id !== p.id)); }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#c4b08a', fontSize: 12, lineHeight: 1, padding: '0 2px' }} title='Unpin'>×</button></div></div></div>))}</div>)}
      {/* Quick replies for tickets */}
      {selected.type === 'ticket' && !isResolved && (
        <div style={{ padding: '6px 18px', borderBottom: '1px solid #f4f6f8', background: '#fafbfc', display: 'flex', gap: 6, overflowX: 'auto', flexShrink: 0 }}>
          {QUICK_REPLIES.map((qr, i) => (
            <button key={i} onClick={() => { setReplyText(qr.text); setShowQuickReplies(false); }} style={{ padding: '3px 10px', borderRadius: 999, border: '1px solid #d8e4ea', background: t.panel, color: '#314F5C', fontSize: 11, cursor: 'pointer', fontFamily: F, whiteSpace: 'nowrap', flexShrink: 0 }}>{qr.label}</button>
          ))}
        </div>
      )}

      {/* Messages / Video */}
      {selected.type === 'calls' ? (
        <VideoPanel
          isMobile={isMobile}
          me={me}
          videoActive={videoActive}
          videoRoomUrl={videoRoomUrl}
          videoRoomName={videoRoomName}
          videoRecording={videoRecording}
          videoLoading={videoLoading}
          videoError={videoError}
          videoTab={videoTab}
          setVideoTab={setVideoTab}
          videoTranscript={videoTranscript}
          setVideoTranscript={setVideoTranscript}
          videoMsgInput={videoMsgInput}
          setVideoMsgInput={setVideoMsgInput}
          videoSessions={videoSessions}
          videoMsgsRef={videoMsgsRef}
          startCall={startCall}
          endCall={endCall}
          startRecording={startRecording}
          newRoom={newRoom}
          sendShareToChannel={sendShareToChannel}
          setVideoRoomUrl={setVideoRoomUrl}
          setVideoActive={setVideoActive}
          onlineUsers={onlineUsers}
          teamMembers={teamMembers}
          chMsgs={chMsgs}
          setChMsgs={setChMsgs}
          supabase={supabase}
          loadSessions={loadSessions}
          meetingToken={meetingToken}
          videoSessionId={videoSessionId}
          inviteToCall={(member) => {
            if (!videoRoomUrl) return;
            broadcastAndNotifyCall({
              roomUrl: videoRoomUrl,
              roomName: videoRoomName,
              withName: member.name,
              withInitials: member.initials,
              type: 'team_room',
              recipientEmails: member.email ? [member.email] : null,
            });
          }}
        />
      ) : (
      <div style={{ flex: 1, overflowY: 'auto', padding: '8px 0', display: 'flex', flexDirection: 'column', gap: 0, background: '#ffffff' }}>

        {selected.type === 'dm' && msgs.length === 0 && (() => {
          const m = TEAM.find(t => t.initials === selected.id);
          return m ? (
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10, padding: '40px 0', color: '#9eb8c8', fontFamily: F }}>
              <Avatar initials={m.initials} color={m.color} textColor={m.text} size={52} />
              <div style={{ textAlign: 'center' }}><div style={{ fontSize: '.88rem', fontWeight: 500, color: '#0f1e28' }}>{m.name}</div><div style={{ fontSize: '.72rem', color: '#7a9aaa', marginTop: 3 }}>{!!onlineUsers[m.initials] ? '🟢 Active now' : '⚫ Away'}</div></div>
              <div style={{ fontSize: '.72rem', color: '#aab8c0', marginBottom: 14 }}>This is the start of your DM with {m.name}</div>
              <button onClick={() => { const el = document.querySelector('textarea'); if (el) el.focus(); }} style={{ padding: '8px 20px', background: t.accent, color: '#E0F5FC', border: 'none', borderRadius: 10, fontSize: '.78rem', fontWeight: 600, cursor: 'pointer', fontFamily: F, boxShadow: '0 2px 8px rgba(49,79,92,0.2)' }}>Start conversation</button>
            </div>)  : null;
        })()}

        {selected.type === 'ticket' && msgs.map((msg) => {
          const isAdmin = msg.isAdmin;
          return (
            <div key={msg.id} style={{ display: 'flex', gap: 10, marginBottom: 10, flexDirection: isAdmin ? 'row-reverse' : 'row', alignItems: 'flex-start' }}>
              <div style={{ width: 32, height: 32, borderRadius: '50%', background: isAdmin ? '#314F5C' : '#e8f0f4', color: isAdmin ? '#AFE1F6' : '#314F5C', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.6rem', fontWeight: 700, flexShrink: 0 }}>{msg.avatar}</div>
              <div style={{ maxWidth: '70%' }}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginBottom: 4, flexDirection: isAdmin ? 'row-reverse' : 'row' }}>
                  <span style={{ fontSize: '.7rem', fontWeight: 600, color: '#0f1e28' }}>{isAdmin ? (me?.name || 'You') : msg.name}</span>
                  <span style={{ fontSize: '.6rem', color: '#9eb8c8' }}>{timeAgo(msg.time)}</span>
                </div>
                <div style={{ background: isAdmin ? '#314F5C' : '#fff', color: isAdmin ? '#e8f4fb' : '#2a3840', borderRadius: isAdmin ? '14px 14px 4px 14px' : '14px 14px 14px 4px', padding: '10px 14px', fontSize: '.8rem', lineHeight: 1.6, border: isAdmin ? 'none' : `1px solid ${t.bd}`, boxShadow: isAdmin ? 'none' : '0 1px 2px rgba(0,0,0,0.04)', whiteSpace: 'pre-wrap' }}>{msg.text}</div>
              </div>
            </div>
          );
        })}

        {(selected.type === 'channel' || selected.type === 'dm') && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 20px 10px' }}>
            <div style={{ flex: 1, height: 1, background: '#edf0f3' }} />
            <span style={{ fontSize: '.67rem', fontWeight: 600, color: '#b0c4cc', whiteSpace: 'nowrap',
              background: t.panel, padding: '2px 10px', borderRadius: 99,
              border: `1px solid ${t.bd}`, letterSpacing: '.01em' }}>
              Today
            </span>
            <div style={{ flex: 1, height: 1, background: '#edf0f3' }} />
          </div>
        )}
        {(selected.type === 'channel' || selected.type === 'dm') && (searchQuery ? msgs.filter(m => m.text && m.text.toLowerCase().includes(searchQuery.toLowerCase())) : msgs).map((msg, i, arr) => {
          const av = TEAM.find(t => t.initials === (msg.user || msg.from)) || { color: '#6F8FA7', text: '#fff' };
          const showHead = i === 0 || (arr[i-1]?.user || arr[i-1]?.from) !== (msg.user || msg.from);
          return (
            <div key={msg.id}
              style={{ display: 'flex', gap: 10, padding: showHead ? (isMobile ? '8px 14px 2px' : '10px 20px 2px') : (isMobile ? '2px 14px' : '2px 20px'), alignItems: 'flex-start', position: 'relative', transition: 'background .08s' }}
              onMouseEnter={e => { e.currentTarget.style.background='rgba(49,79,92,0.02)'; const b = e.currentTarget.querySelector('.react-btn'); if (b) b.style.opacity='1'; }}
              onMouseLeave={e => { e.currentTarget.style.background='transparent'; const b = e.currentTarget.querySelector('.react-btn'); if (b && !isMobile) b.style.opacity='0'; }}
              onTouchStart={e => { const b = e.currentTarget.querySelector('.react-btn'); if (b) b.style.opacity='1'; }}
              onTouchEnd={e => { setTimeout(() => { const b = e.currentTarget.querySelector('.react-btn'); if (b) b.style.opacity='0'; }, 2500); }}>
              <div style={{ width: 36, flexShrink: 0, paddingTop: showHead ? 2 : 0 }}>
                {showHead ? <Avatar initials={msg.user || msg.from} color={av.color} textColor={av.text} size={36} /> : <span style={{ fontSize: '.6rem', color: '#c0d0d8', display: 'block', textAlign: 'center', lineHeight: '20px' }}></span>}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                {showHead && <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 3 }}>
  <span style={{ fontSize: '.82rem', fontWeight: 600, color: '#0f1e28', letterSpacing: '-.01em' }}>{msg.name}</span>
  <span style={{ fontSize: '.65rem', color: '#9eb8c8' }}>
    {(() => {
      if (!msg.ts) return msg.time;
      const d = new Date(msg.ts);
      const now = new Date();
      const isToday = d.toDateString() === now.toDateString();
      const isYesterday = new Date(now-86400000).toDateString() === d.toDateString();
      const timeStr = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
      if (isToday) return timeStr;
      if (isYesterday) return 'Yesterday ' + timeStr;
      return d.toLocaleDateString([], { month: 'short', day: 'numeric' }) + ' ' + timeStr;
    })()}
  </span>
  {msg.edited && <span style={{ fontSize: '.6rem', color: '#b0c4cc', fontStyle: 'italic' }}>(edited)</span>}
</div>}
                {editingMsg && editingMsg.id === msg.id ? (
                  <div style={{ display: 'flex', gap: 6, alignItems: 'flex-end' }}>
                    <textarea defaultValue={msg.text} autoFocus rows={2} id={'edit-' + msg.id}
                      onKeyDown={e => { e.stopPropagation(); if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); saveEdit(msg.id, e.target.value); } if (e.key === 'Escape') setEditingMsg(null); }}
                      style={{ flex: 1, border: '1px solid #c8dce8', borderRadius: 8, padding: '6px 10px', fontSize: '.8rem', fontFamily: F, resize: 'none', outline: 'none', lineHeight: 1.5 }} />
                    <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                      <button onClick={e => saveEdit(msg.id, document.getElementById('edit-' + msg.id).value)} style={{ padding: '5px 12px', background: t.accent, color: '#E0F5FC', border: 'none', borderRadius: 7, fontSize: '.72rem', fontWeight: 600, cursor: 'pointer', fontFamily: F }}>Save</button>
                      <button onClick={() => setEditingMsg(null)} style={{ padding: '5px 10px', background: 'transparent', color: '#7a9aaa', border: '1px solid #d8e4ea', borderRadius: 7, fontSize: '.72rem', cursor: 'pointer', fontFamily: F }}>Cancel</button>
                    </div>
                  </div>
                ) : msg.gif ? <img src={msg.gif} alt='GIF' style={{ maxWidth: 220, borderRadius: 8, display: 'block', border: '1px solid #e0e6ea' }} /> : (
                  <div style={{ fontSize: '.82rem', color: '#1a2e38', lineHeight: 1.6, letterSpacing: '-.01em' }}>
                    {msg.text.split(' ').map((word, wi) => word.startsWith('@') ? <span key={wi} style={{ color: '#314F5C', fontWeight: 600, background: 'rgba(49,79,92,0.08)', borderRadius: 4, padding: '0 3px' }}>{word} </span> : word + ' ')}
                  </div>
                )}
                {/* Rich link preview */}
                {!msg.gif && !editingMsg && (() => { const url = extractUrl(msg.text || ''); if (!url) return null; if (!linkPreviews[msg.id] && !window._lpFetching?.[msg.id]) { window._lpFetching = window._lpFetching || {}; window._lpFetching[msg.id] = true; fetchLinkPreview(msg.id, url); return null; } const p = linkPreviews[msg.id]; return (<div style={{ marginTop: 8, background: '#f8fafc', border: '1px solid #e4edf3', borderLeft: '3px solid #314F5C', borderRadius: '0 10px 10px 0', padding: '10px 14px', maxWidth: 360 }}><div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 4 }}><span style={{ fontSize: '.66rem', color: '#7a9aaa', fontWeight: 500 }}>{p.url}</span></div><div style={{ fontSize: '.76rem', fontWeight: 600, color: '#0f1e28', marginBottom: 3 }}>{p.title}</div><div style={{ fontSize: '.68rem', color: '#7a9aaa', lineHeight: 1.55 }}>{p.desc}</div></div>); })()}
                {translations[msg.id]?.visible && (
                  <div style={{ marginTop: 6, padding: '7px 10px', background: '#f0f7fb', borderRadius: 8, border: '1px solid #dde8f0', fontSize: '.78rem', color: '#314F5C', lineHeight: 1.55 }}>
                    {translations[msg.id]?.loading
                      ? <span style={{ color: '#9eb8c8', fontStyle: 'italic' }}>Translating…</span>
                      : <><span style={{ fontSize: '.6rem', color: '#9eb8c8', display: 'block', marginBottom: 3 }}>{(new Intl.DisplayNames(['en'], { type: 'language' }).of(translateLang) || translateLang).toUpperCase()}</span>{translations[msg.id]?.text}</>
                    }
                  </div>
                )}
                {msg.reactions && msg.reactions.filter(r => r.n > 0).length > 0 && (<div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>{msg.reactions.filter(r => r.n > 0).map((r, ri) => { const rKey = msg.id + r.e; const isMe = reactions[rKey]; const rc = getReactionColor(r.e); return (<button key={ri} onClick={() => addMsgReaction(msg.id, r.e, selected.type === 'channel')} style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '4px 11px 4px 9px', borderRadius: 99, background: isMe ? rc.bg : '#fff', border: '1.5px solid ' + (isMe ? rc.border : '#e0eaf0'), cursor: 'pointer', fontFamily: F, boxShadow: isMe ? 'none' : '0 1px 3px rgba(49,79,92,0.06)', transition: 'transform .13s, box-shadow .13s', animation: 'rxPopIn .26s cubic-bezier(.34,1.56,.64,1) both' }} onMouseEnter={el => { el.currentTarget.style.transform='translateY(-1px)'; el.currentTarget.style.boxShadow='0 3px 10px rgba(49,79,92,0.11)'; }} onMouseLeave={el => { el.currentTarget.style.transform=''; el.currentTarget.style.boxShadow=isMe?'none':'0 1px 3px rgba(49,79,92,0.06)'; }}>{r.e === SANOIRE_RX ? <SanoireIcon size={16} /> : <Tw e={r.e} size={15} />}<span style={{ fontSize: '.72rem', fontWeight: 700, color: isMe ? rc.cnt : '#7a9aaa', letterSpacing: '-.01em' }}>{r.n}</span></button>); })}</div>)}
                {msg.thread && (<button onClick={() => setActiveThread(activeThread === msg.id ? null : msg.id)} style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 6, background: 'none', border: 'none', cursor: 'pointer', fontFamily: F, padding: 0 }}><div style={{ display: 'flex' }}>{TEAM.slice(0,2).map((t,ti) => <div key={t.initials} style={{ width: 16, height: 16, borderRadius: 4, background: t.color, marginLeft: ti > 0 ? -4 : 0, border: '1.5px solid #fff', zIndex: 2-ti }} />)}</div><span style={{ fontSize: '.72rem', fontWeight: 600, color: '#314F5C' }}>{msg.thread} repl{msg.thread === 1 ? 'y' : 'ies'}</span><span style={{ fontSize: '.68rem', color: '#9eb8c8' }}>· Last reply 9:22 AM</span></button>)}
                {/* Read receipts */}
                {(readReceipts[msg.id] || []).length > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 4, gap: 3, alignItems: 'center' }}>
                    <span style={{ fontSize: '.58rem', color: '#b0c4cc' }}>Seen by</span>
                    {(readReceipts[msg.id] || []).filter(init => init !== (msg.user || msg.from)).slice(0, 3).map((init, ri) => { const t = TEAM.find(m => m.initials === init); return (<div key={init} title={t?.name} style={{ width: 13, height: 13, borderRadius: 3, background: t?.color || '#6F8FA7', color: t?.text || '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.38rem', fontWeight: 700, border: '1px solid #fff' }}>{init[0]}</div>); })}
                  </div>
                )}
              </div>
              <div className='react-btn' style={{ position: 'absolute', right: 16, top: -20, opacity: 0, transition: 'opacity .12s', display: 'flex', gap: 3, background: t.panel, border: '1px solid rgba(49,79,92,0.12)', borderRadius: 13, padding: '4px 7px', boxShadow: '0 6px 24px rgba(49,79,92,0.14), 0 1px 4px rgba(49,79,92,0.06)', zIndex: 10 }}>
                {QUICK_REACT.map(e => <button key={e} onClick={() => addMsgReaction(msg.id, e, selected.type === 'channel')} style={{ width: 30, height: 30, border: '0.5px solid transparent', background: 'rgba(49,79,92,0.03)', cursor: 'pointer', padding: 0, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background .1s, transform .1s' }} onMouseEnter={el => { el.currentTarget.style.background='rgba(49,79,92,0.09)'; el.currentTarget.style.borderColor='rgba(49,79,92,0.12)'; el.currentTarget.style.transform='scale(1.15)'; }} onMouseLeave={el => { el.currentTarget.style.background='rgba(49,79,92,0.03)'; el.currentTarget.style.borderColor='transparent'; el.currentTarget.style.transform=''; }}>{e === SANOIRE_RX ? <SanoireIcon size={18} /> : <Tw e={e} size={18} />}</button>)}
                <div style={{ width: 1, background: '#e4edf3', margin: '2px 2px' }} />
                <button onClick={() => setActiveThread(activeThread === msg.id ? null : msg.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', borderRadius: 5, color: '#7a9aaa', display: 'flex', alignItems: 'center' }} onMouseEnter={el => el.currentTarget.style.background='#f4f7f9'} onMouseLeave={el => el.currentTarget.style.background='none'}><svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'><path d='M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z'/></svg></button>
                <button style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', borderRadius: 5, color: '#7a9aaa', display: 'flex', alignItems: 'center' }} onClick={async () => { if (!me || !msg.text) return; const { data } = await supabase.from('dispatch_pins').insert({ channel_id: selected.id, message_id: typeof msg.id === 'string' && msg.id.includes('-') ? msg.id : null, message_text: msg.text.slice(0,200), pinned_by: me.name }).select(); const { data: pins } = await supabase.from('dispatch_pins').select('*').eq('channel_id', selected.id).order('created_at', { ascending: false }); if (pins) setPinnedMsgs(pins); }} onMouseEnter={el => el.currentTarget.style.background='#f4f7f9'} onMouseLeave={el => el.currentTarget.style.background='none'} title='Pin message'><svg width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'><line x1='12' y1='17' x2='12' y2='22'/><path d='M5 17h14v-1.76a2 2 0 00-1.11-1.79l-1.78-.9A2 2 0 0015 10.76V6h1a2 2 0 000-4H8a2 2 0 000 4h1v4.76a2 2 0 01-1.11 1.79l-1.78.9A2 2 0 005 15.24V17z'/></svg></button>
                <button onClick={() => msg.text && translateMsg(msg.id, msg.text)}
                  title={translations[msg.id]?.visible ? 'Hide translation' : 'Translate'}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', borderRadius: 5, color: translations[msg.id]?.visible ? '#314F5C' : '#7a9aaa', display: 'flex', alignItems: 'center' }}>
                  <svg width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'><circle cx='12' cy='12' r='10'/><path d='M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20'/></svg>
                </button>
                {me && (msg.user === me.initials || msg.from === me.initials) && (<>
                  <button onClick={() => setEditingMsg({ id: msg.id, text: msg.text })} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', borderRadius: 5, color: '#7a9aaa', display: 'flex', alignItems: 'center' }} onMouseEnter={el => el.currentTarget.style.background='#f4f7f9'} onMouseLeave={el => el.currentTarget.style.background='none'} title='Edit'>
                    <svg width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'><path d='M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7'/><path d='M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z'/></svg>
                  </button>
                  <button onClick={() => { if (window.confirm('Delete this message?')) deleteMsg(msg.id); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', borderRadius: 5, color: '#e05c5c', display: 'flex', alignItems: 'center' }} onMouseEnter={el => el.currentTarget.style.background='#fff0f0'} onMouseLeave={el => el.currentTarget.style.background='none'} title='Delete'>
                    <svg width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'><polyline points='3 6 5 6 21 6'/><path d='M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6'/><path d='M10 11v6'/><path d='M14 11v6'/><path d='M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2'/></svg>
                  </button>
                </>)}
              </div>
            </div>
          );
        })}
        {/* Thread panel moved to side overlay — rendered in main return */}
        {typingUsers.length > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 16px 4px' }}>
            {(() => { const t = teamMembers.find(m => m.initials === typingUsers[0].initials) || { initials: typingUsers[0].initials, color: '#6F8FA7', text: '#fff' }; return <Avatar initials={t.initials} color={t.color} textColor={t.text} size={22} />; })()}
            <div style={{ display: 'flex', alignItems: 'center', gap: 3, background: '#f0f4f6', borderRadius: 12, padding: '7px 11px' }}>
              {[0,1,2].map(i => <div key={i} style={{ width: 5, height: 5, borderRadius: '50%', background: '#9eb8c8', animation: 'dispatchTyping 1.2s ' + (i*0.2) + 's ease-in-out infinite' }} />)}
            </div>
            <span style={{ fontSize: '.66rem', color: '#9eb8c8', fontStyle: 'italic' }}>
              {typingUsers.length === 1 ? typingUsers[0].name + ' is typing…' : typingUsers.length === 2 ? typingUsers[0].name + ' and ' + typingUsers[1].name + ' are typing…' : 'Several people are typing…'}
            </span>
          </div>
        )}
        <div ref={bottomRef} />
      </div>
      )}

      {/* Active channel call banner — shown when a call is live in this channel */}
      {selected.type === 'channel' && activeChannelCalls[selected.id] && !myActiveChannelId && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 11,
          padding: '10px 18px',
          background: 'linear-gradient(90deg,#061a0f 0%,#092017 50%,#061a0f 100%)',
          borderTop: '1px solid rgba(45,160,106,0.22)',
          flexShrink: 0,
        }}>
          {/* Pulse dot */}
          <div style={{ position: 'relative', flexShrink: 0, width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ position: 'absolute', width: 28, height: 28, borderRadius: '50%', background: 'rgba(45,160,106,0.15)', animation: 'sanoirePulse 2s ease-in-out infinite' }} />
            <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#2da06a', flexShrink: 0, boxShadow: '0 0 8px rgba(45,160,106,0.7)', display: 'inline-block', position: 'relative', zIndex: 1 }} />
          </div>
          {/* Text */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '.76rem', fontWeight: 700, color: '#4ade98', lineHeight: 1.2, letterSpacing: '-.01em' }}>
              {activeChannelCalls[selected.id].startedBy} started a call
            </div>
            <div style={{ fontSize: '.66rem', color: 'rgba(74,222,152,0.5)', marginTop: 1 }}>Call in progress · Tap to join</div>
          </div>
          {/* Join / Force-end buttons */}
          <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
            <button onClick={() => startChannelCall(selected.id)} style={{
              display: 'flex', alignItems: 'center', gap: 6, padding: '7px 16px',
              background: 'linear-gradient(135deg,#2da06a 0%,#1a7a4d 100%)',
              border: 'none', borderRadius: 99, cursor: 'pointer',
              color: '#fff', fontSize: '.73rem', fontWeight: 700, fontFamily: 'inherit',
              boxShadow: '0 1px 0 rgba(0,0,0,0.2) inset, 0 3px 12px rgba(45,160,106,0.5)',
              letterSpacing: '.02em',
            }}>
              <svg width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round'><polygon points='5 3 19 12 5 21 5 3'/></svg>
              Join
            </button>
            <button onClick={() => endChannelCall(selected.id)} title='Force end this call'
              style={{ padding: '7px 10px', background: 'rgba(0,0,0,0.25)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 99, cursor: 'pointer', color: 'rgba(255,255,255,0.5)', fontSize: '.65rem', fontWeight: 600, fontFamily: 'inherit', letterSpacing: '.01em' }}
              onMouseEnter={e => { e.currentTarget.style.background='rgba(198,40,40,0.4)'; e.currentTarget.style.color='#fff'; }}
              onMouseLeave={e => { e.currentTarget.style.background='rgba(0,0,0,0.25)'; e.currentTarget.style.color='rgba(255,255,255,0.5)'; }}>
              End
            </button>
          </div>
        </div>
      )}

      {/* Input bar */}
      {!(selected.type === 'calls') && <div style={{ padding: '8px 16px 14px', borderTop: `1px solid ${t.bd}`, background: t.panel, flexShrink: 0, position: 'relative' }}>
        {showEmoji && <EmojiPicker onSelect={appendEmoji} onClose={() => setShowEmoji(false)} />}
        {showGif && <GifPicker onSelect={handleGifSelect} onClose={() => setShowGif(false)} />}
        {isResolved ? (
          <div style={{ textAlign: 'center', fontSize: '.76rem', color: '#9eb8c8', padding: '8px 0' }}>Ticket resolved.{' '}<button onClick={() => setStatus('open')} style={{ background: 'none', border: 'none', color: '#314F5C', fontWeight: 600, cursor: 'pointer', fontSize: '.76rem', fontFamily: F }}>Reopen to reply →</button></div>
        ) : (
          <div style={{ background: t.panel, borderRadius: 14, border: '1.5px solid rgba(49,79,92,0.15)', overflow: 'hidden', boxShadow: '0 1px 4px rgba(49,79,92,0.06)' }}>
{/* Formatting buttons moved to bottom bar — no separate row */}
            {showMentions && mentionResults.length > 0 && (
              <div style={{ position: 'absolute', bottom: '100%', left: 16, right: 16, background: t.panel, border: '1px solid #e4edf3', borderRadius: 10, overflow: 'hidden', boxShadow: '0 8px 24px rgba(49,79,92,0.12)', zIndex: 50, marginBottom: 4 }}>
                <div style={{ padding: '6px 12px', borderBottom: `1px solid ${t.bd}`, fontSize: '.62rem', color: '#9eb8c8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.08em' }}>Mention</div>
                {mentionResults.map(t => (
                  <button key={t.initials} onClick={() => insertMention(t.name)} style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 9, padding: '8px 12px', background: 'none', border: 'none', cursor: 'pointer', fontFamily: F, textAlign: 'left' }}
                    onMouseEnter={e => e.currentTarget.style.background='#f4f7f9'}
                    onMouseLeave={e => e.currentTarget.style.background='none'}>
                    <div style={{ width: 26, height: 26, borderRadius: 7, background: t.color, color: t.text, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.56rem', fontWeight: 700, flexShrink: 0 }}>{t.initials}</div>
                    <div>
                      <div style={{ fontSize: '.76rem', fontWeight: 600, color: '#0f1e28' }}>{t.name}</div>
                      <div style={{ fontSize: '.62rem', color: t.online ? '#2da06a' : '#9eb8c8' }}>{t.online ? '● Active' : '○ Away'}</div>
                    </div>
                  </button>
                ))}
              </div>
            )}
            <textarea value={inputValue} onChange={e => {
              if (selected.type === 'ticket') inputSet(e.target.value);
              else handleInputChange(e.target.value, inputSet);
            }} onKeyDown={e => { e.stopPropagation(); if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); inputSend(); } }} placeholder={inputPH} rows={1} style={{ border: 'none', background: 'transparent', resize: 'none', outline: 'none', fontSize: isMobile ? '.88rem' : '.82rem', fontFamily: F, color: '#0f1e28', lineHeight: 1.55, minHeight: isMobile ? 44 : 38, maxHeight: 120, padding: isMobile ? '11px 14px 4px' : '9px 14px 4px', overflow: 'auto', width: '100%', letterSpacing: '-.01em', display: 'block' }} />
            <div style={{ display: 'flex', alignItems: 'center', padding: '4px 8px 8px', gap: 2 }}>
              {!isMobile && (selected.type === 'channel' || selected.type === 'dm') && (
                <>
                  {[{l:<strong style={{fontSize:10.5,fontFamily:F}}>B</strong>,t:'Bold'},{l:<em style={{fontSize:10.5}}>I</em>,t:'Italic'},{l:<span style={{textDecoration:'line-through',fontSize:9.5}}>S</span>,t:'Strike'}].map((btn,bi) =>
                    <button key={bi} title={btn.t} style={{background:'none',border:'none',cursor:'pointer',padding:'0 5px',borderRadius:4,color:t.mut,display:'flex',alignItems:'center',justifyContent:'center',height:32}} onMouseEnter={e=>{e.currentTarget.style.background='rgba(49,79,92,0.08)';e.currentTarget.style.color='#314F5C';}} onMouseLeave={e=>{e.currentTarget.style.background='none';e.currentTarget.style.color='#9eb8c8';}}>{btn.l}</button>
                  )}
                  <div style={{width:1,height:16,background:t.gbar,margin:'0 4px'}} />
                </>
              )}
              <button onClick={() => { setShowEmoji(v => !v); setShowGif(false); }} title='Emoji' style={{ background: 'rgba(49,79,92,0.06)', border: '0.5px solid rgba(49,79,92,0.1)', cursor: 'pointer', padding: '5px 7px', borderRadius: 8, color: '#314F5C', display: 'flex', alignItems: 'center', height: 32 }} onMouseEnter={e => { e.currentTarget.style.background='rgba(49,79,92,0.13)'; e.currentTarget.style.borderColor='rgba(49,79,92,0.22)'; }} onMouseLeave={e => { e.currentTarget.style.background='rgba(49,79,92,0.06)'; e.currentTarget.style.borderColor='rgba(49,79,92,0.1)'; }}><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg></button>
              <button onClick={() => { setShowGif(v => !v); setShowEmoji(false); }} title='GIF' style={{ background: 'rgba(49,79,92,0.06)', border: '0.5px solid rgba(49,79,92,0.1)', cursor: 'pointer', padding: '5px 7px', borderRadius: 8, color: '#314F5C', display: 'flex', alignItems: 'center', height: 32 }} onMouseEnter={e => { e.currentTarget.style.background='rgba(49,79,92,0.13)'; e.currentTarget.style.borderColor='rgba(49,79,92,0.22)'; }} onMouseLeave={e => { e.currentTarget.style.background='rgba(49,79,92,0.06)'; e.currentTarget.style.borderColor='rgba(49,79,92,0.1)'; }}><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="3"/><line x1="8" y1="4" x2="8" y2="20"/><line x1="16" y1="4" x2="16" y2="20"/><line x1="2" y1="8" x2="8" y2="8"/><line x1="16" y1="8" x2="22" y2="8"/><line x1="2" y1="16" x2="8" y2="16"/><line x1="16" y1="16" x2="22" y2="16"/></svg></button>
              <input ref={fileInputRef} type='file' style={{ display: 'none' }} accept='image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.zip' onChange={e => { const f = e.target.files && e.target.files[0]; if (f) uploadAndSendFile(f); e.target.value = ''; }} />
              <button onClick={() => fileInputRef.current && fileInputRef.current.click()} title='Attach' style={{ background: 'rgba(49,79,92,0.06)', border: '0.5px solid rgba(49,79,92,0.1)', cursor: 'pointer', padding: '5px 7px', borderRadius: 8, color: '#314F5C', display: 'flex', alignItems: 'center', height: 32 }} onMouseEnter={e => { e.currentTarget.style.background='rgba(49,79,92,0.13)'; e.currentTarget.style.borderColor='rgba(49,79,92,0.22)'; }} onMouseLeave={e => { e.currentTarget.style.background='rgba(49,79,92,0.06)'; e.currentTarget.style.borderColor='rgba(49,79,92,0.1)'; }}><svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'><path d='M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48'/></svg></button>
              <div style={{ flex: 1 }} />
              <button onClick={() => inputSend()} disabled={sending || !inputValue.trim()} style={{ width: 34, height: 34, borderRadius: 10, border: 'none', flexShrink: 0, background: inputValue.trim() ? '#314F5C' : '#e4edf3', color: inputValue.trim() ? '#E0F5FC' : '#9eb8c8', cursor: inputValue.trim() ? 'pointer' : 'default', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all .15s', boxShadow: inputValue.trim() ? '0 1px 0 rgba(0,0,0,0.18) inset, 0 2px 8px rgba(49,79,92,0.3)' : 'none' }}><svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><line x1='22' y1='2' x2='11' y2='13'/><polygon points='22 2 15 22 11 13 2 9 22 2'/></svg></button>
            </div>
          </div>
        )}
      </div>}
  </div>}
    </div>
  );

  const chatHeight = isMobile ? 'calc(100dvh - 58px - env(safe-area-inset-bottom, 0px))' : 'calc(100vh - 72px)';
  const _navW = (typeof window !== 'undefined') ? (window.innerWidth >= 1024 ? 220 : (window.innerWidth >= 768 ? 150 : 0)) : 220;
  // inject spinner keyframe once
  React.useEffect(() => {
    if (!document.getElementById('sanoire-spin-style')) {
      const s = document.createElement('style');
      s.id = 'sanoire-spin-style';
      s.textContent = '@keyframes sanoireSpin { to { transform: rotate(360deg); } } @keyframes threadSlideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } } @keyframes dispatchTyping { 0%,60%,100% { transform: translateY(0); opacity:0.4; } 30% { transform: translateY(-4px); opacity:1; } } @keyframes rxPopIn { 0% { transform: scale(0.55); opacity: 0; } 55% { transform: scale(1.2); } 80% { transform: scale(0.96); } 100% { transform: scale(1); opacity: 1; } } @keyframes soLivePulse { 0%,100% { opacity:1; } 50% { opacity:.35; } } @keyframes sanoirePulse { 0%,100% { opacity:0.45; } 50% { opacity:1; } }';
      document.head.appendChild(s);
    }
  }, []);

  // Hide the ConsoleShell live/Dark-Light eyebrow while a Team Room call is active,
  // so the call goes edge-to-edge under the status bar.
  React.useEffect(() => {
    const id = 'sanoire-call-eyebrow-hide';
    const inCall = videoActive && selected.type === 'calls';
    let el = document.getElementById(id);
    if (inCall) {
      if (!el) { el = document.createElement('style'); el.id = id; document.head.appendChild(el); }
      el.textContent = '.cc-eyebrow{display:none!important}';
    } else if (el) { el.remove(); }
    return () => { const e = document.getElementById(id); if (e) e.remove(); };
  }, [videoActive, selected]);

  if (isMobile) {
    const hBadge = tickets.filter(t => t.status !== 'resolved').length;
    const cUnread = unreadChs.size;
    const MSC = { open: '#A32D2D', in_progress: '#185FA5', resolved: '#0F6E56' };
    const MSL = { open: 'Open', in_progress: 'In progress', resolved: 'Resolved' };
    const mNewCt = tickets.filter(t => !t.assigned_to && t.status !== 'resolved').length;
    const mMineCt = me ? tickets.filter(t => t.assigned_to_email === me.email && t.status !== 'resolved').length : 0;
    const mFiltered = tickets.filter(t => {
      if (mobileHelpFilter === 'new') return !t.assigned_to && t.status !== 'resolved';
      if (mobileHelpFilter === 'mine') return t.assigned_to_email === me?.email && t.status !== 'resolved';
      if (mobileHelpFilter === 'resolved') return t.status === 'resolved';
      return true;
    });
    const mTopBar = (
      <div style={{ display: 'flex', background: t.panel, borderBottom: '0.5px solid rgba(49,79,92,0.09)', flexShrink: 0 }}>
        {[{ k: 'help', label: 'Help', badge: mobileTab !== 'help' && hBadge > 0 ? hBadge : null, badgeBg: '#e53935' },
          { k: 'chat', label: 'C‌hat', badge: mobileTab !== 'chat' && cUnread > 0 ? cUnread : null, badgeBg: '#314F5C' }].map(({ k, label, badge, badgeBg }) => (
          <button key={k} onClick={() => {
            if (k === 'chat' && mobileTab === 'help') {
              if (selected.type === 'ticket' || selected.type === 'customerhelp') {
                setSelected(lastChatSelected && lastChatSelected.type !== 'ticket' ? lastChatSelected : { type: 'channel', id: 'general' });
              }
            }
            if (k === 'help' && mobileTab === 'chat') {
              if (selected.type !== 'ticket') setLastChatSelected(selected);
            }
            setMobileTab(k);
          }} style={{ flex: 1, padding: '15px 0', background: 'none', border: 'none',
            borderBottom: mobileTab === k ? '2px solid #314F5C' : '2px solid transparent',
            fontWeight: mobileTab === k ? 600 : 400,
            color: mobileTab === k ? '#314F5C' : '#9eb8c8',
            cursor: 'pointer', fontFamily: F, fontSize: '.92rem',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7 }}>
            {k === 'help'
              ? <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 8l10 7 10-7"/></svg>
              : <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
            }
            <span style={{ fontFamily: F, letterSpacing: '0.2px', fontVariantLigatures: 'none', fontFeatureSettings: '"liga" 0, "clig" 0, "calt" 0, "dlig" 0' }}>{label}</span>
            {badge != null && <span style={{ background: badgeBg, color: '#fff', fontSize: '.58rem', fontWeight: 700, borderRadius: 4, padding: '1px 5px', lineHeight: 1.5 }}>{badge}</span>}
          </button>
        ))}
      </div>
    );
    const mHelpList = (
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <div style={{ display: 'flex', background: t.panel, borderBottom: '0.5px solid rgba(49,79,92,0.08)',
          padding: '0 16px', overflowX: 'auto', flexShrink: 0,
          scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          {[{ k: 'all', lbl: 'All · ' + tickets.length },
            { k: 'new', lbl: mNewCt > 0 ? 'New · ' + mNewCt : 'New' },
            { k: 'mine', lbl: mMineCt > 0 ? 'Mine · ' + mMineCt : 'Mine' },
            { k: 'resolved', lbl: 'Resolved' },
          ].map(({ k, lbl }) => (
            <button key={k} onClick={() => setMobileHelpFilter(k)} style={{
              flexShrink: 0, padding: '10px 18px 10px 0', fontSize: '.72rem',
              background: 'none', border: 'none',
              borderBottom: mobileHelpFilter === k ? '2px solid #314F5C' : '2px solid transparent',
              fontWeight: mobileHelpFilter === k ? 600 : 400,
              color: mobileHelpFilter === k ? '#314F5C' : '#9eb8c8',
              cursor: 'pointer', fontFamily: F, whiteSpace: 'nowrap',
            }}>{lbl}</button>
          ))}
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '8px 10px 24px', background: '#edf2f5' }}>
          {loadingTix && <div style={{ textAlign: 'center', padding: '32px 0', color: '#9eb8c8', fontSize: '.78rem' }}>Loading…</div>}
          {!loadingTix && mFiltered.length === 0 && <div style={{ textAlign: 'center', padding: '40px 0', color: '#9eb8c8', fontSize: '.78rem' }}>No tickets</div>}
          {mFiltered.map(t => {
            const mAct = selected.type === 'ticket' && selected.id === t.id;
            const mIsNew = !t.assigned_to && t.status !== 'resolved';
            const mSC = mIsNew ? '#A32D2D' : (MSC[t.status] || '#A32D2D');
            const mSL = mIsNew ? 'New' : (MSL[t.status] || 'Open');
            const mAsgn = teamMembers.find(m2 => m2.email === t.assigned_to_email);
            return (
              <button key={t.id}
                onClick={() => { pick('ticket', t.id); setMobileThreadTab('customer'); }}
                style={{ width: '100%', textAlign: 'left', background: t.panel,
                  border: mAct ? '1px solid rgba(49,79,92,0.18)' : '1px solid transparent',
                  borderRadius: 11, padding: '12px 14px', marginBottom: 5,
                  cursor: 'pointer', fontFamily: F, display: 'block',
                  boxShadow: mAct ? '0 1px 5px rgba(49,79,92,0.12)' : '0 1px 2px rgba(49,79,92,0.05)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 }}>
                  <span style={{ fontSize: '.7rem', fontWeight: 600, color: mSC }}>{mSL}</span>
                  <span style={{ fontSize: '.66rem', color: '#a0b4be' }}>{timeAgo(t.created_at)}</span>
                </div>
                <div style={{ fontSize: '.82rem', fontWeight: mIsNew ? 600 : 500,
                  color: t.status === 'resolved' ? '#7a9aaa' : '#0f1e28',
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginBottom: 4 }}>
                  {t.subject || (t.message && t.message.slice(0, 60)) || 'No subject'}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '.68rem', color: '#7a9aaa', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '70%' }}>{t.email}</span>
                  {mAsgn && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 3, flexShrink: 0 }}>
                      <div style={{ width: 15, height: 15, borderRadius: '50%', background: mAsgn.color, color: mAsgn.text, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.48rem', fontWeight: 700 }}>{mAsgn.initials}</div>
                      <span style={{ fontSize: '.66rem', color: '#314F5C', fontWeight: 500 }}>{t.assigned_to && t.assigned_to.split(' ')[0]}</span>
                    </div>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    );
    const mSelT = tickets.find(tx => tx.id === selected.id);
    const mHelpThread = mSelT ? (
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, background: t.panel }}>
        <div style={{ background: t.panel, borderBottom: '0.5px solid #edf0f3', flexShrink: 0 }}>
          <div style={{ padding: '10px 14px 8px' }}>
            <button onClick={() => pick('ticket', null)}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: 'none', border: 'none', cursor: 'pointer',
                padding: '4px 8px 8px 0', marginBottom: 2, fontFamily: F }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6F8FA7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </button>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 5 }}>
              <span style={{ fontSize: '.9rem', fontWeight: 600, color: '#0f1e28', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{mSelT.subject || 'Support ticket'}</span>
              <span style={{ fontSize: '.72rem', fontWeight: 600, flexShrink: 0,
                color: !mSelT.assigned_to && mSelT.status !== 'resolved' ? '#A32D2D' : mSelT.status === 'in_progress' ? '#185FA5' : '#0F6E56' }}>
                {!mSelT.assigned_to && mSelT.status !== 'resolved' ? 'New' : (MSL[mSelT.status] || 'Open')}
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10, flexWrap: 'wrap' }}>
              <span style={{ fontSize: '.7rem', color: '#7a9aaa' }}>{mSelT.email}</span>
              <span style={{ fontSize: '.7rem', color: '#d0d8dd' }}>·</span>
              <span style={{ fontSize: '.7rem', color: '#aab8c0' }}>{timeAgo(mSelT.created_at)}</span>
              {mSelT.telegram && (
                <><span style={{ fontSize: '.7rem', color: '#d0d8dd' }}>·</span>
                <a href={'https://t.me/' + mSelT.telegram.replace('@', '')} target="_blank" rel="noreferrer"
                  style={{ fontSize: '.7rem', color: '#185FA5', textDecoration: 'none' }}>
                  {mSelT.telegram.startsWith('@') ? mSelT.telegram : '@' + mSelT.telegram} ↗
                </a></>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', minHeight: 38 }}>
              {!mSelT.assigned_to && me && (
                <button onClick={async () => {
                  await supabase.rpc('admin_claim_ticket', { p_ticket_id: mSelT.id, p_assignee: me.name, p_assignee_email: me.email });
                  setTickets(prev => prev.map(tt => tt.id === mSelT.id ? { ...tt, assigned_to: me.name, assigned_to_email: me.email, status: tt.status === 'open' ? 'in_progress' : tt.status } : tt));
                }} style={{ fontSize: '.8rem', fontWeight: 500, color: '#6F8FA7', background: 'none', border: 'none', cursor: 'pointer', padding: '10px 16px 10px 0', fontFamily: F, minHeight: 38 }}>Claim</button>
              )}
              {mSelT.status === 'open' && (
                <button onClick={() => setStatus('in_progress')} style={{ fontSize: '.8rem', fontWeight: 500, color: '#6F8FA7', background: 'none', border: 'none', cursor: 'pointer', padding: '10px 16px 10px 0', fontFamily: F, minHeight: 38 }}>Start</button>
              )}
              <div style={{ flex: 1 }} />
              {mSelT.status !== 'resolved'
                ? <button onClick={() => setStatus('resolved')} style={{ fontSize: '.82rem', fontWeight: 600, color: '#fff', background: '#819D84', border: 'none', borderRadius: 8, padding: '9px 20px', cursor: 'pointer', fontFamily: F, minHeight: 38 }}>Resolve</button>
                : <button onClick={() => setStatus('open')} style={{ fontSize: '.8rem', fontWeight: 500, color: '#9eb8c8', background: 'transparent', border: '1px solid #d8e4ea', borderRadius: 8, padding: '9px 16px', cursor: 'pointer', fontFamily: F, minHeight: 38 }}>Reopen</button>
              }
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            {[{ k3: 'customer', l3: 'Thread' }, { k3: 'internal', l3: 'Internal · ' + notes.length }].map(({ k3, l3 }) => (
              <button key={k3} onClick={() => setMobileThreadTab(k3)} style={{
                flex: 1, padding: '9px 0', fontSize: '.72rem', background: 'none', border: 'none',
                borderBottom: mobileThreadTab === k3 ? '2px solid #314F5C' : '2px solid transparent',
                fontWeight: mobileThreadTab === k3 ? 600 : 400,
                color: mobileThreadTab === k3 ? '#314F5C' : '#9eb8c8',
                cursor: 'pointer', fontFamily: F,
              }}>{l3}</button>
            ))}
          </div>
        </div>
        {mobileThreadTab === 'customer' && (
          <>
            <div style={{ flex: 1, overflowY: 'auto', padding: '10px 0', background: t.panel }}>
              <div style={{ display: 'flex', gap: 10, padding: '8px 16px', alignItems: 'flex-start' }}>
                <div style={{ width: 32, height: 32, borderRadius: 9, background: '#AFE1F6', color: '#314F5C', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.62rem', fontWeight: 700, flexShrink: 0 }}>{(mSelT.email || '?')[0].toUpperCase()}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 3 }}>
                    <span style={{ fontSize: '.82rem', fontWeight: 600, color: '#0f1e28' }}>{mSelT.email && mSelT.email.split('@')[0]}</span>
                    <span style={{ fontSize: '.64rem', color: '#9eb8c8' }}>{timeAgo(mSelT.created_at)}</span>
                  </div>
                  <div style={{ fontSize: '.82rem', color: '#1a2e38', lineHeight: 1.6 }}>{mSelT.message}</div>
                </div>
              </div>
              {ticketMsgs.map((r2, ri) => {
                const isAd = r2.author === 'admin';
                const adMem = isAd ? (teamMembers.find(tm2 => tm2.email === r2.author_email) || me || { initials: 'SA', color: '#314F5C', text: '#AFE1F6', name: 'Support' }) : null;
                const sh2 = ri === 0 || ticketMsgs[ri - 1].author !== r2.author;
                return (
                  <div key={r2.id} style={{ display: 'flex', gap: 10, padding: sh2 ? '8px 16px 2px' : '2px 16px', alignItems: 'flex-start' }}>
                    <div style={{ width: 32, flexShrink: 0 }}>
                      {sh2 && (isAd
                        ? <div style={{ width: 32, height: 32, borderRadius: 9, background: adMem.color, color: adMem.text, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.62rem', fontWeight: 700 }}>{adMem.initials}</div>
                        : <div style={{ width: 32, height: 32, borderRadius: 9, background: '#AFE1F6', color: '#314F5C', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.62rem', fontWeight: 700 }}>{(mSelT.email || '?')[0].toUpperCase()}</div>
                      )}
                    </div>
                    <div style={{ flex: 1 }}>
                      {sh2 && <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 3 }}><span style={{ fontSize: '.82rem', fontWeight: 600, color: '#0f1e28' }}>{isAd ? (adMem.name || 'Support') : (mSelT.email && mSelT.email.split('@')[0])}</span><span style={{ fontSize: '.64rem', color: '#9eb8c8' }}>{timeAgo(r2.created_at)}</span></div>}
                      <div style={{ fontSize: '.82rem', color: '#1a2e38', lineHeight: 1.6 }}>{r2.message}</div>
                    </div>
                  </div>
                );
              })}
              <div ref={bottomRef} />
            </div>
            <div style={{ padding: '8px 14px 14px', borderTop: '0.5px solid #edf0f3', background: t.panel, flexShrink: 0 }}>
              <div style={{ background: '#f4f7f9', borderRadius: 11, border: '1px solid #e4edf3', overflow: 'hidden' }}>
                <textarea value={replyText} onChange={e => setReplyText(e.target.value)}
                  onKeyDown={e => { e.stopPropagation(); if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); sendTicketReply(); } }}
                  placeholder={'Reply to ' + mSelT.email + '…'} rows={2}
                  style={{ width: '100%', border: 'none', background: 'transparent', padding: '10px 14px',
                    fontSize: '.84rem', fontFamily: F, color: '#0f1e28', resize: 'none', outline: 'none',
                    lineHeight: 1.55, display: 'block', boxSizing: 'border-box' }} />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '5px 10px 8px', borderTop: '0.5px solid #e4edf3' }}>
                  <button onClick={sendTicketReply} disabled={!replyText.trim() || sending}
                    style={{ width: 32, height: 32, borderRadius: 8, border: 'none',
                      background: replyText.trim() ? '#314F5C' : '#e4edf3',
                      color: replyText.trim() ? '#E0F5FC' : '#9eb8c8',
                      cursor: replyText.trim() ? 'pointer' : 'default',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all .15s' }}>
                    {sending
                      ? <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/></svg>
                      : <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                    }
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
        {mobileThreadTab === 'internal' && (
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px', color: '#9eb8c8', background: '#fef9ef' }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#d0dde4" strokeWidth="1.2" strokeLinecap="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>
            <div style={{ fontSize: '.72rem', marginTop: 10 }}>{notes.length === 0 ? 'No internal notes yet' : notes.length + ' note' + (notes.length !== 1 ? 's' : '')}</div>
          </div>
        )}
      </div>
    ) : null;
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: chatHeight, minHeight: 0, border: 'none', borderRadius: 0, overflow: 'hidden', fontFamily: F, margin: '-16px -20px -22px', background: t.panel }}>
        {!(videoActive && selected.type === 'calls') && mTopBar}
        {(videoActive && selected.type === 'calls')
          ? mainPanel
          : (mobileTab === 'help'
              ? (selected.type === 'ticket' && selected.id ? mHelpThread : mHelpList)
              : (showSidebar ? sidebar : mainPanel))
        }
      </div>
    );
  }

  return (
    <div style={ videoActive
      ? { position: 'fixed', top: 72, left: _navW, right: 0, bottom: 0, zIndex: 40, display: 'flex', overflow: 'hidden', background: '#0b1620', fontFamily: F }
      : { display: 'flex', height: chatHeight, minHeight: 0, margin: '-16px -20px -22px', border: 'none', borderRadius: 0, overflow: 'hidden', position: 'relative', fontFamily: F, background: t.panel } }>
      {callCollapsed ? (
        <div style={{ width: 48, flexShrink: 0, background: '#0f1f2b', borderRight: '1px solid rgba(255,255,255,0.07)', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 12, gap: 12 }}>
          <button onClick={() => setCallCollapsed(false)} title="Show channels" style={{ width: 34, height: 34, borderRadius: 9, border: '1px solid #d8e4ea', background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#314F5C' }}>
            <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><polyline points='9 18 15 12 9 6'/></svg>
          </button>
          <div style={{ width: 32, height: 32, borderRadius: 9, background: 'rgba(45,160,106,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} title="Call in progress">
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#2da06a', boxShadow: '0 0 6px rgba(45,160,106,0.5)' }} />
          </div>
        </div>
      ) : (
        <div style={{ position: 'relative', flexShrink: 0, display: 'flex' }}>
          {sidebar}
          {videoActive && !isMobile && (
            <button onClick={() => setCallCollapsed(true)} title="Hide channels for more room" style={{ position: 'absolute', top: 10, right: 8, zIndex: 5, width: 28, height: 28, borderRadius: 8, border: '1px solid #d8e4ea', background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#314F5C', boxShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>
              <svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><polyline points='15 18 9 12 15 6'/></svg>
            </button>
          )}
        </div>
      )}
      {mainPanel}
      {/* Calls handled by App-level FloatingCallOverlay */}

      {/* Incoming call notification */}
      {pendingIncomingCall && pendingIncomingCall.callerInitials !== me?.initials && (
        <div style={{ position: 'fixed', bottom: isMobile ? 'calc(96px + env(safe-area-inset-bottom))' : 28, right: isMobile ? 12 : 24, left: isMobile ? 12 : 'auto', background: '#0c1e2b', borderRadius: 16, padding: '12px 14px', boxShadow: '0 12px 48px rgba(0,0,0,0.45), 0 0 0 1px rgba(175,225,246,0.10)', zIndex: 9999, minWidth: isMobile ? 'unset' : 300, fontFamily: F, display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 38, height: 38, borderRadius: 11, background: 'rgba(45,160,106,0.15)', border: '1px solid rgba(45,160,106,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#2da06a' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .84h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.28a16 16 0 006.29 6.29l1.46-1.46a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 15.31z'/></svg>
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '.65rem', color: 'rgba(175,225,246,0.45)', fontWeight: 500, marginBottom: 1 }}>{pendingIncomingCall.callType === 'team_room' ? 'Team Room invite' : 'Incoming call'}</div>
            <div style={{ fontSize: '.84rem', fontWeight: 700, color: '#e8f4fb', letterSpacing: '-.01em', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{pendingIncomingCall.callerName}</div>
          </div>
          <div style={{ display: 'flex', gap: 7, flexShrink: 0 }}>
            <button onClick={() => {
              if (pendingIncomingCall.callType === 'team_room') {
                // Team Room invite — navigate to Team Room and join the video meeting
                const invRoom = pendingIncomingCall.roomUrl;
                const invName = pendingIncomingCall.roomName || 'team-call';
                setVideoRoomUrl(invRoom);
                setVideoRoomName(invName);
                setVideoActive(true);
                setVideoStartTime(new Date().toISOString());
                supabase.from('call_video_sessions').insert({
                  room_name: invName,
                  room_url: invRoom,
                  started_by: pendingIncomingCall.callerName || 'Team member',
                  caller_name: pendingIncomingCall.callerName || 'Team member',
                  with_name: me?.name || 'Admin',
                  session_type: 'video', status: 'active',
                  participants: [pendingIncomingCall.callerName, me?.name].filter(Boolean),
                }).select().single().then(({ data }) => { if (data) setVideoSessionId(data.id); });
                // Fetch meeting token for secure iframe join
                fetch('/api/meeting-token', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ room_name: invName, user_name: me?.name || 'Admin' }),
                }).then(r => r.json()).then(d => { if (d.token) setMeetingToken(d.token); }).catch(() => {});
                // Notify floating overlay
                window.dispatchEvent(new CustomEvent('sanoire:startcall', {
                  detail: { type: 'video', id: invName, name: 'Team Room', roomUrl: invRoom }
                }));
                window.dispatchEvent(new CustomEvent('sanoire:hideoverlay'));
                pick('calls', 'team-room');
                setPendingIncomingCall(null);
              } else {
                // DM / channel invite — existing behaviour
                const callStartedAt = new Date().toISOString();
                supabase.from('call_video_sessions').insert({
                  room_name: pendingIncomingCall.roomName || 'dm-call',
                  room_url: pendingIncomingCall.roomUrl,
                  started_by: pendingIncomingCall.callerName || 'Team member',
                  caller_name: pendingIncomingCall.callerName || 'Team member',
                  with_name: me?.name || 'Admin',
                  session_type: 'audio', status: 'active',
                  participants: [pendingIncomingCall.callerName, me?.name].filter(Boolean),
                }).select().single().then(({ data }) => { if (data) dmCallSessionRef.current = data.id; });
                setActiveDmCall({ roomUrl: pendingIncomingCall.roomUrl, memberInitials: pendingIncomingCall.callerInitials, memberName: pendingIncomingCall.callerName, _startedAt: callStartedAt });
                setCallElapsed(0);
                if (callTimerRef.current) clearInterval(callTimerRef.current);
                callTimerRef.current = setInterval(() => setCallElapsed(s => s + 1), 1000);
                pick('dm', pendingIncomingCall.callerInitials);
                setPendingIncomingCall(null);
              }
            }} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 16px', background: '#2da06a', color: '#fff', border: 'none', borderRadius: 99, cursor: 'pointer', fontSize: '.76rem', fontWeight: 700, fontFamily: F, flexShrink: 0, boxShadow: '0 1px 0 rgba(0,0,0,0.15) inset, 0 2px 10px rgba(45,160,106,0.4)' }} title='Accept'>
              <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><path d='M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .84h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.28a16 16 0 006.29 6.29l1.46-1.46a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 15.31z'/></svg>
              Accept
            </button>
            <button onClick={() => setPendingIncomingCall(null)} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 16px', background: '#c62828', color: '#fff', border: 'none', borderRadius: 99, cursor: 'pointer', fontSize: '.76rem', fontWeight: 700, fontFamily: F, flexShrink: 0, boxShadow: '0 1px 0 rgba(0,0,0,0.15) inset, 0 2px 8px rgba(198,40,40,0.35)' }} title='Decline'>
              <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round'><line x1='18' y1='6' x2='6' y2='18'/><line x1='6' y1='6' x2='18' y2='18'/></svg>
              Decline
            </button>
          </div>
        </div>
      )}

      {/* Thread side panel */}
      {activeThread && (() => { const orig = msgs.find(m => m.id === activeThread); if (!orig) return null; return (
        <div style={{ position: isMobile ? 'fixed' : 'absolute', top: 0, right: 0, bottom: 0, left: isMobile ? 0 : 'auto', width: isMobile ? '100%' : 300, background: t.panel, borderLeft: isMobile ? 'none' : '1px solid #e4edf3', display: 'flex', flexDirection: 'column', zIndex: isMobile ? 9990 : 20, boxShadow: isMobile ? '0 0 40px rgba(0,0,0,0.2)' : '-4px 0 20px rgba(49,79,92,0.08)', animation: 'threadSlideIn .18s ease' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '14px 16px', borderBottom: `1px solid ${t.bd}`, flexShrink: 0 }}>
            <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='#314F5C' strokeWidth='2' strokeLinecap='round'><path d='M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z'/></svg>
            <span style={{ fontSize: '.82rem', fontWeight: 700, color: '#0f1e28' }}>Thread</span>
            <span style={{ fontSize: '.7rem', color: '#9eb8c8' }}>· #{selected.id}</span>
            <button onClick={() => setActiveThread(null)} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', color: '#9eb8c8', fontSize: 18, lineHeight: 1, padding: '0 2px' }}>×</button>
          </div>
          <div style={{ flex: 1, overflowY: 'auto', padding: '12px 14px' }}>
            <div style={{ padding: '10px 12px', background: '#f8fafc', border: '1px solid #e4edf3', borderRadius: 10, marginBottom: 12 }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 7, marginBottom: 4 }}><span style={{ fontSize: '.76rem', fontWeight: 600, color: '#0f1e28' }}>{orig.name}</span><span style={{ fontSize: '.63rem', color: '#9eb8c8' }}>{orig.time}</span></div>
              <div style={{ fontSize: '.78rem', color: '#1a2e38', lineHeight: 1.6 }}>{orig.text}</div>
            </div>
            {(threadReplies[activeThread] || []).length > 0 && (<div style={{ height: 1, background: '#edf0f3', margin: '8px 0 12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><span style={{ fontSize: '.62rem', color: '#9eb8c8', background: t.panel, padding: '0 8px' }}>{(threadReplies[activeThread] || []).length} {(threadReplies[activeThread] || []).length === 1 ? 'reply' : 'replies'}</span></div>)}
            {(threadReplies[activeThread] || []).length === 0 && <div style={{ textAlign: 'center', padding: '16px 0', fontSize: '.72rem', color: '#9eb8c8' }}>No replies yet.</div>}
            {(threadReplies[activeThread] || []).map(r => {
              const t = teamMembers.find(m => m.initials === r.user_initials) || { initials: r.user_initials, name: r.user_name, color: '#6F8FA7', text: '#fff' };
              return (<div key={r.id} style={{ display: 'flex', gap: 8, marginBottom: 10, alignItems: 'flex-start' }}>
                <div style={{ width: 28, height: 28, borderRadius: 8, background: t.color, color: t.text, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.56rem', fontWeight: 700, flexShrink: 0 }}>{t.initials}</div>
                <div><div style={{ display: 'flex', gap: 7, marginBottom: 3 }}><span style={{ fontSize: '.76rem', fontWeight: 600, color: '#0f1e28' }}>{t.name}</span><span style={{ fontSize: '.63rem', color: '#9eb8c8' }}>{r.created_at ? new Date(r.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'just now'}</span></div><div style={{ fontSize: '.78rem', color: '#1a2e38', lineHeight: 1.55 }}>{r.text}</div></div>
              </div>);
            })}
          </div>
          <div style={{ padding: '8px 12px 14px', borderTop: `1px solid ${t.bd}`, flexShrink: 0 }}>
            <div style={{ background: '#f4f7f9', border: '1px solid #e4edf3', borderRadius: 10, display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px' }}>
              <input value={threadInput} onChange={e => setThreadInput(e.target.value)} onKeyDown={e => { e.stopPropagation(); if (e.key === 'Enter') { e.preventDefault(); sendThreadReply(); } }} placeholder='Reply in thread…' style={{ flex: 1, border: 'none', background: 'transparent', fontSize: '.78rem', color: '#0f1e28', outline: 'none', fontFamily: F }} />
              <button onClick={sendThreadReply} disabled={threadSending || !threadInput.trim()} style={{ width: 30, height: 30, borderRadius: 9, border: 'none', background: threadInput.trim() ? '#314F5C' : '#e4edf3', color: threadInput.trim() ? '#E0F5FC' : '#9eb8c8', cursor: threadInput.trim() ? 'pointer' : 'default', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'all .15s', boxShadow: threadInput.trim() ? '0 1px 0 rgba(0,0,0,0.15) inset, 0 2px 6px rgba(49,79,92,0.25)' : 'none' }}><svg width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><line x1='22' y1='2' x2='11' y2='13'/><polygon points='22 2 15 22 11 13 2 9 22 2'/></svg></button>
            </div>
          </div>
        </div>
      ); })()}
    </div>
  );
}

export default function Dispatch(props) {
  if (props && props.embed) return <DispatchBody session={props.session} />;
  return <ConsoleShell title="Dispatch"><DispatchBody session={props && props.session} /></ConsoleShell>;
}
